import { createContext, useContext, PureComponent, useRef, useEffect, useState, useCallback, Component, useDebugValue, Fragment as Fragment$1, createRef } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import cn from 'classnames';
import { MpdIcon, MpdColorSelector, SOLID_COLOR_LIST, MpdModal, generateColor, MpdPopover, MpdCard, MpdFilters, MpdCircleProgress, MpdInput, MpdSingleSelect, MpdLoader, MpdRadio, MpdCheckbox, MpdMultiSelect, MpdPhoneInput, MpdTextarea } from '@mapado/makeup';
import { List, Map as Map$1, OrderedMap, Set as Set$1 } from 'immutable';
import { CONTINGENT_AVAILABLE_ACTIONS, Contingent, SeatGroup, assertRelationIsDefined, COUPON_USAGE, assertRelationIsListOfObject, TicketPrice, TICKET_PRICE_TYPE_EXEMPTED, assertRelationIsNullOrObject, assertRelationIsObject, assertRelationIsString } from '@mapado/ticketing-js-sdk';
import { createI18nPack } from '@mapado/i18next-pack';
import { createPortal } from 'react-dom';
import Fuse from 'fuse.js';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import debounce from 'debounce';
import moment from 'moment';
import { buildUrl } from '@mapado/image-url-builder';
import { Field as Field$1, Form, FormSpy } from 'react-final-form';
import { HttpError } from 'rest-client-sdk';
import moment$1 from 'moment-timezone';

var DOMAIN_CONTEXT = /*#__PURE__*/function (DOMAIN_CONTEXT) {
  DOMAIN_CONTEXT["DESK"] = "desk";
  DOMAIN_CONTEXT["MINISITE"] = "minisite";
  return DOMAIN_CONTEXT;
}({});
var DomainContext = /*#__PURE__*/createContext(null);
DomainContext.displayName = 'DomainContext';
function useDomainContext() {
  var context = useContext(DomainContext);
  if (!context) {
    throw new Error("DomainContext should be defined. Did you add a the `DomainContext.Provider` up in the tree ?\n      See https://docs.mapado.net/js-component/?path=/story/contexts-domaincontext--page");
  }
  return context;
}

function _arrayLikeToArray$4(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles$1(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$4(r);
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper$1(t, o, e) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$1(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e));
}
function _classCallCheck$3(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$6(o.key), o);
  }
}
function _createClass$3(e, r, t) {
  return r && _defineProperties$2(e.prototype, r), t && _defineProperties$2(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _defineProperty$5(e, r, t) {
  return (r = _toPropertyKey$6(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf$1(t);
}
function _inherits$1(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf$1(t, e);
}
function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$1 = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit$1(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys$5(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(t), true).forEach(function (r) {
      _defineProperty$5(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn$1(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = false,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = true, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), true), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$1(t, e);
}
function _slicedToArray$1(r, e) {
  return _arrayWithHoles$1(r) || _iterableToArrayLimit$1(r, e) || _unsupportedIterableToArray$4(r, e) || _nonIterableRest$1();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$4(r) || _nonIterableSpread();
}
function _toPrimitive$6(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$6(t) {
  var i = _toPrimitive$6(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$7(o) {
  "@babel/helpers - typeof";

  return _typeof$7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$7(o);
}
function _unsupportedIterableToArray$4(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$4(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0;
  }
}

var FormBuilderInstance = /*#__PURE__*/function () {
  function FormBuilderInstance() {
    _classCallCheck$3(this, FormBuilderInstance);
  }
  return _createClass$3(FormBuilderInstance, null, [{
    key: "setFormBuilder",
    value: function setFormBuilder(formBuilder) {
      FormBuilderInstance.formBuilder = formBuilder;
    }
  }, {
    key: "getFormBuilder",
    value: function getFormBuilder() {
      if (!FormBuilderInstance.formBuilder) {
        throw new Error('FormBuilderInstance.setFormBuilder has not been called.');
      }
      return FormBuilderInstance.formBuilder;
    }
  }]);
}();

var MomentInstance = /*#__PURE__*/function () {
  function MomentInstance() {
    _classCallCheck$3(this, MomentInstance);
  }
  return _createClass$3(MomentInstance, null, [{
    key: "setMoment",
    value: function setMoment(moment) {
      MomentInstance.moment = moment;
    }
  }, {
    key: "getMoment",
    value: function getMoment() {
      return MomentInstance.moment;
    }
  }]);
}();
_defineProperty$5(MomentInstance, "moment", void 0);

var TicketingSdkContext = /*#__PURE__*/createContext(null);
TicketingSdkContext.displayName = 'TicketingSdkContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDisplayName$1(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function useTicketingSdkContext() {
  var context = useContext(TicketingSdkContext);
  if (!context) {
    throw new Error("TicketingSdkContext should be defined. Did you add a the `TicketingSdkContext.Provider` up in the tree ?\n      See https://docs.mapado.net/js-component/?path=/story/contexts-ticketingsdkcontext--page");
  }
  return context;
}
function withTicketingSdk(WrappedComponent) {
  function WithTicketingSdk(props) {
    var ticketingSdk = useTicketingSdkContext();

    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2({
      ticketingSdk: ticketingSdk
    }, props));
  }
  WithTicketingSdk.displayName = "withTicketingSdk(".concat(getDisplayName$1(WrappedComponent));
  return WithTicketingSdk;
}

/**
 * ## Usage
 *
 * ```js
 * import { BaseModal } from '@mapado/js-component';
 *
 * <BaseModal
 *   actions={
 *     <div>
 *       <button
 *         type="button"
 *         className="mbtn mbtn-white"
 *         onClick={action('click cancel button')}
 *       >
 *         Annuler
 *       </button>
 *
 *       <button
 *         type="button"
 *         className="mbtn mbtn-green"
 *         onClick={action('click confirm button')}
 *       >
 *         Confirmer
 *       </button>
 *     </div>
 *   }
 *   onCancel={action('onCancel')}
 *   title="Titre de la modale"
 *   subtitle="Sous-titre de la modale"
 * >
 *   <div className="txtcenter">Corps de la modale</div>
 * </BaseModal>;
 * ```
 *
 * ### Form
 *
 * If your modal is a form, you may want to use the `isForm` and `onSubmit` attributes.
 *
 * If you do, your call-to-action button, should not contain an `onClick` callback but should be of type `<button type="submit">`.
 *
 * ❗Don't forget to call `event.preventDefaut()` in your callback, or the form will redirect to the form default `action`, which is probably not what you want. ❗
 *
 * #### Example
 *
 * ```js
 * import { BaseModal } from '@mapado/js-component';
 *
 * <BaseModal
 *   isForm
 *   onSubmit={(e) => {
 *     e.preventDefault();
 *     console.log('form has been submitted', e);
 *   }}
 *   actions={
 *     <button type="submit" className="mbtn mbtn-green">
 *       Submit form
 *     </button>
 *   }
 *   onCancel={action('onCancel')}
 *   title="Titre de la modale"
 * >
 *   <div className="txtcenter">Corps de la modale</div>
 * </BaseModal>;
 * ```
 * @deprecated use MpdModal from makeup v9.1.0 instead (see this repo changelog for migration tips)
 */
var BaseModal = /*#__PURE__*/function (_PureComponent) {
  function BaseModal(props) {
    var _this;
    _classCallCheck$3(this, BaseModal);
    _this = _callSuper$1(this, BaseModal, [props]);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.handleModalClicked = _this.handleModalClicked.bind(_this);
    var isModalOpened = document.body.getAttribute('ismodalopened');
    if (!isModalOpened) {
      document.body.setAttribute('ismodalopened', 'true');
    }
    _this.state = {
      isMainModal: !isModalOpened,
      initialPosition: document.body.style.position || '',
      initialTop: document.body.style.top || '',
      initialLeft: document.body.style.left || '',
      initialWidth: document.body.style.width || ''
    };
    return _this;
  }
  _inherits$1(BaseModal, _PureComponent);
  return _createClass$3(BaseModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isMainModal = this.state.isMainModal;
      document.addEventListener('keydown', this.handleKeydown);
      if (isMainModal) {
        document.body.setAttribute('ismodalopened', 'true');

        // When the modal is shown, we want a fixed body
        // Taken from https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
        var _window = window,
          scrollY = _window.scrollY; // save value before setting position to fixed

        document.body.style.position = 'fixed';
        document.body.style.top = "-".concat(scrollY, "px");
        document.body.style.left = '0';
        document.body.style.width = '100%';
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state = this.state,
        initialPosition = _this$state.initialPosition,
        initialTop = _this$state.initialTop,
        initialLeft = _this$state.initialLeft,
        initialWidth = _this$state.initialWidth,
        isMainModal = _this$state.isMainModal;
      document.removeEventListener('keydown', this.handleKeydown);
      if (isMainModal) {
        // we are on the main submodal, so we need to reset the default position
        document.body.removeAttribute('ismodalopened');
        var scrollY = document.body.style.top;
        document.body.style.position = initialPosition;
        document.body.style.top = initialTop;
        document.body.style.left = initialLeft;
        document.body.style.width = initialWidth;
        // eslint-disable-next-line radix
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.key === 'Escape') {
        // eslint-disable-next-line react/destructuring-assignment
        this.props.onCancel();
      }
    }
  }, {
    key: "handleModalClicked",
    value: function handleModalClicked(evt) {
      // prevent background `handleBackgroundClicked` to be called
      evt.stopPropagation();
    }
  }, {
    key: "handleClose",
    value: function handleClose(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      // eslint-disable-next-line react/destructuring-assignment
      this.props.onCancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        actions = _this$props.actions,
        children = _this$props.children,
        onCancel = _this$props.onCancel,
        onPrevious = _this$props.onPrevious,
        onPreviousText = _this$props.onPreviousText,
        subtitle = _this$props.subtitle,
        title = _this$props.title,
        zIndexDelta = _this$props.zIndexDelta,
        isForm = _this$props.isForm,
        noValidate = _this$props.noValidate,
        onSubmit = _this$props.onSubmit,
        maxWidth = _this$props.maxWidth,
        contentHeight = _this$props.contentHeight,
        modalHeight = _this$props.modalHeight;
      var modalSizeStyle = {
        maxWidth: maxWidth,
        height: modalHeight
      };
      var displayHeader = title || subtitle || onCancel;
      var MainTag = isForm ? 'form' : 'div';
      var mainTagProps = {
        className: cn('base-modal', className)
      };
      var blockInnerClassNames = cn('base-modal__block base-modal__block--inner', contentHeight && 'base-modal__block--with-contentHeight');
      if (isForm) {
        mainTagProps.onSubmit = onSubmit;
        if (noValidate) {
          // @ts-expect-error noValidate is not a valid attribute for div, but it is for form, and we are sure that MainTag is a form since isForm is true
          mainTagProps.noValidate = noValidate;
        }
      }
      return (
        /*#__PURE__*/
        // @ts-expect-error MainTag can be either a form or a div, and the props are correctly typed, but typescript is not able to infer it
        // eslint-disable-next-line react/jsx-props-no-spreading
        jsxs(MainTag, _objectSpread2(_objectSpread2({}, mainTagProps), {}, {
          children: [/*#__PURE__*/jsx("div", {
            className: "base-modal__modal-bg",
            style: {
              zIndex: 1042 + (zIndexDelta !== null && zIndexDelta !== void 0 ? zIndexDelta : 0)
            }
          }), /*#__PURE__*/jsx("div", {
            className: "base-modal__modal-wrap",
            style: {
              zIndex: 1045 + (zIndexDelta !== null && zIndexDelta !== void 0 ? zIndexDelta : 0)
            },
            children: /*#__PURE__*/jsx("div", {
              className: "base-modal__modal-wrap__modal-container",
              children: /*#__PURE__*/jsxs("div", {
                className: "base-modal__modal-wrap__modal-container__modal-elt",
                onMouseDown: this.handleModalClicked,
                style: modalSizeStyle,
                children: [displayHeader && /*#__PURE__*/jsxs("div", {
                  className: "base-modal__block base-modal__block--header",
                  children: [onPrevious && /*#__PURE__*/jsxs("button", {
                    className: "base-modal__modal-wrap__modal-container__modal-elt__previous",
                    title: "Previous",
                    onClick: onPrevious,
                    type: "button",
                    children: [/*#__PURE__*/jsx(MpdIcon, {
                      icon: "arrow-left",
                      height: "24",
                      width: "24"
                    }), onPreviousText && /*#__PURE__*/jsx("span", {
                      className: "small base-modal__previous-text",
                      children: onPreviousText
                    })]
                  }), /*#__PURE__*/jsx("button", {
                    type: "button",
                    className: "base-modal__modal-wrap__modal-container__modal-elt__close",
                    title: "Close (Esc)",
                    onClick: this.handleClose,
                    children: /*#__PURE__*/jsx(MpdIcon, {
                      icon: "cross",
                      height: "24",
                      width: "24"
                    })
                  }), /*#__PURE__*/jsxs("div", {
                    className: "base-modal__block--content",
                    children: [/*#__PURE__*/jsx("h2", {
                      className: "base-modal__block--title",
                      children: title
                    }), !!subtitle && /*#__PURE__*/jsx("div", {
                      className: "base-modal__block--subtitle",
                      children: subtitle
                    })]
                  })]
                }), /*#__PURE__*/jsx("div", {
                  className: blockInnerClassNames,
                  style: contentHeight ? {
                    maxHeight: contentHeight
                  } : undefined,
                  children: /*#__PURE__*/jsx("div", {
                    className: "base-modal__block--content",
                    children: children
                  })
                }), actions && /*#__PURE__*/jsx("div", {
                  className: "base-modal__block base-modal__block--footer",
                  children: /*#__PURE__*/jsx("div", {
                    className: "base-modal__block--content txtcenter",
                    children: actions
                  })
                })]
              })
            })
          })]
        }))
      );
    }
  }]);
}(PureComponent);
_defineProperty$5(BaseModal, "defaultProps", {
  className: '',
  actions: null,
  zIndexDelta: 999999,
  // top of slidebox
  subtitle: '',
  maxWidth: '800px',
  modalHeight: 'auto',
  contentHeight: null,
  onPrevious: null,
  onPreviousText: '',
  isForm: false,
  onSubmit: null,
  noValidate: undefined
});

// declare your configuration
var projectName = 'js-component';
var namespaceList = ['messages'];
var defaultNamespace = 'messages';
var languageList = ['fr', 'en', 'de'];
var defaultLanguage = 'fr';

// This function load the local JSON files in case the translation server is down
// We need to keep the full path name and do not use template strings as rollup wont resolve path
function backendLoader(language, namespace) {
  if (namespace !== 'messages') {
    throw new Error('Namespace must be "messages"');
  }
  switch (language) {
    case 'fr':
      return import('./messages-DYe90ug4.js');
    case 'en':
      return import('./messages-BtP3fsGe.js');
    case 'de':
      return import('./messages-BiRNZljV.js');
    default:
      return Promise.reject(new Error("Do not handle locale ".concat(language)));
  }
}
var _createI18nPack = createI18nPack(projectName, namespaceList, defaultNamespace, languageList, defaultLanguage, backendLoader),
  i18n = _createI18nPack.i18n,
  useTranslation = _createI18nPack.useTranslation;

var isContingent = function isContingent(item) {
  return item instanceof Contingent;
};
var isSeatGroup = function isSeatGroup(item) {
  return item instanceof SeatGroup;
};
function ColoredItemAdminRow(_ref) {
  var _item$name, _item$label;
  var item = _ref.item,
    _onChange = _ref.onChange,
    onDelete = _ref.onDelete,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$isNew = _ref.isNew,
    isNew = _ref$isNew === void 0 ? false : _ref$isNew,
    _ref$isDeleted = _ref.isDeleted,
    isDeleted = _ref$isDeleted === void 0 ? false : _ref$isDeleted;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var nameRef = useRef(null);
  useEffect(function () {
    if (autoFocus && nameRef.current) {
      nameRef.current.focus();
    }
  }, [nameRef, autoFocus]);
  return /*#__PURE__*/jsxs("div", {
    className: cn({
      'ColoredItemAdminRow--deleted': isDeleted
    }),
    children: [/*#__PURE__*/jsx("label", {
      htmlFor: "name",
      className: "help small required",
      children: !isNew ? t('colored_item.form.name_field') : t('colored_item.form.new_name_field')
    }), /*#__PURE__*/jsxs("div", {
      className: "flex-row mb3",
      children: [isContingent(item) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("input", {
          ref: nameRef,
          type: "text",
          id: "name",
          className: "form-control mr3",
          value: (_item$name = item.name) !== null && _item$name !== void 0 ? _item$name : '',
          disabled: !item.isActionAvailable(CONTINGENT_AVAILABLE_ACTIONS.RENAME)
          // @ts-expect-error This is a valid type
          ,
          onChange: function onChange(e) {
            return _onChange(item.set('name', e.target.value));
          },
          required: true
        }), /*#__PURE__*/jsx(MpdColorSelector, {
          colorList: SOLID_COLOR_LIST
          // @ts-expect-error This is a valid type
          ,
          onChange: function onChange(color) {
            return _onChange(item.set('color', color));
          },
          selectedColor: item.color
        })]
      }), isSeatGroup(item) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("input", {
          ref: nameRef,
          type: "text",
          id: "name",
          className: "form-control mr3",
          value: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : ''
          // @ts-expect-error This is a valid type
          ,
          onChange: function onChange(e) {
            return _onChange(item.set('label', e.target.value));
          },
          required: true
        }), /*#__PURE__*/jsx(MpdColorSelector, {
          colorList: SOLID_COLOR_LIST
          // @ts-expect-error This is a valid type
          ,
          onChange: function onChange(color) {
            return _onChange(item.set('seatColor', color));
          },
          selectedColor: item.seatColor
        })]
      }), /*#__PURE__*/jsx("button", {
        type: "button",
        disabled: isDeleted || isContingent(item) && !item.isActionAvailable(CONTINGENT_AVAILABLE_ACTIONS.DELETE),
        className: "mpd-btn mpd-btn--icon-only ml3",
        onClick: function onClick(e) {
          e.preventDefault();
          if (onDelete) {
            onDelete();
          }
        },
        children: /*#__PURE__*/jsx(MpdIcon, {
          icon: "cross",
          width: "18"
        })
      })]
    })]
  });
}

function DeletedMessage(_ref) {
  var _item$name;
  var item = _ref.item,
    _onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsxs("div", {
    className: "help small mb1",
    children: [t('colored_item.admin.deleted', {
      name: (_item$name = item.name) !== null && _item$name !== void 0 ? _item$name : item.label
    }), ' ', /*#__PURE__*/jsx("a", {
      className: "ml1",
      href: "#undelete",
      onClick: function onClick(e) {
        e.preventDefault();
        _onClick();
      },
      children: t('cancel')
    })]
  });
}

var CONTINGENT = 'CONTINGENT';
var SEAT_GROUP = 'SEAT_GROUP';
var CONTINGENT_API_DATA = {
  fields: ['@id', 'name', 'color'],
  getRepository: function getRepository(ticketingSdk) {
    return ticketingSdk.getRepository('contingent');
  }
};
var SEAT_GROUP_API_DATA = {
  fields: ['@id', 'label', 'seatColor'],
  getRepository: function getRepository(ticketingSdk) {
    return ticketingSdk.getRepository('seatGroup');
  }
};

function ColoredItemAdminModal(_ref) {
  var contractId = _ref.contractId,
    dataType = _ref.dataType,
    coloredItemList = _ref.coloredItemList,
    onChange = _ref.onChange,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ticketingSdk = useTicketingSdkContext();
  var _useState = useState(List()),
    _useState2 = _slicedToArray$1(_useState, 2),
    newList = _useState2[0],
    setNewList = _useState2[1];
  var _useState3 = useState(List()),
    _useState4 = _slicedToArray$1(_useState3, 2),
    listToUpdate = _useState4[0],
    setListToUpdate = _useState4[1];
  var _useState5 = useState(List()),
    _useState6 = _slicedToArray$1(_useState5, 2),
    listToDelete = _useState6[0],
    setListToDelete = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray$1(_useState7, 2),
    isSubmitting = _useState8[0],
    setIsSubmitting = _useState8[1];
  var updatedList = coloredItemList.map(function (item) {
    assertRelationIsDefined(item['@id'], 'item.@id');
    var updatedItem = listToUpdate.find(function (listItem) {
      return listItem['@id'] === item['@id'];
    });
    return updatedItem || item;
  });
  var addNew = function addNew() {
    var color = generateColor(Math.floor(Math.random() * 13) + 1);
    if (dataType === CONTINGENT) {
      var newContingent = new Contingent({
        '@id': "/v1/contingents/".concat(Date.now()),
        '@type': 'Contingent',
        name: '',
        color: color
      });

      // @ts-expect-error if dataType is CONTINGENT, then newList is a list of contingent
      setNewList(newList.unshift(newContingent));
    } else if (dataType === SEAT_GROUP) {
      var newSeatGroup = new SeatGroup({
        '@id': "/v1/seat_groups/".concat(Date.now()),
        '@type': 'SeatGroup',
        label: '',
        seatColor: color
      });

      // @ts-expect-error if dataType is SEAT_GROUP, then newList is a list of seatGroup
      setNewList(newList.unshift(newSeatGroup));
    } else {
      throw new Error('Unknown data type');
    }
  };
  var canSubmit = (listToUpdate.size > 0 || newList.size > 0 || listToDelete.size > 0) && listToUpdate.every(function (updatedItem) {
    return updatedItem.name !== '' && updatedItem.label !== '';
  }) && newList.every(function (newItem) {
    return newItem.name !== '' && newItem.label !== '';
  });
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var repository, fields, updatePromiseList, newPromiseList, deletedPromiseList;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (canSubmit) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsSubmitting(true);
            repository = dataType === CONTINGENT ? CONTINGENT_API_DATA.getRepository(ticketingSdk) : SEAT_GROUP_API_DATA.getRepository(ticketingSdk);
            fields = dataType === CONTINGENT ? CONTINGENT_API_DATA.fields : SEAT_GROUP_API_DATA.fields;
            updatePromiseList = listToUpdate.map(function (updatedItem) {
              // @ts-expect-error we have a proper entity, linked to the proper repository
              return repository.update(updatedItem, {
                fields: fields
              });
            });
            newPromiseList = newList.map(function (newItem) {
              // @ts-expect-error, both datatype need @id and contract, all good
              var item = newItem.set('@id', null).set('contract', contractId);
              if (dataType === SEAT_GROUP) {
                item = item.set('seatConfig', null);
              }
              return repository.create(item, {
                fields: fields
              });
            });
            deletedPromiseList = listToDelete.map(function (deletedItem) {
              if ('hide' in repository && typeof repository.hide === 'function') {
                return repository.hide(deletedItem);
              }
              throw new Error('Hide is not supported for this entity');
            });
            _context.n = 2;
            return Promise.all(updatePromiseList.concat(newPromiseList).concat(deletedPromiseList)).then(function (results) {
              // Update newList with real @id from the results
              var newListWithIds = results.slice(updatePromiseList.size, updatePromiseList.size + newList.size);
              onChange(listToUpdate, List(newListWithIds), listToDelete);
              setIsSubmitting(false);
            }).catch(function (error) {
              // eslint-disable-next-line no-console
              console.error(error);
              setIsSubmitting(false);
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/jsxs(MpdModal, {
    onCancel: onCancel,
    title: t('colored_item.admin.title', {
      dataType: dataType
    }),
    primaryButtonProps: {
      isLoading: isSubmitting,
      isDisabled: !canSubmit || isSubmitting,
      label: t('submit'),
      onClick: onSubmit
    },
    secondaryButtonProps: {
      onClick: onCancel
    },
    children: [/*#__PURE__*/jsxs("button", {
      type: "button",
      onClick: function onClick() {
        return addNew();
      },
      className: "mpd-btn mpd-btn--no-border mpd-btn--tertiary mb3",
      children: [/*#__PURE__*/jsx(MpdIcon, {
        icon: "plus"
      }), dataType === CONTINGENT ? t('contingent.new') : t('seat_group.new')]
    }), /*#__PURE__*/jsxs("div", {
      children: [newList.map(function (item, index) {
        return /*#__PURE__*/jsx(ColoredItemAdminRow, {
          isNew: true,
          autoFocus: true,
          item: item,
          onChange: function onChange(newUpdated) {
            setNewList(newList.set(index, newUpdated));
          },
          onDelete: function onDelete() {
            setNewList(newList.delete(index));
          }
        }, item['@id']);
      }), updatedList.map(function (item) {
        return /*#__PURE__*/jsxs(Fragment, {
          children: [listToDelete.includes(item) && /*#__PURE__*/jsx(DeletedMessage, {
            item: item,
            onClick: function onClick() {
              return setListToDelete(function (prev) {
                return prev.filter(function (itemToDelete) {
                  return itemToDelete['@id'] !== item['@id'];
                });
              });
            }
          }), /*#__PURE__*/jsx(ColoredItemAdminRow, {
            item: item,
            isDeleted: listToDelete.includes(item),
            onChange: function onChange(updatedItem) {
              var indexToUpdate = listToUpdate.findIndex(function (listItem) {
                return listItem['@id'] === updatedItem['@id'];
              });

              // if item not in listToUpdate, add it
              if (indexToUpdate === -1) {
                return setListToUpdate(listToUpdate.push(updatedItem));
              }

              // if item previously updated, update it
              return setListToUpdate(listToUpdate.set(indexToUpdate, updatedItem));
            },
            onDelete: function onDelete() {
              if (dataType === CONTINGENT || dataType === SEAT_GROUP) {
                setListToDelete(function (prev) {
                  return prev.push(item);
                });
              }
            }
          }, item['@id'])]
        });
      })]
    }), listToUpdate.size > 0 && /*#__PURE__*/jsx("div", {
      className: "help small",
      children: t('colored_item.admin.updated_nb', {
        count: listToUpdate.size
      })
    }), newList.size > 0 && /*#__PURE__*/jsx("div", {
      className: "help small",
      children: t('colored_item.admin.new_nb', {
        count: newList.size
      })
    })]
  });
}

function getModalRoot() {
  var modalRoot = document.getElementById('modal-root');
  if (!modalRoot) {
    throw new Error('modal-root element not found. Did you create a div with an id "modal-root" in your DOM ?');
  }
  return modalRoot;
}

/**
 * Helper that render a modal in the right DOM event without having to manage the modal-root manually.
 */
function createModalPortal(children, key) {
  return /*#__PURE__*/createPortal(children, getModalRoot(), key);
}

// Auto-generated file. Edit "src/breakpoints.js" to change values
var $primaryBlue = '#00859c';

function ContingentRow(_ref) {
  var _contingent$color, _contingent$name;
  var contingent = _ref.contingent,
    onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    _ref$hasDefaultStyle = _ref.hasDefaultStyle,
    hasDefaultStyle = _ref$hasDefaultStyle === void 0 ? true : _ref$hasDefaultStyle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsxs("div", {
    className: cn('flex-row', hasDefaultStyle && 'contingent-selector__row'),
    onClick: onClick,
    onKeyDown: onClick,
    tabIndex: tabIndex,
    role: "button",
    children: [/*#__PURE__*/jsx(MpdIcon, {
      icon: "seat-filled",
      color: (_contingent$color = contingent === null || contingent === void 0 ? void 0 : contingent.color) !== null && _contingent$color !== void 0 ? _contingent$color : $primaryBlue,
      width: "12",
      className: "mr2"
    }), (_contingent$name = contingent === null || contingent === void 0 ? void 0 : contingent.name) !== null && _contingent$name !== void 0 ? _contingent$name : t('contingent.selector.none')]
  });
}

var CONTINGENTS_FIELDS = ['@id', 'name', 'color', {
  availableActions: [CONTINGENT_AVAILABLE_ACTIONS.RENAME, CONTINGENT_AVAILABLE_ACTIONS.DELETE, CONTINGENT_AVAILABLE_ACTIONS.SELL_TICKETS]
}];
function useFetchContingentList(contractId) {
  var ticketingSdk = useTicketingSdkContext();
  var _useState = useState(null),
    _useState2 = _slicedToArray$1(_useState, 2),
    contingentList = _useState2[0],
    setContingentList = _useState2[1];
  var fetchContingentList = useCallback(function () {
    ticketingSdk.getRepository('contingent').findBy({
      itemsPerPage: 999,
      contract: contractId,
      'order[name]': 'ASC'
    }, CONTINGENTS_FIELDS).then(function (contingentResult) {
      setContingentList(contingentResult.getMembers());
    });
  }, [contractId, ticketingSdk]);
  return {
    contingentList: contingentList,
    fetchContingentList: fetchContingentList
  };
}
function ContingentSelector(_ref) {
  var contractId = _ref.contractId,
    onChange = _ref.onChange,
    onSubmitAdminModal = _ref.onSubmitAdminModal,
    label = _ref.label,
    isContingentHidden = _ref.isContingentHidden,
    _ref$labelClassName = _ref.labelClassName,
    labelClassName = _ref$labelClassName === void 0 ? 'ml2 bold' : _ref$labelClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'contingent-selector' : _ref$className,
    icon = _ref.icon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchContingentLi = useFetchContingentList(contractId),
    contingentList = _useFetchContingentLi.contingentList,
    fetchContingentList = _useFetchContingentLi.fetchContingentList;
  useEffect(function () {
    fetchContingentList();
  }, [fetchContingentList]);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    isOpenedContingentAdminModal = _useState4[0],
    setIsOpenedContingentAdminModal = _useState4[1];
  var submitContingentLists = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(updatedContingentList, newContingentList, deletedContingentList) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsOpenedContingentAdminModal(false);
            fetchContingentList();
            if (onSubmitAdminModal) {
              onSubmitAdminModal(updatedContingentList, newContingentList, deletedContingentList);
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function submitContingentLists(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var iconProps = icon ? {
    icon: icon
  } : {
    noIcon: true
  };
  var filteredContingentList = contingentList === null || contingentList === void 0 ? void 0 : contingentList.filter(function (contingent) {
    if (typeof isContingentHidden === 'function') {
      return !isContingentHidden(contingent);
    }
    return true;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(MpdPopover, _objectSpread2(_objectSpread2({
      action: /*#__PURE__*/jsx("button", {
        type: "button",
        className: "mpd-btn mpd-btn--secondary",
        onClick: function onClick() {
          return setIsOpenedContingentAdminModal(true);
        },
        children: t('contingent.selector.title')
      }),
      label: label,
      labelClassName: labelClassName,
      className: className,
      disabled: !contingentList
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, iconProps), {}, {
      children: /*#__PURE__*/jsxs("div", {
        className: "contingent-selector__container",
        children: [filteredContingentList && filteredContingentList.size === 0 && /*#__PURE__*/jsx("span", {
          children: t('no_contingent')
        }), filteredContingentList && filteredContingentList.map(function (contingent, tabIndex) {
          return /*#__PURE__*/jsx(ContingentRow, {
            contingent: contingent,
            onClick: function onClick() {
              return onChange(contingent);
            },
            tabIndex: tabIndex
          }, contingent.get('@id'));
        })]
      })
    })), isOpenedContingentAdminModal && contingentList && createModalPortal(/*#__PURE__*/jsx(ColoredItemAdminModal, {
      contractId: contractId,
      dataType: CONTINGENT,
      coloredItemList: contingentList,
      onCancel: function onCancel() {
        return setIsOpenedContingentAdminModal(false);
      },
      onChange: function onChange(updatedContingentList, newContingentList, deletedContingentList) {
        submitContingentLists(updatedContingentList, newContingentList, deletedContingentList);
      }
    }))]
  });
}

function CouponAppliedLabel(_ref) {
  var _coupon$creatingOffer;
  var coupon = _ref.coupon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isCashCoupon = coupon.usage === COUPON_USAGE.CASH;
  var offerName = (_coupon$creatingOffer = coupon.creatingOfferRule) !== null && _coupon$creatingOffer !== void 0 && _coupon$creatingOffer.title ? "(".concat(coupon.creatingOfferRule.title, ")") : '';
  return /*#__PURE__*/jsx("strong", {
    children: isCashCoupon ? t('order.detail.applied_cash_coupon_title', {
      code: coupon.code,
      offerName: offerName
    }) : t('order.detail.applied_offer_coupon_title', {
      code: coupon.code,
      offerName: offerName
    })
  });
}

function CouponApplied(_ref) {
  var coupon = _ref.coupon,
    actions = _ref.actions;
  return /*#__PURE__*/jsxs("div", {
    className: "CouponApplied__Main ml2 mt1 p2",
    children: [/*#__PURE__*/jsx(CouponAppliedLabel, {
      coupon: coupon
    }), actions]
  });
}

function CouponOfferColorBorder(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'pink' : _ref$color;
  return /*#__PURE__*/jsx("div", {
    className: "CouponOfferColorBorder gradiant-background-color-".concat(color, "-vertical")
  });
}

var DATE_OPTIONS_NO_YEAR = {
  weekday: 'long',
  month: 'long',
  day: 'numeric'
};
var SHORT_DATE_OPTIONS_NO_YEAR = {
  month: '2-digit',
  day: 'numeric'
};
var DATE_OPTIONS_WITH_YEAR = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
var DATE_OPTIONS_WITH_YEAR_AND_SHORT_MONTH = {
  weekday: 'long',
  year: 'numeric',
  month: 'short',
  day: 'numeric'
};
var SHORT_DATE_OPTIONS_WITH_YEAR = {
  year: 'numeric',
  month: '2-digit',
  day: 'numeric'
};
var TIME_OPTIONS = {
  hour: '2-digit',
  minute: '2-digit'
};
function formatDate(momentDate) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var d = momentDate;
  // copy options as the timezone will be changed later
  var innerOptions = _objectSpread2({}, options);
  if (!(innerOptions !== null && innerOptions !== void 0 && innerOptions.timeZone)) {
    var _d;
    var timezone = (_d = d) === null || _d === void 0 ? void 0 : _d.tz();
    if (timezone) {
      innerOptions.timeZone = timezone;
    } else {
      // If the timezone is not specified, we need to handle it in UTC in order for `toLocaleDateString` to NOT use the user timezone
      d = d.clone().add(d.utcOffset(), 'minutes');
      innerOptions.timeZone = 'UTC';
    }
  }
  return d.toDate().toLocaleDateString(d.locale(), innerOptions);
}
function formatTime(momentDate) {
  var d = momentDate;
  var options = _objectSpread2({}, TIME_OPTIONS);
  if (!options.timeZone) {
    var _d2;
    var timezone = (_d2 = d) === null || _d2 === void 0 ? void 0 : _d2.tz();
    if (timezone) {
      options.timeZone = timezone;
    } else {
      // If the timezone is not specified, we need to handle it in UTC in order for `toLocaleDateString` to NOT use the user timezone
      d = d.clone().add(d.utcOffset(), 'minutes');
      options.timeZone = 'UTC';
    }
  }
  return d.toDate().toLocaleTimeString(d.locale(), options);
}
var FORMATTED_DATE_FORMAT = /*#__PURE__*/function (FORMATTED_DATE_FORMAT) {
  FORMATTED_DATE_FORMAT["LONG"] = "long";
  FORMATTED_DATE_FORMAT["SHORT"] = "short";
  FORMATTED_DATE_FORMAT["LONG_WITH_YEAR"] = "long_with_year";
  FORMATTED_DATE_FORMAT["LONG_WITH_YEAR_AND_SHORT_MONTH"] = "long_with_year_and_short_month";
  FORMATTED_DATE_FORMAT["SHORT_WITH_YEAR"] = "short_with_year";
  FORMATTED_DATE_FORMAT["TIME"] = "time";
  return FORMATTED_DATE_FORMAT;
}({});

/**
 * @deprecated Use `<FormattedDateForStartAndEndDate />` component instead
 */
function getFormattedDateForStartAndEndDate(localStartDate, localEndDate) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FORMATTED_DATE_FORMAT.LONG;
  var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var i18nInstance = t ? {
    t: t
  } : i18n;
  if (!localStartDate) {
    return i18nInstance.t('dashboard.ticketing.ticketing_without_start_date');
  }
  var noYearDateOptions;
  var withYearDateOptions;
  switch (format) {
    case FORMATTED_DATE_FORMAT.LONG:
      noYearDateOptions = _objectSpread2({}, DATE_OPTIONS_NO_YEAR);
      withYearDateOptions = _objectSpread2({}, DATE_OPTIONS_WITH_YEAR);
      break;
    case FORMATTED_DATE_FORMAT.LONG_WITH_YEAR:
      noYearDateOptions = _objectSpread2({}, DATE_OPTIONS_WITH_YEAR);
      withYearDateOptions = _objectSpread2({}, DATE_OPTIONS_WITH_YEAR);
      break;
    case FORMATTED_DATE_FORMAT.LONG_WITH_YEAR_AND_SHORT_MONTH:
      noYearDateOptions = _objectSpread2({}, DATE_OPTIONS_WITH_YEAR_AND_SHORT_MONTH);
      withYearDateOptions = _objectSpread2({}, DATE_OPTIONS_WITH_YEAR_AND_SHORT_MONTH);
      break;
    case FORMATTED_DATE_FORMAT.SHORT_WITH_YEAR:
      noYearDateOptions = _objectSpread2({}, SHORT_DATE_OPTIONS_WITH_YEAR);
      withYearDateOptions = _objectSpread2({}, SHORT_DATE_OPTIONS_WITH_YEAR);
      break;
    case FORMATTED_DATE_FORMAT.TIME:
      return i18nInstance.t('ticketing.event.date_hours', {
        startHour: formatTime(localStartDate),
        endHour: localEndDate ? formatTime(localEndDate) : 0
      });
    case FORMATTED_DATE_FORMAT.SHORT:
    default:
      noYearDateOptions = _objectSpread2({}, SHORT_DATE_OPTIONS_NO_YEAR);
      withYearDateOptions = _objectSpread2({}, SHORT_DATE_OPTIONS_WITH_YEAR);
      break;
  }
  if (localEndDate) {
    if (localEndDate.format('DDMMYYYY') === localStartDate.format('DDMMYYYY')) {
      return i18nInstance.t('ticketing.event.date_end_same_say', {
        startDate: formatDate(localStartDate, noYearDateOptions),
        startHour: formatTime(localStartDate),
        endHour: formatTime(localEndDate)
      });
    }
    if (localEndDate.year() === localStartDate.year()) {
      return i18nInstance.t('ticketing.event.date_multiple_days', {
        startDate: formatDate(localStartDate, noYearDateOptions),
        endDate: formatDate(localEndDate, noYearDateOptions),
        startHour: formatTime(localStartDate),
        endHour: formatTime(localEndDate)
      });
    }
    return i18nInstance.t('ticketing.event.date_multiple_days', {
      startDate: formatDate(localStartDate, withYearDateOptions),
      endDate: formatDate(localEndDate, withYearDateOptions),
      startHour: formatTime(localStartDate),
      endHour: formatTime(localEndDate)
    });
  }
  return i18nInstance.t('ticketing.event.date_no_end', {
    startDate: formatDate(localStartDate, noYearDateOptions),
    startHour: formatTime(localStartDate)
  });
}

/** @deprecated to move in desk */
function compareMomentDates(dateA, dateB) {
  if (!dateA && !dateB) {
    return 0;
  }
  if (!dateA && dateB) {
    return 1;
  }
  if (dateA && !dateB) {
    return -1;
  }
  if (dateA.isBefore(dateB)) {
    return -1;
  }
  if (dateA.isAfter(dateB)) {
    return 1;
  }
  return 0;
}

function CouponOfferStatusRowContent(_ref) {
  var _customerStatusList$m;
  var coupon = _ref.coupon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var customerStatusList = coupon.customerStatusList,
    code = coupon.code,
    validUntil = coupon.validUntil;
  var isOfferCustomerStatusCoupon = customerStatusList && customerStatusList.size > 0;
  if (!isOfferCustomerStatusCoupon) {
    return null;
  }
  var statuses = (_customerStatusList$m = customerStatusList.map(function (_ref2) {
    var label = _ref2.label;
    return label;
  })) === null || _customerStatusList$m === void 0 ? void 0 : _customerStatusList$m.join(', ');
  var hasBeenCreated = !!coupon.get('creatingOrder');
  return /*#__PURE__*/jsxs("div", {
    className: "mr3",
    children: [/*#__PURE__*/jsx("strong", {
      children: hasBeenCreated ? t('coupon_row.coupon_offer_status.title', {
        count: customerStatusList.size,
        status: statuses
      }) : t('cart.coupon_row.coupon_offer_status.title', {
        count: customerStatusList.size,
        status: statuses
      })
    }), /*#__PURE__*/jsxs("div", {
      children: [hasBeenCreated && /*#__PURE__*/jsx("span", {
        className: "CouponOffer__Code bold large",
        children: code
      }), ' ', validUntil && /*#__PURE__*/jsx("span", {
        className: "small mpd-color-gray",
        children: t('crm.valid_until', {
          date: formatDate(validUntil)
        })
      })]
    })]
  });
}

function CouponOfferStatusRow(_ref) {
  var coupon = _ref.coupon,
    actions = _ref.actions;
  var customerStatusList = coupon.customerStatusList,
    creatingOfferRule = coupon.creatingOfferRule;
  var isOfferCustomerStatusCoupon = customerStatusList && customerStatusList.size > 0;
  if (!isOfferCustomerStatusCoupon) {
    return null;
  }
  return /*#__PURE__*/jsxs(MpdCard, {
    className: "mb2",
    children: [/*#__PURE__*/jsx(CouponOfferColorBorder, {
      color: creatingOfferRule === null || creatingOfferRule === void 0 ? void 0 : creatingOfferRule.color
    }), /*#__PURE__*/jsxs("div", {
      className: "CouponOffer__Content p3 ml2",
      children: [/*#__PURE__*/jsx(CouponOfferStatusRowContent, {
        coupon: coupon
      }), actions]
    })]
  });
}

var ALERT_TYPE = /*#__PURE__*/function (ALERT_TYPE) {
  ALERT_TYPE["ERROR"] = "error";
  ALERT_TYPE["WARNING"] = "warning";
  ALERT_TYPE["INFO"] = "info";
  ALERT_TYPE["SUCCESS"] = "success";
  return ALERT_TYPE;
}({});
function ModalAlertMessage(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? ALERT_TYPE.ERROR : _ref$type,
    className = _ref.className;
  return /*#__PURE__*/jsx("div", {
    className: cn('mpd-alert', "mpd-alert--".concat(type), 'mpd-alert--sticky', className),
    role: "alert",
    children: children
  });
}

function MpdTooltip(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    position = _ref.position,
    color = _ref.color,
    _ref$isOpened = _ref.isOpened,
    isOpened = _ref$isOpened === void 0 ? false : _ref$isOpened,
    _ref$triggerComponent = _ref.triggerComponent,
    triggerComponent = _ref$triggerComponent === void 0 ? null : _ref$triggerComponent;
  var tooltipRef = useRef(null);
  return /*#__PURE__*/jsxs("div", {
    ref: tooltipRef,
    className: cn(className, 'mpd-tooltip', "mpd-tooltip--".concat(position), "mpd-tooltip--".concat(color), isOpened && 'mpd-tooltip--open'),
    children: [triggerComponent && /*#__PURE__*/jsx("span", {
      className: "mpd-tooltip-trigger",
      "data-mpd-tooltip-trigger": "hover",
      onMouseEnter: function onMouseEnter() {
        var _tooltipRef$current;
        (_tooltipRef$current = tooltipRef.current) === null || _tooltipRef$current === void 0 || _tooltipRef$current.classList.add('mpd-tooltip--open');
      },
      onMouseLeave: function onMouseLeave() {
        var _tooltipRef$current2;
        (_tooltipRef$current2 = tooltipRef.current) === null || _tooltipRef$current2 === void 0 || _tooltipRef$current2.classList.remove('mpd-tooltip--open');
      },
      children: triggerComponent
    }), children]
  });
}

/**
 * This method get the id (IRI) from an object or a string
 */

function getEntityId(entity) {
  if (entity === null || typeof entity === 'undefined') {
    return null;
  }
  if (typeof entity === 'string') {
    return entity;
  }
  if (_typeof$7(entity) === 'object' && '@id' in entity) {
    return entity['@id'];
  }
  return entity.get('@id');
}

/**
 * This method get the id (IRI) from an object or a string. It does throw an error if the id is not defined.
 */

function getRequiredEntityId(entity) {
  var id = getEntityId(entity);
  if (id === null) {
    throw new Error('Id is required');
  }
  return id;
}

/**
 * remove the first part of a long id
 */
var getShortId = function getShortId(longId) {
  return longId.replace(/\/v\d+\/[a-z_-]+\/(.*)/, '$1');
};

// Overloaded function for return same type as the param

function formatTicketPrice(ticketPrice) {
  if (typeof ticketPrice === 'string') {
    return ticketPrice;
  }
  return ticketPrice.withMutations(function (mutableTp) {
    var recordToId = function recordToId(key) {
      var val = mutableTp.get(key);
      if (val !== null && val !== undefined && typeof val !== 'string') {
        // @ts-expect-error get('@id') is possible
        mutableTp.set(key, val.get('@id'));
      }
    };
    recordToId('bookingTrack');
    recordToId('eventDate');
    recordToId('eventDatePattern');
    recordToId('scanTrack');
    recordToId('tax');
    recordToId('wallet');
    recordToId('publicTypology');

    // Allow creating a new ticketPriceGroup
    if (
    // @ts-expect-error issue with SDK definition or immutable
    !ticketPrice.getIn(['ticketPriceGroup', 'groupName']) &&
    // @ts-expect-error issue with SDK definition or immutable
    !ticketPrice.getIn(['ticketPriceGroup', '@id'])) {
      mutableTp.set('ticketPriceGroup', ticketPrice.ticketPriceGroup);
    } else {
      recordToId('ticketPriceGroup');
    }
    var sellingDeviceList = mutableTp.get('sellingDeviceList');
    assertRelationIsDefined(sellingDeviceList, 'ticketPrice.sellingDeviceList');
    mutableTp.set('sellingDeviceList',
    // @ts-expect-error issue with SDK definition or immutable
    sellingDeviceList.map(function (sellingDevice) {
      if (typeof sellingDevice === 'string') {
        return sellingDevice;
      }
      return sellingDevice.get('@id');
    }));
    var ticketPriceSeatGroupList = mutableTp.get('ticketPriceSeatGroupList');
    assertRelationIsListOfObject(ticketPriceSeatGroupList, 'ticketPrice.ticketPriceSeatGroupList');
    mutableTp.set('ticketPriceSeatGroupList', ticketPriceSeatGroupList.map(function (tpsg) {
      return tpsg.set('ticketPrice', ticketPrice.get('@id')).set('seatGroup', getEntityId(tpsg.get('seatGroup')));
    }));
    var name = mutableTp.get('name');
    if (typeof name === 'string') {
      mutableTp.set('name', name.trim());
    }
  });
}
function compareEventDatesDate(a, b) {
  var aDate = a.get('startDate');
  var bDate = b.get('startDate');
  if (!aDate) {
    if (!bDate) {
      return 0;
    }
    return -1;
  }
  if (!bDate) {
    return 1;
  }
  return aDate.isBefore(bDate) ? -1 : 1;
}
function sortTicketingEventDateList(ticketing) {
  var eventDateList = ticketing.get('eventDateList');
  assertRelationIsListOfObject(eventDateList, 'ticketing.eventDateList');
  var sortedEventDateList = eventDateList.sort(compareEventDatesDate);
  return ticketing.set('eventDateList', sortedEventDateList);
}
function compareTicketPrices(a, b) {
  if (a.manualSort === b.manualSort) {
    return 0;
  } else if (a.manualSort !== null && b.manualSort === null) {
    return -1;
  } else if (a.manualSort === null && b.manualSort !== null) {
    return 1;
    // @ts-expect-error values are not null in last else
  } else if (a.manualSort < b.manualSort) {
    return -1;
  }
  return 1;
}
var compareTicketing = function compareTicketing(a, b) {
  assertRelationIsDefined(a.title, 'ticketing.title');
  assertRelationIsDefined(b.title, 'ticketing.title');
  return a.title.localeCompare(b.title);
};
function compareTicketingByFirstEventDateDate(a, b) {
  assertRelationIsListOfObject(a.eventDateList, 'a.eventDateList');
  assertRelationIsListOfObject(b.eventDateList, 'b.eventDateList');

  // we don't want to sort here, the sort between event dates should have been done before
  var aFirstEventDate = a.eventDateList.first();
  var bFirstEventDate = b.eventDateList.first();
  if (!aFirstEventDate || !bFirstEventDate) {
    if (!aFirstEventDate && bFirstEventDate) {
      return -1;
    } else if (!bFirstEventDate && aFirstEventDate) {
      return 1;
    }
    return 0;
  }
  return compareEventDatesDate(aFirstEventDate, bFirstEventDate);
}
function getMinisiteLabel(minisite) {
  return minisite.domain ? minisite.domain : "".concat(minisite.slug, ".mapado.com");
}

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var metadata = {
  "version": 4,
  "country_calling_codes": {
    "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"],
    "7": ["RU", "KZ"],
    "20": ["EG"],
    "27": ["ZA"],
    "30": ["GR"],
    "31": ["NL"],
    "32": ["BE"],
    "33": ["FR"],
    "34": ["ES"],
    "36": ["HU"],
    "39": ["IT", "VA"],
    "40": ["RO"],
    "41": ["CH"],
    "43": ["AT"],
    "44": ["GB", "GG", "IM", "JE"],
    "45": ["DK"],
    "46": ["SE"],
    "47": ["NO", "SJ"],
    "48": ["PL"],
    "49": ["DE"],
    "51": ["PE"],
    "52": ["MX"],
    "53": ["CU"],
    "54": ["AR"],
    "55": ["BR"],
    "56": ["CL"],
    "57": ["CO"],
    "58": ["VE"],
    "60": ["MY"],
    "61": ["AU", "CC", "CX"],
    "62": ["ID"],
    "63": ["PH"],
    "64": ["NZ"],
    "65": ["SG"],
    "66": ["TH"],
    "81": ["JP"],
    "82": ["KR"],
    "84": ["VN"],
    "86": ["CN"],
    "90": ["TR"],
    "91": ["IN"],
    "92": ["PK"],
    "93": ["AF"],
    "94": ["LK"],
    "95": ["MM"],
    "98": ["IR"],
    "211": ["SS"],
    "212": ["MA", "EH"],
    "213": ["DZ"],
    "216": ["TN"],
    "218": ["LY"],
    "220": ["GM"],
    "221": ["SN"],
    "222": ["MR"],
    "223": ["ML"],
    "224": ["GN"],
    "225": ["CI"],
    "226": ["BF"],
    "227": ["NE"],
    "228": ["TG"],
    "229": ["BJ"],
    "230": ["MU"],
    "231": ["LR"],
    "232": ["SL"],
    "233": ["GH"],
    "234": ["NG"],
    "235": ["TD"],
    "236": ["CF"],
    "237": ["CM"],
    "238": ["CV"],
    "239": ["ST"],
    "240": ["GQ"],
    "241": ["GA"],
    "242": ["CG"],
    "243": ["CD"],
    "244": ["AO"],
    "245": ["GW"],
    "246": ["IO"],
    "247": ["AC"],
    "248": ["SC"],
    "249": ["SD"],
    "250": ["RW"],
    "251": ["ET"],
    "252": ["SO"],
    "253": ["DJ"],
    "254": ["KE"],
    "255": ["TZ"],
    "256": ["UG"],
    "257": ["BI"],
    "258": ["MZ"],
    "260": ["ZM"],
    "261": ["MG"],
    "262": ["RE", "YT"],
    "263": ["ZW"],
    "264": ["NA"],
    "265": ["MW"],
    "266": ["LS"],
    "267": ["BW"],
    "268": ["SZ"],
    "269": ["KM"],
    "290": ["SH", "TA"],
    "291": ["ER"],
    "297": ["AW"],
    "298": ["FO"],
    "299": ["GL"],
    "350": ["GI"],
    "351": ["PT"],
    "352": ["LU"],
    "353": ["IE"],
    "354": ["IS"],
    "355": ["AL"],
    "356": ["MT"],
    "357": ["CY"],
    "358": ["FI", "AX"],
    "359": ["BG"],
    "370": ["LT"],
    "371": ["LV"],
    "372": ["EE"],
    "373": ["MD"],
    "374": ["AM"],
    "375": ["BY"],
    "376": ["AD"],
    "377": ["MC"],
    "378": ["SM"],
    "380": ["UA"],
    "381": ["RS"],
    "382": ["ME"],
    "383": ["XK"],
    "385": ["HR"],
    "386": ["SI"],
    "387": ["BA"],
    "389": ["MK"],
    "420": ["CZ"],
    "421": ["SK"],
    "423": ["LI"],
    "500": ["FK"],
    "501": ["BZ"],
    "502": ["GT"],
    "503": ["SV"],
    "504": ["HN"],
    "505": ["NI"],
    "506": ["CR"],
    "507": ["PA"],
    "508": ["PM"],
    "509": ["HT"],
    "590": ["GP", "BL", "MF"],
    "591": ["BO"],
    "592": ["GY"],
    "593": ["EC"],
    "594": ["GF"],
    "595": ["PY"],
    "596": ["MQ"],
    "597": ["SR"],
    "598": ["UY"],
    "599": ["CW", "BQ"],
    "670": ["TL"],
    "672": ["NF"],
    "673": ["BN"],
    "674": ["NR"],
    "675": ["PG"],
    "676": ["TO"],
    "677": ["SB"],
    "678": ["VU"],
    "679": ["FJ"],
    "680": ["PW"],
    "681": ["WF"],
    "682": ["CK"],
    "683": ["NU"],
    "685": ["WS"],
    "686": ["KI"],
    "687": ["NC"],
    "688": ["TV"],
    "689": ["PF"],
    "690": ["TK"],
    "691": ["FM"],
    "692": ["MH"],
    "850": ["KP"],
    "852": ["HK"],
    "853": ["MO"],
    "855": ["KH"],
    "856": ["LA"],
    "880": ["BD"],
    "886": ["TW"],
    "960": ["MV"],
    "961": ["LB"],
    "962": ["JO"],
    "963": ["SY"],
    "964": ["IQ"],
    "965": ["KW"],
    "966": ["SA"],
    "967": ["YE"],
    "968": ["OM"],
    "970": ["PS"],
    "971": ["AE"],
    "972": ["IL"],
    "973": ["BH"],
    "974": ["QA"],
    "975": ["BT"],
    "976": ["MN"],
    "977": ["NP"],
    "992": ["TJ"],
    "993": ["TM"],
    "994": ["AZ"],
    "995": ["GE"],
    "996": ["KG"],
    "998": ["UZ"]
  },
  "countries": {
    "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
    "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]],
    "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"],
    "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"],
    "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"],
    "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"],
    "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"],
    "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"],
    "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]],
    "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"],
    "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"],
    "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"],
    "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]],
    "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"],
    "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"],
    "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"],
    "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"],
    "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"],
    "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"],
    "BF": ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]],
    "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]],
    "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]],
    "BJ": ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]],
    "BL": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
    "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"],
    "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]],
    "BO": ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"],
    "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"],
    "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"],
    "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"],
    "BT": ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]],
    "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]],
    "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"],
    "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]],
    "CA": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]],
    "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    "CD": ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"],
    "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]],
    "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]],
    "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"],
    "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]],
    "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]],
    "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]],
    "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]],
    "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"],
    "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"],
    "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"],
    "CU": ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"],
    "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]],
    "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"],
    "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]],
    "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]],
    "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"],
    "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]],
    "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]],
    "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"],
    "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"],
    "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"],
    "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"],
    "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
    "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"],
    "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
    "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"],
    "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]],
    "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"],
    "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"],
    "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "FK": ["500", "00", "[2-7]\\d{4}", [5]],
    "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]],
    "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"],
    "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"],
    "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"],
    "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"],
    "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"],
    "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"],
    "GF": ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"],
    "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]],
    "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"],
    "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]],
    "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]],
    "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]],
    "GP": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
    "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]],
    "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]],
    "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
    "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"],
    "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]],
    "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]],
    "HR": ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    "HT": ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]],
    "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"],
    "ID": ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"],
    "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"],
    "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"],
    "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"],
    "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]],
    "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"],
    "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "IT": ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]],
    "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]],
    "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"],
    "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"],
    "JP": ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"],
    "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
    "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"],
    "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]],
    "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"],
    "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"],
    "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"],
    "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]],
    "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"],
    "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", 0, "8~10"],
    "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"],
    "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"],
    "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"],
    "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"],
    "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"],
    "LR": ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"],
    "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]],
    "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"],
    "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],
    "LV": ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]],
    "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"],
    "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],
    "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"],
    "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"],
    "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"],
    "MF": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
    "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"],
    "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"],
    "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"],
    "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]],
    "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"],
    "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]],
    "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"],
    "MQ": ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]],
    "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"],
    "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]],
    "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"],
    "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"],
    "MX": ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"],
    "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
    "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]],
    "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]],
    "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"],
    "NG": ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"],
    "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]],
    "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"],
    "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"],
    "NR": ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]],
    "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]],
    "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"],
    "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]],
    "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]],
    "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "],
    "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
    "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"],
    "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"],
    "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]],
    "PM": ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"],
    "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]],
    "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"],
    "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]],
    "RE": ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],
    "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "],
    "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"],
    "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"],
    "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"],
    "SA": ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"],
    "SB": ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],
    "SC": ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
    "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"],
    "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
    "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"],
    "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"],
    "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"],
    "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"],
    "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"],
    "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"],
    "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]],
    "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"],
    "SR": ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]],
    "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
    "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]],
    "SV": ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]],
    "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"],
    "SY": ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"],
    "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]],
    "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
    "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"],
    "TD": ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]],
    "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"],
    "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
    "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]],
    "TM": ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
    "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]],
    "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]],
    "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"],
    "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"],
    "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
    "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"],
    "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"],
    "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"],
    "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"],
    "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]],
    "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "],
    "UZ": ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]],
    "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"],
    "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"],
    "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"],
    "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"],
    "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"],
    "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"],
    "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]],
    "WF": ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
    "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
    "XK": ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"],
    "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    "YT": ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],
    "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    "ZM": ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"],
    "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"]
  },
  "nonGeographic": {
    "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]],
    "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]],
    "870": ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]],
    "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]],
    "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]],
    "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],
    "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],
    "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]],
    "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]]
  }
};

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}

function _typeof$6(o) {
  "@babel/helpers - typeof";

  return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$6(o);
}
function _classCallCheck$2(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$5(o.key), o);
  }
}
function _createClass$2(e, r, t) {
  return r && _defineProperties$1(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _toPropertyKey$5(t) {
  var i = _toPrimitive$5(t, "string");
  return "symbol" == _typeof$6(i) ? i : i + "";
}
function _toPrimitive$5(t, r) {
  if ("object" != _typeof$6(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$6(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}

// Added "idd_prefix" and "default_idd_prefix".
var V3 = '1.2.0';

// Moved `001` country code to "nonGeographic" section of metadata.
var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;

/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */
var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    _classCallCheck$2(this, Metadata);
    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }
  return _createClass$2(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return;
      // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }

    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];
        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    }

    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }

    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }

    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }

    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }

    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }

    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }

    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }

    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }

    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }

    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }

    // Deprecated.
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }

    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }

    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);
}();
var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$2(this, NumberingPlan);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  return _createClass$2(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }

    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }

    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }

    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }

    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    }

    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    }

    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }

    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.
      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      }
      // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
}();
var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck$2(this, Format);
    this._format = format;
    this.metadata = metadata;
  }
  return _createClass$2(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }

    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() &&
      // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule())
      // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck$2(this, Type);
    this.type = type;
    this.metadata = metadata;
  }
  return _createClass$2(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
}();
function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];
    case 'MOBILE':
      return types[1];
    case 'TOLL_FREE':
      return types[2];
    case 'PREMIUM_RATE':
      return types[3];
    case 'PERSONAL_NUMBER':
      return types[4];
    case 'VOICEMAIL':
      return types[5];
    case 'UAN':
      return types[6];
    case 'PAGER':
      return types[7];
    case 'VOIP':
      return types[8];
    case 'SHARED_COST':
      return types[9];
  }
}
function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  }

  // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
  // For that reason, it's not used in this detection algorithm.
  // Instead, it detects by `countries: {}` property existence.
  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
}

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var typeOf = function typeOf(_) {
  return _typeof$6(_);
};

/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */
function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);
  if (metadata.hasCountry(country)) {
    return metadata.selectNumberingPlan(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry$1(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}
function setVersion(metadata) {
  var version = metadata.version;
  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}

// const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

function checkNumberLength(nationalNumber, country, metadata) {
  return checkNumberLengthForType(nationalNumber, country, undefined, metadata);
}

// Checks whether a number is possible for a certain `country` based on the number length.
//
// This function is not supported by metadata generated with ancient versions of
// `libphonenumber-js` (before version `1.0.18`) which didn't include "possible lengths".
//
// There was also a known issue with `checkNumberLength()` function:
// if a number is possible only in a certain `country` among several `countries`
// that share the same "country calling code", that function would check
// the possibility of the phone number only in the "main" `country` for the "country calling code"
// and would not check if it's actually be possible in the speciifc `country`.
//
// For example, "+1310xxxx" numbers are valid in Canada.
// However, they are not possible in the US due to being too short.
// Since Canada and the US share the same country calling code — "+1" —
// `checkNumberLength()` function used to return not "IS_POSSIBLE" for "+1310xxxx" numbers.
//
// In such cases, when using "/max" metadata, `isValid()` could output `true`
// but at the same time `isPossible()` could output `false`, which was contradictory.
//
// See https://issuetracker.google.com/issues/335892662 for the discusson in Google's issues.
//
// The solution suggested by Google was implemented: an optional `country` argument
// was added to `checkNumberLength()` function. If present, that `country` will be used
// to check phone number length for that specific `country` rather than the "main" country
// for the shared "country calling code".
//
function checkNumberLengthForType(nationalNumber, country, type, metadata) {
  // If the exact `country` is specified, it's no necessarily already selected in `metadata`.
  // Most likely, in cases when there're multiple countries corresponding to the same
  // "country calling code", the "main" country for that "country calling code" will be selected.
  if (country) {
    metadata = new Metadata(metadata.metadata);
    metadata.selectNumberingPlan(country);
  }
  var type_info = metadata.type(type);

  // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.
  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
  // let local_lengths = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()

  // Metadata before version `1.0.18` didn't contain `possible_lengths`.
  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }
  var actual_length = nationalNumber.length;

  // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }
  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  }

  // We skip the first element since we've already checked it.
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */
function isPossiblePhoneNumber$3(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }
  metadata = new Metadata(metadata);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata.selectNumberingPlan(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }
      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  // Old metadata (< 1.0.18) had no "possible length" data.
  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, input.country, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, country, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, country, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return false;
  }
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regularExpressionText) {
  // If the assigning of the `''` default value is moved to the arguments above,
  // the code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regularExpressionText + ')$').test(text);
}

function _createForOfIteratorHelperLoose$2(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: true
      } : {
        done: false,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$3(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0;
  }
}
function _arrayLikeToArray$3(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL'];

// Finds out national phone number type (fixed line, mobile, etc)
function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};

  // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;

  // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835

  // Is this national number even valid for this country
  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  }

  // Is it fixed line number
  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    }

    // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.
    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)
    /* istanbul ignore if */
    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }
    return 'FIXED_LINE';
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);

  // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.
  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  }

  // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2;

// The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.
var MAX_LENGTH_FOR_NSN = 17;

// The maximum length of the country calling code.
var MAX_LENGTH_COUNTRY_CODE = 3;

// Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";

// `DASHES` will be right after the opening square bracket of the "character class"
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
// export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var TILDES = "~\u2053\u223C\uFF5E";

// Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
// const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  }
  // Check if the number is IDD-prefixed.
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  // Strip IDD prefix.
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }
  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
        // If there's more than one captured group,
        // then carrier code is the second one.
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      }
      // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        // If there's at least one captured group,
        // then carrier code is the first one.
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}

function _createForOfIteratorHelperLoose$1(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: true
      } : {
        done: false,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
  }
}
function _arrayLikeToArray$2(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

// Returns the exact country that the `nationalPhoneNumber` belongs to
// in cases of ambiguity, i.e. when multiple countries share the same "country calling code".
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
    metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);

  // const matchingCountries = []

  for (var _iterator = _createForOfIteratorHelperLoose$1(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.selectNumberingPlan(country);
    // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.
    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    }
    // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // When multiple countries share the same "country calling code",
      // type patterns aren't guaranteed to be unique among them.
      // For example, both `US` and `CA` have the same pattern for `toll_free` numbers.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417147572
      //
      // That means that this `if` condition could be `true` for multiple countries from the list.
      // Currently, it just returns the first one, which is also the "main" country for the "country calling code".
      // In an example with `toll_free` numbers above, `"US"` would be returned even though
      // it could as well be `"CA"`.
      //
      // There was also a time when this attempted to be overly smart
      // and kept track of all such multiple matching countries
      // and then picked the one that matched the `defaultCountry`, if provided.
      // For example, with `toll_free` numbers above, and with `defaultCountry: "CA"`,
      // it would've returned `"CA"` instead of `"US"`.
      // Later it turned out that such "overly smart" behavior turned out to be just confusing,
      // so this "overly smart" country detection was reverted to returning the "main" country
      // for the "country calling code".
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
      //
      return country;
      //
      // The "overly smart" behavior code:
      //
      // if (defaultCountry) {
      // 	if (country === defaultCountry) {
      // 		return country
      // 	} else {
      // 		matchingCountries.push(country)
      // 	}
      // } else {
      // 	return country
      // }
    }
  }

  // // Return the first ("main") one of the `matchingCountries`.
  // if (matchingCountries.length > 0) {
  // 	return matchingCountries[0]
  // }
}

// Returns the exact country for the `nationalNumber`
// that belongs to the specified "country calling code".
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
    metadata = _ref.metadata;
  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    metadata: metadata.metadata
  });
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {string?} country — Country, if known.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */
function extractNationalNumber(number, country, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
    carrierCode = _extractNationalNumbe.carrierCode,
    nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    }
    // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
    if (metadata.numberingPlan.possibleLengths()) {
      // If an exact `country` is not specified, attempt to detect it from the assumed national number.
      if (!country) {
        country = getCountryByCallingCode(metadata.numberingPlan.callingCode(), {
          nationalNumber: nationalNumber,
          metadata: metadata
        });
      }

      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, country, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

// In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  }
  // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, country, metadata) {
  switch (checkNumberLength(nationalNumber, country, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;
    default:
      return true;
  }
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string} [country] — Exact country of the phone number.
 * @param  {string} [defaultCountry]
 * @param  {string} [defaultCallingCode]
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadata) {
  var countryCallingCode = defaultCountry ? getCountryCallingCode(defaultCountry, metadata) : defaultCallingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(defaultCountry, countryCallingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, country, metadata),
      possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, country, metadata),
      nationalNumber = _extractNationalNumbe2.nationalNumber;

    // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.
    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, country, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Country.
 * @param  {string} [defaultCountry] — Default country.
 * @param  {string} [defaultCallingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', null, 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, null, metadata)
 * extractCountryCallingCode('+12133734253', null, 'RU', null, metadata)
 */
function extractCountryCallingCode(number, country, defaultCountry, defaultCallingCode, metadata) {
  if (!number) {
    return {};
  }
  var isNumberWithIddPrefix;

  // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376
  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, defaultCountry, defaultCallingCode, metadata);
    // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (defaultCountry || defaultCallingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  }

  // `number` can only be international at this point.

  // Fast abortion: country codes do not begin with a '0'
  if (number[1] === '0') {
    return {};
  }
  metadata = new Metadata(metadata);

  // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}

// The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }

// Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
    withNationalPrefix = _ref.withNationalPrefix;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() :
  // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;

// For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

// The RFC 3966 format for extensions.
var RFC3966_EXTN_PREFIX = ';ext=';

/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */
var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};

/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */
function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.
  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */
  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */
  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */
  var extLimitWhenNotSure = '6';

  /** @type {string} */
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
  /** @type {string} */
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */
  var optionalExtnSuffix = "#?";

  // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".
  /** @type {string} */
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.
  /** @type {string} */
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  // When extension is not separated clearly.
  /** @type {string} */
  var ambiguousSeparator = "[- ]+";
  // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.
  /** @type {string} */
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.
  /** @type {string} */
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";

  /** @type {string} */
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";

  /** @type {string} */
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;

  // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
//
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//
var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';

// This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER +
// Phone number extensions
'(?:' + createExtensionPattern() + ')?';

// The combined regular expression for valid phone numbers:
//
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
// Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
// Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i');

// Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}

// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */
function formatRFC3966(_ref) {
  var number = _ref.number,
    ext = _ref.ext;
  if (!number) {
    return '';
  }
  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }
  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};

/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */
function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    // Using ES6 "rest spread" syntax here didn't work with `babel`/`istanbul`
    // for some weird reason: this line of code would cause the code coverage
    // to show as not 100%. That's because `babel`/`istanbul`, for some weird reason,
    // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
    //
    // options = { ...DEFAULT_OPTIONS, ...options }
    //
    options = merge({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata = new Metadata(metadata);
  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata.selectNumberingPlan(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';
  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;

  // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".
  var number;
  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });

    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case 'IDD':
      if (!options.fromCountry) {
        return;
        // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true});
}
function chooseFormatForNumber(availableFormats, nationalNumber) {
  // Using a `for ... of` loop here didn't work with `babel`/`istanbul`:
  // for some weird reason, it showed code coverage less than 100%.
  // That's because `babel`/`istanbul`, for some weird reason,
  // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
  //
  // for (const format of availableFormats) { ... }
  //
  return pickFirstMatchingElement(availableFormats, function (format) {
    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      // If leading digits don't match then move on to the next phone number format
      if (nationalNumber.search(lastLeadingDigitsPattern) !== 0) {
        return false;
      }
    }
    // Check that the national number matches the phone number format regular expression
    return matchesEntirely(nationalNumber, format.pattern());
  });
}
function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata);
  // When calling within the same country calling code.
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata);
    // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.
    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    }
    // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
function merge() {
  var i = 1;
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  while (i < objects.length) {
    if (objects[i]) {
      for (var key in objects[i]) {
        objects[0][key] = objects[i][key];
      }
    }
    i++;
  }
  return objects[0];
}
function pickFirstMatchingElement(elements, testFunction) {
  var i = 0;
  while (i < elements.length) {
    if (testFunction(elements[i])) {
      return elements[i];
    }
    i++;
  }
}

function _typeof$5(o) {
  "@babel/helpers - typeof";

  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$5(o);
}
function ownKeys$4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(t), true).forEach(function (r) {
      _defineProperty$4(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty$4(e, r, t) {
  return (r = _toPropertyKey$4(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _classCallCheck$1(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$4(o.key), o);
  }
}
function _createClass$1(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _toPropertyKey$4(t) {
  var i = _toPrimitive$4(t, "string");
  return "symbol" == _typeof$5(i) ? i : i + "";
}
function _toPrimitive$4(t, r) {
  if ("object" != _typeof$5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(t);
}
var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck$1(this, PhoneNumber);
    // Validate `countryOrCountryCallingCode` argument.
    if (!countryOrCountryCallingCode) {
      throw new TypeError('First argument is required');
    }
    if (typeof countryOrCountryCallingCode !== 'string') {
      throw new TypeError('First argument must be a string');
    }

    // In case of public API use: `constructor(number, metadata)`.
    // Transform the arguments from `constructor(number, metadata)` to
    // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
    if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) {
      throw new TypeError('`metadata` argument not passed');
    }
    if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
      metadata = nationalNumber;
      var e164Number = countryOrCountryCallingCode;
      if (!E164_NUMBER_REGEXP.test(e164Number)) {
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      }
      var _extractCountryCallin = extractCountryCallingCode(e164Number, undefined, undefined, undefined, metadata),
        _countryCallingCode = _extractCountryCallin.countryCallingCode,
        number = _extractCountryCallin.number;
      nationalNumber = number;
      countryOrCountryCallingCode = _countryCallingCode;
      if (!nationalNumber) {
        throw new Error('Invalid `number` argument passed: too short');
      }
    }

    // Validate `nationalNumber` argument.
    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` argument is required');
    }
    if (typeof nationalNumber !== 'string') {
      throw new TypeError('`nationalNumber` argument must be a string');
    }

    // Validate `metadata` argument.
    validateMetadata(metadata);

    // Initialize properties.
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
      country = _getCountryAndCountry.country,
      countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.
    this.getMetadata = function () {
      return metadata;
    };
  }
  return _createClass$1(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber$3(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }

    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$4(_objectSpread$4({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);
}();
var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson);
  // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }
  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}
var E164_NUMBER_REGEXP = /^\+\d+$/;

function _typeof$4(o) {
  "@babel/helpers - typeof";

  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$4(o);
}
function _createClass(e, r, t) {
  return Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$4(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  function ParseError(code) {
    var _this;
    _classCallCheck(this, ParseError);
    _this = _callSuper(this, ParseError, [code]);
    // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.
    Object.setPrototypeOf(_this, ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  _inherits(ParseError, _Error);
  return _createClass(ParseError);
}(/*#__PURE__*/_wrapNativeSuper(Error));

// Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.
var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i');

// Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}

function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: true
      } : {
        done: false,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}
function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */
function parseIncompletePhoneNumber(string) {
  var result = '';
  // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.
  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }
  return result;
}

/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} eventListener - An optional "on event" function.
 * @return {string?} The parsed character.
 */
function parsePhoneNumberCharacter(character, prevParsedCharacters, eventListener) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }
    return '+';
  }
  // Allow digits.
  return parseDigit(character);
}

// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';

/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g');

// In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';

/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';

/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  // If no phone-context parameter is present
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  // If phone-context parameter is empty
  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart);
  // If phone-context is not the last parameter
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}

/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }

  // Does phone-context value match pattern of global-number-digits or domainname.
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }
  var phoneNumberString;
  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = '';

    // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }

    // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.
    /* istanbul ignore else */
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }

  // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.

  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js


// We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.
var MAX_INPUT_STRING_LENGTH = 250;

// This consists of the plus symbol, digits, and arabic-indic digits.
var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');

// Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');

// Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */
function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);

  // Validate `defaultCountry`.
  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }

  // Parse the phone number.
  var _parseInput = parseInput(text, options.v2, options.extract),
    formattedPhoneNumber = _parseInput.number,
    ext = _parseInput.ext,
    error = _parseInput.error;

  // If the phone number is not viable then return nothing.
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }
      throw new ParseError('NOT_A_NUMBER');
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
    country = _parsePhoneNumber.country,
    nationalNumber = _parsePhoneNumber.nationalNumber,
    countryCallingCode = _parsePhoneNumber.countryCallingCode,
    countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
    carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }
    return {};
  }

  // Validate national (significant) number length.
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.
    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    }
    // Google's demo just throws an error in this case.
    return {};
  }

  // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    }
    // Google's demo just throws an error in this case.
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }

  // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }

  // isInternational: countryCallingCode !== undefined

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, country, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}

/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  // Attempt to extract a possible number from the string passed in
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text
  // Trim everything to the left of the phone number
  .slice(startsAt)
  // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}

/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */
function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  });
  // If the phone number is not viable, then abort.
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }
    return {};
  }
  // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number
  };
}

/**
 * Creates `parse()` result object.
 */
function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };
  if (ext) {
    result.ext = ext;
  }
  return result;
}

/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */
function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), undefined, defaultCountry, defaultCallingCode, metadata.metadata),
    countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
    countryCallingCode = _extractCountryCallin.countryCallingCode,
    number = _extractCountryCallin.number;

  // The exact country of the phone number
  var country;

  // If `formattedPhoneNumber` is passed in "international" format,
  // choose a country by `countryCallingCode`.
  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  }
  // Else, if `formattedPhoneNumber` is passed in "national" format,
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};
  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), country, metadata),
    nationalNumber = _extractNationalNumbe.nationalNumber,
    carrierCode = _extractNationalNumbe.carrierCode;

  // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    metadata: metadata
  });
  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */
    if (exactCountry === '001') ; else {
      metadata.selectNumberingPlan(country);
    }
  }
  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function _typeof$3(o) {
  "@babel/helpers - typeof";

  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$3(o);
}
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), true).forEach(function (r) {
      _defineProperty$3(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty$3(e, r, t) {
  return (r = _toPropertyKey$3(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey$3(t) {
  var i = _toPrimitive$3(t, "string");
  return "symbol" == _typeof$3(i) ? i : i + "";
}
function _toPrimitive$3(t, r) {
  if ("object" != _typeof$3(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$3(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function parsePhoneNumberWithError$2(text, options, metadata) {
  return parse(text, _objectSpread$3(_objectSpread$3({}, options), {}, {
    v2: true
  }), metadata);
}

function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), true).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey$2(t) {
  var i = _toPrimitive$2(t, "string");
  return "symbol" == _typeof$2(i) ? i : i + "";
}
function _toPrimitive$2(t, r) {
  if ("object" != _typeof$2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

// Extracts the following properties from function arguments:
// * input `text`
// * `options` object
// * `metadata` JSON
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
    _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
    arg_1 = _Array$prototype$slic2[0],
    arg_2 = _Array$prototype$slic2[1],
    arg_3 = _Array$prototype$slic2[2],
    arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata;

  // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.
  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.');

  // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$2({
        defaultCountry: arg_2
      }, options);
    }
  }
  // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text: text,
    options: options,
    metadata: metadata
  };
}

function parsePhoneNumberWithError$1() {
  var _normalizeArguments = normalizeArguments(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return parsePhoneNumberWithError$2(text, options, metadata);
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _toPrimitive$1(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function parsePhoneNumber(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry$1(options.defaultCountry, metadata)) {
    options = _objectSpread$1(_objectSpread$1({}, options), {}, {
      defaultCountry: undefined
    });
  }
  // Parse phone number.
  try {
    return parsePhoneNumberWithError$2(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function isPossiblePhoneNumber$2() {
  var _normalizeArguments = normalizeArguments(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumber(text, options, metadata);
  return phoneNumber && phoneNumber.isPossible() || false;
}

function parsePhoneNumberWithError() {
  return withMetadataArgument(parsePhoneNumberWithError$1, arguments);
}

function isPossiblePhoneNumber$1() {
  return withMetadataArgument(isPossiblePhoneNumber$2, arguments);
}

function isSupportedCountry() {
  return withMetadataArgument(isSupportedCountry$1, arguments);
}

/** @deprecated to move in desk */
function getLocale() {
  var locale = null;
  if (!locale) {
    switch (true) {
      case !!window.navigator.language:
        locale = window.navigator.language;
        break;
      // @ts-expect-error browserLanguage and systemLanguage are not standard but are supported by some browsers, and we want to support them if they are available
      case !!window.navigator.browserLanguage:
        // @ts-expect-error browserLanguage and systemLanguage are not standard but are supported by some browsers, and we want to support them if they are available
        locale = window.navigator.browserLanguage;
        break;
      // @ts-expect-error browserLanguage and systemLanguage are not standard but are supported by some browsers, and we want to support them if they are available
      case !!window.navigator.systemLanguage:
        // @ts-expect-error browserLanguage and systemLanguage are not standard but are supported by some browsers, and we want to support them if they are available
        locale = window.navigator.systemLanguage;
        break;
      // @ts-expect-error browserLanguage and systemLanguage are not standard but are supported by some browsers, and we want to support them if they are available
      case !!window.navigator.userLanguage:
        // @ts-expect-error browserLanguage and systemLanguage are not standard but are supported by some browsers, and we want to support them if they are available
        locale = window.navigator.userLanguage;
        break;
      default:
        locale = 'fr-FR';
        break;
    }
  }
  return locale;
}
function getFullname(lastname, firstname) {
  var normalizedLastname = lastname || '';
  var normalizedFirstname = firstname || '';
  return "".concat(normalizedLastname, " ").concat(normalizedFirstname).trim();
}
function getCustomerFullname(customer) {
  if (customer === null) {
    return null;
  }
  var lastname = '';
  var firstname = '';
  if (_typeof$7(customer) !== 'object') {
    throw new Error('Unable to get the customer full name from something that is not an object');
  }
  if (Map$1.isMap(customer)) {
    var _customer$get, _customer$get2;
    lastname = (_customer$get = customer.get('lastname')) !== null && _customer$get !== void 0 ? _customer$get : '';
    firstname = (_customer$get2 = customer.get('firstname')) !== null && _customer$get2 !== void 0 ? _customer$get2 : '';
  } else {
    lastname = customer.lastname || '';
    firstname = customer.firstname || '';
  }
  return getFullname(lastname, firstname);
}

/**
 * Formats number to be more readable using locale-specific formatting
 * @param value - The number to format
 * @param locale - The locale to use for formatting (optional, defaults to browser's locale)
 * @returns A string representing the formatted number
 * @example
 * ```js
 * import { getFormattedNumber } from '@mapado/js-component';
 *
 * getFormattedNumber(1234567); // "1 234 567" (for fr-FR locale)
 * getFormattedNumber(1234567, 'en-US'); // "1,234,567"
 * ```
 */
function getFormattedNumber(value, locale) {
  return new Intl.NumberFormat(locale).format(value);
}
function isPossiblePhoneNumber(phoneNumber, contractCountry) {
  if (!phoneNumber) {
    return false;
  }
  if (contractCountry === undefined || isSupportedCountry(contractCountry)) {
    return isPossiblePhoneNumber$1(phoneNumber, contractCountry);
  }
  return false;
}

/**
 * Returns an object with national and international phone number formats.
 * If the phone number is invalid, it returns the phone number without changes for both formats.
 * You should only provide the `contractCountry` if you want to force-format numbers without prefix "+".
 *
 * ```ts
 * const { nationalPhoneNumber } = getFormattedPhoneNumberObject(phone);
 * ```
 */
function getFormattedPhoneNumberObject(phoneNumber, contractCountry, errorCallback) {
  var trimmedPhoneNumber = phoneNumber && phoneNumber.trim();
  if (!trimmedPhoneNumber) {
    return {
      nationalPhoneNumber: '',
      internationalPhoneNumber: ''
    };
  }

  // eslint-disable-next-line no-nested-ternary
  var country = trimmedPhoneNumber.startsWith('+') ? undefined : contractCountry && isSupportedCountry(contractCountry) ? contractCountry : undefined;
  try {
    var parsedPhone = parsePhoneNumberWithError(trimmedPhoneNumber, country);
    return {
      nationalPhoneNumber: parsedPhone.formatNational(),
      internationalPhoneNumber: parsedPhone.formatInternational()
    };
  } catch (error) {
    if (errorCallback && error instanceof Error) {
      errorCallback(error);
    }
    return {
      nationalPhoneNumber: phoneNumber,
      internationalPhoneNumber: phoneNumber
    };
  }
}
function getAddressFromCrmCustomer(crmCustomer) {
  if (crmCustomer === null) {
    return null;
  }
  var parts = [];

  // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
  if (crmCustomer.get('address')) {
    // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
    parts.push(crmCustomer.get('address'));
  }

  // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
  if (crmCustomer.get('zipcode') || crmCustomer.get('city')) {
    parts.push('\n');
  }

  // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
  if (crmCustomer.get('zipcode')) {
    // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
    parts.push(crmCustomer.get('zipcode'));
  }

  // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
  if (crmCustomer.get('city')) {
    // @ts-expect-error `get` is available on both `MapOf`, `TicketingCustomer` and `CrmCustomer`
    parts.push(crmCustomer.get('city'));
  }
  if (parts.length === 0) {
    return null;
  }
  return parts.join(' ').replace('\n ', '\n');
}

function fromCents(price) {
  return price === null || Number.isNaN(Number(price)) ? null : price / 100;
}
function toCents(price) {
  return price === null || Number.isNaN(Number(price)) ? null : price * 100;
}
var formatPriceCtsWarningTriggered = false;
function warnAboutMapadoVariable() {
  if (formatPriceCtsWarningTriggered) {
    return;
  }
  formatPriceCtsWarningTriggered = true;
  // eslint-disable-next-line no-console
  console.warn('global variable "mapado" is not defined, getting locale from browser');
}
function getLocaleFromMapadoObject() {
  if (typeof window.mapado !== 'undefined' && window.mapado.locale) {
    return window.mapado.locale;
  }
  warnAboutMapadoVariable();
  return getLocale();
}
function intlFormatPrice(price, currency, locale) {
  var isInteger = Number.isInteger(price);
  return price.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: !isInteger ? 2 : 0
  });
}
function xpfFormatPrice(formattedPrice, currency) {
  if (currency !== 'XPF') {
    return formattedPrice;
  }
  return formattedPrice.replace(/(FCFP|CFPF)/, 'XPF');
}
function formatPrice(price, currency) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fr-FR';
  var formatFreeAsText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var priceFromCents = fromCents(price);
  if (currency === null || priceFromCents === null || currency === '') {
    return null;
  }
  if (formatFreeAsText && price === 0) {
    return i18n.t('ticketing.free_price');
  }
  return xpfFormatPrice(intlFormatPrice(priceFromCents, currency, locale), currency);
}

/**
 * @deprecated Use <FormattedTicketPriceFacialValue /> component instead to handle async translations
 */
function getFormattedTicketPriceFacialValue(ticketPrice) {
  var deprecatedCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getLocaleFromMapadoObject();
  var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var i18nInstance = t ? {
    t: t
  } : i18n;
  var currency = ticketPrice.get('currency');
  if (!currency) {
    // eslint-disable-next-line no-console
    console.warn('Using a currency as second parameter is deprecated. You should use the currency directly given in the TicketPrice object');
    currency = deprecatedCurrency;
    if (!currency) {
      throw new Error('currency is not defined');
    }
  }
  var facialValue = ticketPrice.get('facialValue');
  if (facialValue && facialValue > 0) {
    return formatPrice(facialValue, currency, locale).toString();
  }
  if (ticketPrice.get('facialValue') === 0 && ticketPrice.get('behaviour') !== 'trigger_offer' && ticketPrice.get('type') !== 'subscription' && ticketPrice.get('isPriceDisplayed') !== false) {
    return i18nInstance.t('ticketing.free_price');
  }
  return null;
}
function fallBackFormatPrice(amount, currency) {
  return "".concat(currency, " ").concat(amount);
}
function formatPriceCts(amountCts, currency) {
  var formatFreeAsText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var locale = getLocaleFromMapadoObject();
  try {
    return formatPrice(amountCts, currency, locale, formatFreeAsText);
  } catch (e) {
    var amount = amountCts / 100;
    return fallBackFormatPrice(amount, currency);
  }
}

function PriceInformation(_ref) {
  var _ticketPrice$publicTy;
  var _ref$currency = _ref.currency,
    deprecatedCurrency = _ref$currency === void 0 ? null : _ref$currency,
    ticketPrice = _ref.ticketPrice;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var currency = ticketPrice.currency;
  if (!currency) {
    // eslint-disable-next-line no-console
    console.warn('using "currency" from element "PriceInformation" is deprecated, you should use `ticketPrice.currency` instead. You probably need to change the fields of you ticketPrice : "ticketPrice{eventDate{ticketing{currency}}} to ticketPrice{currency}"');
    currency = deprecatedCurrency;
  }
  var sellingDeviceListLabelList = ticketPrice.sellingDeviceList.map(function (sd) {
    switch (sd.originType) {
      case 'MINISITE':
        return getMinisiteLabel(sd.minisite);
      case 'DESK':
        return t('order.origin_desk');
      default:
        return null;
    }
  }).filter(function (sd) {
    return sd !== null;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("span", {
      className: "gray-l10",
      children: [/*#__PURE__*/jsx("span", {
        children: ticketPrice.name
      }), !!ticketPrice.description && /*#__PURE__*/jsxs("div", {
        className: "mpd-tooltip mpd-tooltip--gray mpd-tooltip--top-right",
        children: [/*#__PURE__*/jsx("span", {
          className: "mpd-tooltip-trigger",
          "data-mpd-tooltip-trigger": "hover",
          children: /*#__PURE__*/jsx(MpdIcon, {
            width: "16",
            height: "16",
            icon: "crm"
          })
        }), /*#__PURE__*/jsx("div", {
          className: "mpd-tooltip-popinWrapper",
          children: /*#__PURE__*/jsx("div", {
            className: "mpd-tooltip-popin",
            children: ticketPrice.description
          })
        })]
      }), "-", /*#__PURE__*/jsx("span", {
        children: formatPriceCts(ticketPrice.facialValue, currency)
      })]
    }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsxs("span", {
      className: "help",
      children: [sellingDeviceListLabelList.size === 0 && t('ticketing.ticketprice.is_visible.none'), sellingDeviceListLabelList.size > 0 && sellingDeviceListLabelList.join(', '), ' - ', /*#__PURE__*/jsx("span", {
        children: (_ticketPrice$publicTy = ticketPrice.publicTypology) === null || _ticketPrice$publicTy === void 0 ? void 0 : _ticketPrice$publicTy.label
      }), ' - ', /*#__PURE__*/jsx("span", {
        children: "".concat(t('ticketing.price_form.price_tax'), " ").concat((ticketPrice.tax.rate * 100).toPrecision(2))
      }), "%", ticketPrice.ticketPriceSeatGroupList.size > 0 && /*#__PURE__*/jsxs("span", {
        children: [' - ', /*#__PURE__*/jsx("span", {
          children: t('ticketing.ticketprice.has_seats')
        }), /*#__PURE__*/jsxs("div", {
          className: "mpd-tooltip mpd-tooltip--gray mpd-tooltip--top-right",
          children: [/*#__PURE__*/jsx(MpdIcon, {
            icon: "crm",
            width: "18",
            className: "gray-l30",
            "data-mpd-tooltip-trigger": "hover"
          }), /*#__PURE__*/jsx("div", {
            className: "mpd-tooltip-popinWrapper",
            children: /*#__PURE__*/jsx("div", {
              className: "mpd-tooltip-popin",
              children: ticketPrice.ticketPriceSeatGroupList.map(function (tpsg) {
                return tpsg.seatGroup.label;
              }).filter(function (label) {
                return !!label;
              }).join(', ')
            })
          })]
        })]
      })]
    })]
  });
}
PriceInformation.propTypes = {
  currency: PropTypes.string,
  ticketPrice: PropTypes.instanceOf(TicketPrice).isRequired
};

function TicketPriceItem(_ref) {
  var _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? '' : _ref$currency,
    isPriceSelected = _ref.isPriceSelected,
    ticketPrice = _ref.ticketPrice,
    toggleSelectTicketPrice = _ref.toggleSelectTicketPrice;
  var currencyToUse = currency;
  if (!currency) {
    currencyToUse = ticketPrice.currency;
    if (!currencyToUse) {
      // eslint-disable-next-line no-console
      console.warn('using "currency" from eventDate.ticketing or wallet is deprecated, you should use `ticketPrice.currency` instead. You probably need to change the fields of you ticketPrice : "ticketPrice{eventDate{ticketing{currency}}} to ticketPrice{currency}"');
      currencyToUse = ticketPrice.getIn(['wallet', 'currency']);
    }
  }
  return /*#__PURE__*/jsx("li", {
    className: "form-check",
    children: /*#__PURE__*/jsxs("label", {
      className: "form-check-label",
      children: [/*#__PURE__*/jsx("input", {
        type: "checkbox",
        className: "form-check-input",
        checked: isPriceSelected,
        onChange: function onChange() {
          return toggleSelectTicketPrice(ticketPrice);
        }
      }), /*#__PURE__*/jsx("div", {
        className: "ml2",
        children: /*#__PURE__*/jsx(PriceInformation, {
          currency: currencyToUse,
          ticketPrice: ticketPrice
        })
      })]
    })
  });
}
TicketPriceItem.propTypes = {
  currency: PropTypes.string,
  isPriceSelected: PropTypes.bool.isRequired,
  ticketPrice: PropTypes.instanceOf(TicketPrice).isRequired,
  toggleSelectTicketPrice: PropTypes.func.isRequired
};
function GroupName(_ref2) {
  var _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? null : _ref2$name;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsx("li", {
    className: "bold mt2",
    children: name || t('ticketing.manage_prices.group.default_title')
  });
}
GroupName.propTypes = {
  name: PropTypes.string
};
var PriceList = /*#__PURE__*/function (_Component) {
  function PriceList(props) {
    var _this;
    _classCallCheck$3(this, PriceList);
    _this = _callSuper$1(this, PriceList, [props]);
    _this.state = {
      queryOffer: '',
      queryTicketPrice: '',
      useAllTicketPrice: props.selectedTicketPriceList.size === props.ticketPriceList.size,
      showAllTicketPrice: props.selectedTicketPriceList.size > 0
    };
    _this.isPriceSelected = _this.isPriceSelected.bind(_this);
    _this.toggleUseAllTicketPrice = _this.toggleUseAllTicketPrice.bind(_this);
    _this.toggleSelectTicketPrice = _this.toggleSelectTicketPrice.bind(_this);
    _this.toggleSelectOffer = _this.toggleSelectOffer.bind(_this);
    _this.toggleShowAllPrice = _this.toggleShowAllPrice.bind(_this);
    _this.handleQueryTicketPriceInputChange = _this.handleQueryTicketPriceInputChange.bind(_this);
    _this.handleQueryOfferInputChange = _this.handleQueryOfferInputChange.bind(_this);
    _this.fuse = new Fuse(props.ticketPriceList.toJSON(), {
      threshold: 0.4,
      keys: ['name', 'description', 'facialValue', 'ticketPriceSeatGroupList.seatGroup.label']
    });
    return _this;
  }
  _inherits$1(PriceList, _Component);
  return _createClass$3(PriceList, [{
    key: "getGroupedTicketPriceMap",
    value: function getGroupedTicketPriceMap(queryTicketPrice) {
      var matchingIdList = this.fuse.search(queryTicketPrice).map(function (ticketPriceJson) {
        return ticketPriceJson['@id'];
      });
      var ticketPriceListByTicketPriceGroup = this.props.ticketPriceList.filter(function (tp) {
        return !queryTicketPrice || matchingIdList.includes(tp.get('@id'));
      }).groupBy(function (tp) {
        return tp.getIn(['ticketPriceGroup', '@id']);
      });
      if (ticketPriceListByTicketPriceGroup.size > 0 && ticketPriceListByTicketPriceGroup.first().ticketPriceGroup) {
        return ticketPriceListByTicketPriceGroup.sortBy(function (tpList) {
          return tpList.first().ticketPriceGroup.manualSort;
        });
      }
      return ticketPriceListByTicketPriceGroup;
    }
  }, {
    key: "getDisplayedTicketPriceList",
    value: function getDisplayedTicketPriceList() {
      var _this$state = this.state,
        queryTicketPrice = _this$state.queryTicketPrice,
        showAllTicketPrice = _this$state.showAllTicketPrice;
      var groupedTicketPriceMap = this.getGroupedTicketPriceMap(queryTicketPrice).toList();
      if (showAllTicketPrice) {
        return groupedTicketPriceMap.flatten(true);
      }
      return groupedTicketPriceMap.slice(0, 1).flatten(true);
    }
  }, {
    key: "getDisplayedOfferList",
    value: function getDisplayedOfferList() {
      var queryOffer = this.state.queryOffer;
      var offerList = this.props.offerList;
      return offerList.filter(function (offer) {
        return offer.title.toLowerCase().includes(queryOffer.toLowerCase());
      });
    }
  }, {
    key: "toggleShowAllPrice",
    value: function toggleShowAllPrice(event) {
      event.preventDefault();
      this.setState(function (prevState) {
        return {
          showAllTicketPrice: !prevState.showAllTicketPrice
        };
      });
    }
  }, {
    key: "isPriceSelected",
    value: function isPriceSelected(ticketPrice) {
      return this.props.selectedTicketPriceList.includes(ticketPrice);
    }
  }, {
    key: "toggleUseAllTicketPrice",
    value: function toggleUseAllTicketPrice() {
      var useAllTicketPrice = this.state.useAllTicketPrice;
      var ticketPriceList = this.getDisplayedTicketPriceList();
      var newUseAllTicketPrice = !useAllTicketPrice;
      if (newUseAllTicketPrice) {
        this.setState({
          useAllTicketPrice: true
        });
        this.props.onSelectedTicketPriceListChange(ticketPriceList);
      } else {
        this.setState({
          useAllTicketPrice: false
        });
        this.props.onSelectedTicketPriceListChange(List());
      }
    }
  }, {
    key: "toggleSelectTicketPrice",
    value: function toggleSelectTicketPrice(ticketPrice) {
      var selectedTicketPriceList = this.props.selectedTicketPriceList;
      var index = selectedTicketPriceList.findIndex(function (tp) {
        return tp.get('@id') === ticketPrice.get('@id');
      });
      if (index >= 0) {
        this.setState({
          useAllTicketPrice: false
        });
        this.props.onSelectedTicketPriceListChange(selectedTicketPriceList.delete(index));
      } else {
        var newSelectedTicketPriceList = selectedTicketPriceList.push(ticketPrice);
        var displayedTicketPriceList = this.getDisplayedTicketPriceList();
        var newUseAllTicketPrice = displayedTicketPriceList.every(function (tp) {
          return newSelectedTicketPriceList.contains(tp);
        }) && displayedTicketPriceList.size === newSelectedTicketPriceList.size;
        this.setState({
          useAllTicketPrice: newUseAllTicketPrice
        });
        this.props.onSelectedTicketPriceListChange(newSelectedTicketPriceList);
      }
    }
  }, {
    key: "toggleSelectOffer",
    value: function toggleSelectOffer(offer) {
      var selectedTicketPriceList = this.props.selectedTicketPriceList;
      var index = selectedTicketPriceList.findIndex(function (tp) {
        return tp.offerRuleList.get(0) === offer.get('@id');
      });
      if (index >= 0) {
        this.props.onSelectedTicketPriceListChange(selectedTicketPriceList.delete(index));
      } else {
        var newTicketPrice = new TicketPrice({
          wallet: null,
          eventDatePattern: null,
          type: TICKET_PRICE_TYPE_EXEMPTED,
          isPriceDisplayed: false,
          name: offer.getIn(['exchangeData', 'name']),
          description: offer.getIn(['exchangeData', 'description']),
          behaviour: 'trigger_offer',
          facialValue: 0,
          buyable: true,
          visible: true,
          willGenerateTicket: false,
          saleStartDate: null,
          saleEndDate: null,
          tax: '/v1/taxes/11',
          offerRuleList: [offer.get('@id')]
        });
        var newSelectedOfferList = selectedTicketPriceList.push(newTicketPrice);
        this.props.onSelectedTicketPriceListChange(newSelectedOfferList);
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "handleQueryTicketPriceInputChange",
    value: function handleQueryTicketPriceInputChange(queryTicketPrice) {
      this.setState({
        queryTicketPrice: queryTicketPrice
      });
    }
  }, {
    key: "handleQueryOfferInputChange",
    value: function handleQueryOfferInputChange(queryOffer) {
      this.setState({
        queryOffer: queryOffer
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        currency = _this$props.currency,
        ticketPriceList = _this$props.ticketPriceList,
        offerList = _this$props.offerList,
        t = _this$props.t;
      var _this$state2 = this.state,
        queryTicketPrice = _this$state2.queryTicketPrice,
        showAllTicketPrice = _this$state2.showAllTicketPrice,
        useAllTicketPrice = _this$state2.useAllTicketPrice;
      if (ticketPriceList.size === 0) {
        return null;
      }
      var ticketPriceMap = this.getGroupedTicketPriceMap(queryTicketPrice).toList();
      var firstTicketPriceListPart = ticketPriceMap.slice(0, 1).flatten(true);
      var secondTicketPriceListPart = showAllTicketPrice ? ticketPriceMap.slice(1, ticketPriceMap.size).toList() : List();
      return /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsxs("div", {
          className: "bg-lightgray p4 mt4",
          children: [/*#__PURE__*/jsxs("div", {
            className: "bold uppercase wauto mb5",
            children: [t('ticketing.session.price_list_to_use.title'), /*#__PURE__*/jsx("div", {
              className: "right",
              children: /*#__PURE__*/jsx(MpdFilters, {
                placeholder: t('ticketing.session.price_list_to_use.filter.title'),
                onChange: this.handleQueryTicketPriceInputChange
              })
            })]
          }), /*#__PURE__*/jsxs("ul", {
            className: "no-style",
            children: [ticketPriceMap.size > 1 && firstTicketPriceListPart.size > 1 && /*#__PURE__*/jsx("li", {
              className: "form-check",
              children: /*#__PURE__*/jsxs("label", {
                className: "form-check-label",
                children: [/*#__PURE__*/jsx("input", {
                  type: "checkbox",
                  checked: useAllTicketPrice,
                  onChange: this.toggleUseAllTicketPrice,
                  className: "form-check-input"
                }), /*#__PURE__*/jsx("span", {
                  className: "bold gray ml2",
                  children: t('ticketing.session.price_list_to_use.use_all')
                })]
              })
            }), firstTicketPriceListPart.size > 0 && /*#__PURE__*/jsx(GroupName, {
              name: firstTicketPriceListPart.first().getIn(['ticketPriceGroup', 'groupName'])
            }), firstTicketPriceListPart.map(function (ticketPrice) {
              return /*#__PURE__*/jsx(TicketPriceItem, {
                isPriceSelected: _this2.isPriceSelected(ticketPrice),
                ticketPrice: ticketPrice,
                toggleSelectTicketPrice: _this2.toggleSelectTicketPrice,
                currency: currency
              }, ticketPrice.get('@id'));
            })]
          }), ticketPriceMap.size > 1 && !queryTicketPrice && /*#__PURE__*/jsxs("a", {
            className: "with-i",
            href: "#showAllTicketPriceList",
            onClick: this.toggleShowAllPrice,
            children: [/*#__PURE__*/jsx("span", {
              children: t('ticketing.session.price_list_to_use.show_all')
            }), !showAllTicketPrice && /*#__PURE__*/jsx(MpdIcon, {
              icon: "arrow-right",
              height: "16",
              width: "16"
            }), showAllTicketPrice && /*#__PURE__*/jsx(MpdIcon, {
              icon: "arrow-down",
              height: "16",
              width: "16"
            })]
          }), secondTicketPriceListPart.size > 0 && /*#__PURE__*/jsx("ul", {
            className: "no-style mt0",
            children: secondTicketPriceListPart.map(function (subTicketPriceList) {
              var _subTicketPriceList$f = subTicketPriceList.first(),
                ticketPriceGroup = _subTicketPriceList$f.ticketPriceGroup;
              return /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx(GroupName, {
                  name: ticketPriceGroup ? ticketPriceGroup.groupName : t('ticketing.manage_prices.group.default_title')
                }), subTicketPriceList.map(function (ticketPrice) {
                  return /*#__PURE__*/jsx(TicketPriceItem, {
                    isPriceSelected: _this2.isPriceSelected(ticketPrice),
                    ticketPrice: ticketPrice,
                    toggleSelectTicketPrice: _this2.toggleSelectTicketPrice,
                    currency: currency
                  }, ticketPrice.get('@id'));
                })]
              });
            })
          }), offerList && offerList.size > 0 && /*#__PURE__*/jsxs("div", {
            className: "mt4",
            children: [/*#__PURE__*/jsxs("div", {
              className: "bold uppercase wauto mb5",
              children: [t('ticketing.session.offer_list_to_use'), /*#__PURE__*/jsx("div", {
                className: "right",
                children: /*#__PURE__*/jsx(MpdFilters, {
                  placeholder: t('ticketing.session.price_list_to_use.filter.title'),
                  onChange: this.handleQueryOfferInputChange
                })
              })]
            }), /*#__PURE__*/jsx("ul", {
              className: "no-style",
              children: this.getDisplayedOfferList().map(function (offer) {
                return /*#__PURE__*/jsx("li", {
                  className: "form-check",
                  children: /*#__PURE__*/jsxs("label", {
                    className: "form-check-label",
                    children: [/*#__PURE__*/jsx("input", {
                      name: "offer",
                      type: "checkbox",
                      className: "form-check-input",
                      onChange: function onChange() {
                        return _this2.toggleSelectOffer(offer);
                      }
                    }), /*#__PURE__*/jsx("div", {
                      className: "ml2",
                      children: offer.title
                    })]
                  })
                });
              })
            })]
          })]
        })
      });
    }
  }]);
}(Component);
PriceList.defaultProps = {
  currency: '',
  offerList: null
};
PriceList.propTypes = {
  currency: PropTypes.string,
  onSelectedTicketPriceListChange: PropTypes.func.isRequired,
  selectedTicketPriceList: ImmutablePropTypes.list.isRequired,
  ticketPriceList: ImmutablePropTypes.list.isRequired,
  offerList: ImmutablePropTypes.list,
  t: PropTypes.func.isRequired
};
function PriceListWithTranslation(props) {
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/jsx(PriceList, _objectSpread2(_objectSpread2({}, props), {}, {
    t: t
  }));
}

var reportFormValidity = function reportFormValidity(form) {
  if (!form) {
    return true; // state is not "opened", so the form does not exists and thus is not invalid
  }
  if (typeof form.checkValidity !== 'function') {
    // < IE10, lets ignore the validity, the API will handle the errors
    return true;
  }
  if (form.checkValidity()) {
    // the form is valid
    return true;
  }
  if (typeof form.reportValidity === 'function') {
    form.reportValidity();
  }
  return false;
};
var STOCK_DEFAULT_VALUE = 0;
function EditableStockContingentRow(_ref) {
  var _stockContingent$cont, _stockContingent$cont2;
  var stockContingent = _ref.stockContingent,
    index = _ref.index,
    hasEventDate = _ref.hasEventDate,
    onDeleteStockContingent = _ref.onDeleteStockContingent,
    onStockContingentChange = _ref.onStockContingentChange,
    _ref$displayStockInpu = _ref.displayStockInput,
    displayStockInput = _ref$displayStockInpu === void 0 ? false : _ref$displayStockInpu,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? undefined : _ref$onSelect,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? undefined : _ref$errorMessage,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var formRef = useRef(null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var bookedTickets = stockContingent.bookedTickets || STOCK_DEFAULT_VALUE;
  var totalStock = stockContingent.totalStock || STOCK_DEFAULT_VALUE;
  var bookableStock = stockContingent.bookableStock || STOCK_DEFAULT_VALUE;
  assertRelationIsNullOrObject(stockContingent.contingent, 'stockContingent.contingent');
  var contingentColor = ((_stockContingent$cont = stockContingent.contingent) === null || _stockContingent$cont === void 0 ? void 0 : _stockContingent$cont.color) || stockContingent.color || $primaryBlue;
  var contingentName = ((_stockContingent$cont2 = stockContingent.contingent) === null || _stockContingent$cont2 === void 0 ? void 0 : _stockContingent$cont2.name) || stockContingent.name;
  var isSelectable = typeof onSelect === 'function';
  var updateStockContingent = debounce(function (value) {
    if (!onStockContingentChange) {
      return;
    }
    onStockContingentChange(stockContingent.set('totalStock', parseInt(value, 10)), index);
  }, 400);
  var handleInputChange = function handleInputChange(value) {
    if (!reportFormValidity(formRef.current)) {
      return;
    }
    updateStockContingent(value);
  };
  return /*#__PURE__*/jsxs("div", {
    className: cn('editable-stock-contingent-row', {
      'editable-stock-contingent-row--selectable': isSelectable,
      'editable-stock-contingent-row--selected': isSelectable && isSelected,
      'editable-stock-contingent-row--no-event': !hasEventDate,
      'editable-stock-contingent-row--disabled': disabled
    }),
    onClick: function onClick() {
      return isSelectable && onSelect(stockContingent, index);
    },
    "aria-hidden": "true",
    children: [/*#__PURE__*/jsxs("div", {
      className: "editable-stock-contingent-row__title",
      children: [hasEventDate ? /*#__PURE__*/jsx("span", {
        className: "bold",
        children: contingentName
      }) : /*#__PURE__*/jsxs("div", {
        className: "editable-stock-contingent-row__icon-label",
        children: [/*#__PURE__*/jsx(MpdIcon, {
          icon: "seat-filled",
          width: "14",
          height: "14",
          className: "ml1 mr2",
          color: contingentColor
        }), /*#__PURE__*/jsx("span", {
          className: "bold",
          children: contingentName
        })]
      }), onDeleteStockContingent && /*#__PURE__*/jsx("button", {
        disabled: disabled,
        type: "button",
        className: "mpd-btn mpd-btn--link p0",
        onClick: function onClick(e) {
          e.stopPropagation();
          onDeleteStockContingent(stockContingent, index);
        },
        title: t('delete'),
        children: /*#__PURE__*/jsx(MpdIcon, {
          icon: "cross",
          height: "16",
          width: "16"
        })
      })]
    }), hasEventDate && /*#__PURE__*/jsxs("div", {
      className: "editable-stock-contingent-row__counts",
      children: [/*#__PURE__*/jsx(MpdCircleProgress, {
        stroke: 4,
        size: 35,
        max: totalStock,
        current: bookedTickets,
        strokeColor: contingentColor
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("div", {
          className: "editable-stock-contingent-row__count"
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: t('stock_contingent.item.totalStock', {
              count: totalStock
            })
          }
        }), /*#__PURE__*/jsx("div", {
          className: "editable-stock-contingent-row__count"
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: t('stock_contingent.item.availableStock', {
              count: bookableStock
            })
          }
        })]
      })]
    }), displayStockInput && /*#__PURE__*/jsx("form", {
      className: "editable-stock-contingent-row__form",
      ref: formRef,
      children: /*#__PURE__*/jsx(MpdInput, {
        label: t('stock_contingent.form.label'),
        type: "number",
        required: true,
        defaultValue: totalStock,
        placeholder: t('stock_contingent.form.label'),
        id: "stockContingent-stock-input-".concat(stockContingent.get('@id'), "-").concat(index),
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return handleInputChange(value);
        }
      })
    }), errorMessage && /*#__PURE__*/jsx("div", {
      className: "mpd-color-red",
      children: errorMessage
    })]
  });
}

function StockNotInContingent(_ref) {
  var totalStock = _ref.totalStock,
    availableStock = _ref.availableStock,
    bookedStock = _ref.bookedStock;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "editable-stock-contingent-row__title bold",
      children: t('stock_bar.not_contingent')
    }), /*#__PURE__*/jsxs("div", {
      className: "editable-stock-contingent-row__counts",
      children: [/*#__PURE__*/jsx(MpdCircleProgress, {
        stroke: 4,
        size: 35,
        max: totalStock,
        current: bookedStock
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("div", {
          className: "editable-stock-contingent-row__count"
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: t('stock_contingent.item.totalStock', {
              count: totalStock
            })
          }
        }), /*#__PURE__*/jsx("div", {
          className: "editable-stock-contingent-row__count"
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: t('stock_contingent.item.availableStock', {
              count: availableStock
            })
          }
        })]
      })]
    })]
  });
}

function getPercentageFromTotalStock(totalStock, value) {
  if (totalStock <= 0) {
    return 0;
  }
  return value * 100 / totalStock;
}
// https://codepen.io/xgad/post/svg-radial-progress-meters

/**
 * ## Usage
 *
 * ```js
 * import { StockRoundRepresentation } from '@mapado/js-component';
 *
 * <StockRoundRepresentation
 *   totalStock={50}
 *   data={List([
 *     {
 *       key: 'availableInContingent',
 *       nb: 10,
 *       color: 'red',
 *     },
 *   ])}
 * />;
 * ```
 */
function StockRoundRepresentation$1(_ref) {
  var data = _ref.data,
    totalStock = _ref.totalStock,
    _ref$counterClockwise = _ref.counterClockwise,
    counterClockwise = _ref$counterClockwise === void 0 ? false : _ref$counterClockwise;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (totalStock === undefined) {
    return null;
  }
  var stockAcc = 0;
  var lines = data.map(function (dataRow) {
    stockAcc += dataRow.nb;
    var classList = ['radial-progress__value'];
    if (typeof dataRow.classNameSuffix !== 'undefined') {
      classList.push("radial-progress__value--".concat(dataRow.classNameSuffix));
    }
    var r = 40;
    var dashArray = 2 * Math.PI * r;
    var percentage = getPercentageFromTotalStock(totalStock, stockAcc);
    var dashOffset = dashArray * (1 - percentage / 100);
    var style = {
      strokeDasharray: dashArray,
      strokeDashoffset: dashOffset * (counterClockwise ? -1 : 1)
    };
    if (typeof dataRow.color !== 'undefined') {
      style.stroke = dataRow.color;
    }
    return /*#__PURE__*/jsx("circle", {
      className: classList.join(' '),
      cx: "45",
      cy: "45",
      r: r,
      strokeWidth: "6",
      style: style
    }, dataRow.key);
  });
  return /*#__PURE__*/jsxs("svg", {
    className: "radial-progress",
    width: "90",
    height: "90",
    viewBox: "0 0 90 90",
    children: [/*#__PURE__*/jsx("circle", {
      className: "radial-progress__meter",
      cx: "45",
      cy: "45",
      r: "40",
      strokeWidth: "6"
    }), lines.reverse().toArray(), /*#__PURE__*/jsx("foreignObject", {
      y: "-90",
      x: "0",
      width: "90",
      height: "90",
      className: "radial-progress__total",
      children: /*#__PURE__*/jsx("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: t('eventDate.stock_graph.stock_nb', {
            nb: stockAcc
          })
        }
      })
    })]
  });
}

function useTimeout(time) {
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var displayTimeout = useRef(null);
  useEffect(function () {
    var instance = displayTimeout.current;
    instance = window.setTimeout(function () {
      return setIsVisible(true);
    }, time);
    return function () {
      return window.clearTimeout(instance || 0);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isVisible;
}

var BATCH_SIZE = 100;
var NO_STOCK_TICKET_PRICE_FIELDS = ['@id', 'currency', 'description', 'name', 'hash', 'facialValue', 'type', 'isPriceDisplayed', 'manualSort', 'onlineMaxQuantityPerCart', 'excludedFromParentStock', {
  eventDate: ['@id', 'startDate', 'endDate', {
    ticketing: ['address', 'city', 'imageList', 'mediaList', 'place', 'timezone', 'title', 'venue', 'sellingDeviceSchedule']
  }]
}, {
  bookingTrack: ['cartType']
}];
var TICKET_PRICE_FIELDS = ['@id', 'currency', 'description', 'name', 'hash', 'facialValue', 'type', 'isPriceDisplayed', 'manualSort', 'onSale', 'bookableStock', 'onlineMaxQuantityPerCart', 'excludedFromParentStock', {
  eventDate: ['@id', 'startDate', 'endDate', 'onSale', 'notInStockContingentBookableStock', {
    ticketing: ['address', 'city', 'imageList', 'mediaList', 'place', 'timezone', 'title', 'venue', 'sellingDeviceSchedule', 'isOnSale']
  }]
}, {
  bookingTrack: ['cartType']
}];
function useTicketPricePickerOfferRuleFetch(_ref) {
  var offerRuleId = _ref.offerRuleId,
    offerRuleDisallowBatchFetching = _ref.offerRuleDisallowBatchFetching,
    sellingDeviceId = _ref.sellingDeviceId,
    ticketPriceRepository = _ref.ticketPriceRepository;
  var _useState = useState([]),
    _useState2 = _slicedToArray$1(_useState, 2),
    ticketPriceList = _useState2[0],
    setTicketPriceList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$1(_useState5, 2),
    isBatchFetch = _useState6[0],
    setIsBatchFetch = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray$1(_useState7, 2),
    ticketPriceCount = _useState8[0],
    setTicketPriceCount = _useState8[1];
  useDebugValue(ticketPriceList);
  useEffect(function () {
    var isCancelled = false;
    var tpMap = OrderedMap();
    var fetchTotalItems = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, count;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return ticketPriceRepository.findBy({
                offerRuleForTicketPricePicker: offerRuleId,
                'order[eventDate.startDate]': 'ASC',
                sellingDevice: sellingDeviceId,
                itemsPerPage: 0
              }, ['@id']);
            case 1:
              result = _context.v;
              count = result.get('hydra:totalItems');
              setTicketPriceCount(count);
              return _context.a(2, count);
            case 2:
              _context.p = 2;
              _context.v;
              return _context.a(2, null);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function fetchTotalItems() {
        return _ref2.apply(this, arguments);
      };
    }();

    /*
     * @param fetchStocksAsync - if true, fetch will use NO_STOCK_TICKET_PRICE_FIELDS
     * it will then set onSale true on every fetched ticketPrice and eventDate
     * else it will use TICKET_PRICE_FIELDS and leave fetched data untouched
     */
    var fetchTicketPriceList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var fetchStocksAsync,
          result,
          fetchedTicketPriceList,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              fetchStocksAsync = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              _context2.p = 1;
              setIsLoading(true);
              _context2.n = 2;
              return ticketPriceRepository.findBy({
                offerRuleForTicketPricePicker: offerRuleId,
                'order[eventDate.startDate]': 'ASC',
                sellingDevice: sellingDeviceId
              }, fetchStocksAsync ? NO_STOCK_TICKET_PRICE_FIELDS : TICKET_PRICE_FIELDS);
            case 2:
              result = _context2.v;
              setIsLoading(false);
              fetchedTicketPriceList = result.getMembers();
              if (fetchStocksAsync) {
                // set everything on sale
                fetchedTicketPriceList = fetchedTicketPriceList.map(function (tp) {
                  assertRelationIsObject(tp.eventDate, 'tp.eventDate');
                  assertRelationIsObject(tp.eventDate.ticketing, 'tp.eventDate.ticketing');
                  return tp.set('onSale', true).set('eventDate', tp.eventDate.set('onSale', true).set('ticketing', tp.eventDate.ticketing.set('isOnSale', true)));
                });

                // keep a map of ticket prices for easy update
                fetchedTicketPriceList.forEach(function (tp) {
                  tpMap = tpMap.set(tp.get('@id'), tp);
                });
              }
              setTicketPriceList(fetchedTicketPriceList.toArray());
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              setIsLoading(false);
              // eslint-disable-next-line no-console
              console.error(_t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function fetchTicketPriceList() {
        return _ref3.apply(this, arguments);
      };
    }();

    /*
     * batch fetch ticketPriceList with TICKET_PRICE_FIELDS and replace values contained in tpMap
     * then derive ticketPriceList from tpMap
     */
    var batchFetchTicketPriceList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(totalItems) {
        var page, nbBatches, i, result, fetchedTicketPriceList, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              page = 1;
              nbBatches = Math.ceil(totalItems / BATCH_SIZE);
              i = 0;
            case 1:
              if (!(i < nbBatches && !isCancelled)) {
                _context3.n = 6;
                break;
              }
              _context3.p = 2;
              _context3.n = 3;
              return ticketPriceRepository.findBy({
                offerRuleForTicketPricePicker: offerRuleId,
                'order[eventDate.startDate]': 'ASC',
                sellingDevice: sellingDeviceId,
                itemsPerPage: BATCH_SIZE,
                page: page
              }, TICKET_PRICE_FIELDS);
            case 3:
              result = _context3.v;
              fetchedTicketPriceList = result.getMembers(); // replace ticketPrices contained in tpMap with the ones just fetched
              // eslint-disable-next-line no-loop-func
              fetchedTicketPriceList.forEach(function (tp) {
                tpMap = tpMap.set(tp.get('@id'), tp);
              });

              // extract ticketPriceList from tpMap
              setTicketPriceList(tpMap.toList().toArray());
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              // eslint-disable-next-line no-console
              console.error(_t3);
            case 5:
              // eslint-disable-next-line no-plusplus
              page++;
              // eslint-disable-next-line no-plusplus
              i++;
              _context3.n = 1;
              break;
            case 6:
              return _context3.a(2);
          }
        }, _callee3, null, [[2, 4]]);
      }));
      return function batchFetchTicketPriceList(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var startFetching = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var totalItems, fetchStockAsync;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return fetchTotalItems();
            case 1:
              totalItems = _context4.v;
              fetchStockAsync = !offerRuleDisallowBatchFetching && totalItems !== null && totalItems > BATCH_SIZE;
              if (fetchStockAsync) {
                setIsBatchFetch(true);
              }
              _context4.n = 2;
              return fetchTicketPriceList(fetchStockAsync);
            case 2:
              if (!fetchStockAsync) {
                _context4.n = 3;
                break;
              }
              _context4.n = 3;
              return batchFetchTicketPriceList(totalItems);
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function startFetching() {
        return _ref5.apply(this, arguments);
      };
    }();
    startFetching();

    // returned function will be called on component unmount
    return function () {
      isCancelled = true;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- as "fields" is an object that will force re-triggering the effect
  }, [sellingDeviceId, offerRuleId, ticketPriceRepository]);
  return {
    ticketPriceList: ticketPriceList,
    isLoading: isLoading,
    isBatchFetch: isBatchFetch,
    ticketPriceCount: ticketPriceCount
  };
}

var generateGroupKey = function generateGroupKey() {
  return Math.random().toString(36).substring(2);
};

function ErrorMessageList(_ref) {
  var errorMessageList = _ref.errorMessageList,
    className = _ref.className;
  if (errorMessageList.length > 0) {
    return /*#__PURE__*/jsx(Fragment, {
      children: errorMessageList.map(function (msg) {
        return /*#__PURE__*/jsxs("div", {
          className: cn('bold', className),
          children: [/*#__PURE__*/jsx(MpdIcon, {
            icon: "exclamation",
            className: "mr2"
          }), msg]
        }, msg);
      })
    });
  }
  return null;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function findTicketPriceById(ticketPriceList, id) {
  return ticketPriceList.find(function (tp) {
    return tp.get('@id') === id;
  });
}
function assertHashIsValid(hash) {
  if (typeof hash !== 'string' || hash === '') {
    throw new Error('Hash should be a non-empty string');
  }
}

/**
 * Get the hash of the list of ticket price by their id
 */
function getSelectedHashList(ticketPriceList, selectedTicketPriceIdList) {
  var ticketPricePerId = Object.fromEntries(ticketPriceList.map(function (innerTicketPrice) {
    var _innerTicketPrice$Id;
    return [(_innerTicketPrice$Id = innerTicketPrice['@id']) !== null && _innerTicketPrice$Id !== void 0 ? _innerTicketPrice$Id : '', innerTicketPrice];
  }));
  return selectedTicketPriceIdList.map(function (selectedTicketPriceId) {
    var ticketPrice = ticketPricePerId[selectedTicketPriceId];
    if (!ticketPrice) {
      // ticketPrice might not be fetched for now
      return null;
    }
    assertHashIsValid(ticketPrice.hash);
    return ticketPrice.hash;
  }).filter(function (hash) {
    return hash !== null;
  });
}

/**
 * Return the day of a ticketprice event date in the format YYYY-MM-DD
 */
function getDayOfTicketPrice(ticketPrice) {
  var _ticketPrice$eventDat, _ticketPrice$eventDat2;
  assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
  return (_ticketPrice$eventDat = (_ticketPrice$eventDat2 = ticketPrice.eventDate.startDate) === null || _ticketPrice$eventDat2 === void 0 ? void 0 : _ticketPrice$eventDat2.format('YYYY-MM-DD')) !== null && _ticketPrice$eventDat !== void 0 ? _ticketPrice$eventDat : undefined;
}

function getSelectedEventDateIdSet(ticketPriceList) {
  var eventDateIdSet = new Set();
  ticketPriceList.forEach(function (tp) {
    var eventDate = tp.eventDate;
    if (eventDate === null || eventDate === undefined) {
      return;
    }
    assertRelationIsObject(eventDate, 'ticketPrice.eventDate');
    var eventDateId = eventDate.get('@id');
    if (eventDateId) {
      eventDateIdSet.add(eventDateId);
    }
  });
  return eventDateIdSet;
}

/**
 * Filter ticket prices to only keep those whose eventDate matches
 * one of the eventDates selected in previous steps.
 *
 * This is used for the "MakeCompanionBuyable" applier:
 * companion tickets should only be available for the same eventDates
 * as the tickets selected in the previous offer steps.
 */
function filterTicketPriceListForCompanionBuyable(ticketPriceList, potentialSiblingsTicketPriceList, constraintList) {
  var _constraintList$appli;
  if (!((_constraintList$appli = constraintList.applierList) !== null && _constraintList$appli !== void 0 && _constraintList$appli.includes('MakeCompanionBuyable'))) {
    return ticketPriceList;
  }
  if (potentialSiblingsTicketPriceList.length === 0) {
    return ticketPriceList;
  }
  var selectedEventDateIdSet = getSelectedEventDateIdSet(potentialSiblingsTicketPriceList);
  if (selectedEventDateIdSet.size === 0) {
    return ticketPriceList;
  }
  var filteredTicketPriceList = ticketPriceList.filter(function (tp) {
    var eventDate = tp.eventDate;
    if (eventDate === null || eventDate === undefined) {
      return false;
    }
    assertRelationIsObject(eventDate, 'ticketPrice.eventDate');
    var eventDateId = eventDate.get('@id');
    return eventDateId !== null && eventDateId !== undefined && selectedEventDateIdSet.has(eventDateId);
  });
  return filteredTicketPriceList;
}

/**
 * This HOC filters ticket prices for MakeCompanionBuyable actions:
 * only show ticket prices whose eventDate has at least one ticket price
 * selected in previous steps.
 */
var withCompanionBuyable = function withCompanionBuyable(WrappedComponent) {
  var WithCompanionBuyable = function WithCompanionBuyable(props) {
    var ticketPriceList = props.ticketPriceList,
      potentialSiblingsTicketPriceList = props.potentialSiblingsTicketPriceList,
      constraintList = props.constraintList;
    var filteredTicketPriceList = filterTicketPriceListForCompanionBuyable(ticketPriceList, potentialSiblingsTicketPriceList !== null && potentialSiblingsTicketPriceList !== void 0 ? potentialSiblingsTicketPriceList : [], constraintList);
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      ticketPriceList: filteredTicketPriceList
    }));
  };
  WithCompanionBuyable.displayName = "WithCompanionBuyable(".concat(getDisplayName(WrappedComponent), ")");
  return WithCompanionBuyable;
};

function hasMultipleTicketing(ticketPriceList) {
  var ticketingIdList = ticketPriceList.map(function (ticketPrice) {
    assertRelationIsObject(ticketPrice, 'ticketPrice');
    assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
    assertRelationIsObject(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
    return ticketPrice.eventDate.ticketing.get('@id');
  });
  return new Set(ticketingIdList).size > 1;
}
function filterTicketPriceListForEventDate(ticketPriceList, currentEventDateId, constraintList) {
  var _constraintList$NPerE;
  if (!currentEventDateId) {
    return ticketPriceList;
  }
  if (((_constraintList$NPerE = constraintList.NPerEventDate) === null || _constraintList$NPerE === void 0 ? void 0 : _constraintList$NPerE.max) === 1) {
    // if we force different event dates, we should not filter
    return ticketPriceList;
  }
  var _ref = constraintList.NbTicket || {},
    min = _ref.min,
    max = _ref.max;
  var exactlyOne = max === 1 && min === 1;
  if (
  // if we have multiple ticketing, we don't want to filter…
  hasMultipleTicketing(ticketPriceList) &&
  // …unless we have exactly a "one ticket only" constraint…
  !exactlyOne &&
  // …or we have a "same event date" constraint
  constraintList.SameEventDate !== true) {
    return ticketPriceList;
  }
  var filteredTicketPriceList = ticketPriceList.filter(function (ticketPrice) {
    return getEntityId(ticketPrice.eventDate) === currentEventDateId;
  });
  return filteredTicketPriceList.length > 0 ? filteredTicketPriceList : ticketPriceList;
}

/**
 * This HOC tries to auto-select the current event date if we want to purchase a ticket price
 * that is contain in the current event date.
 * The main purpose of this HOC is to resolve offer like this :
 *   one ticket named "XXX" + one drink
 * if we trigger this offer in an event date context, we assume that we want to by the ticket for this event date.
 * This way the offer might appear on each event date, and still be a "one-click offer"
 */
var withEventDateFilter = function withEventDateFilter(WrappedComponent) {
  var WithEventDateFilter = function WithEventDateFilter(props) {
    var currentEventDateId = props.currentEventDateId,
      ticketPriceList = props.ticketPriceList,
      constraintList = props.constraintList;
    var filteredTicketPriceList = filterTicketPriceListForEventDate(ticketPriceList, currentEventDateId, constraintList);
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      ticketPriceList: filteredTicketPriceList
    }));
  };
  WithEventDateFilter.displayName = "WithEventDateFilter(".concat(getDisplayName(WrappedComponent), ")");
  return WithEventDateFilter;
};

var withMandatoryTicketPriceList = function withMandatoryTicketPriceList(WrappedComponent) {
  var WithMandatoryTicketPriceList = /*#__PURE__*/function (_PureComponent) {
    function WithMandatoryTicketPriceList(props) {
      var _this;
      _classCallCheck$3(this, WithMandatoryTicketPriceList);
      _this = _callSuper$1(this, WithMandatoryTicketPriceList, [props]);
      _this.canChangeTicketPriceToCheckedState = _this.canChangeTicketPriceToCheckedState.bind(_this);
      _this.getDefaultSelectedTicketPriceList = _this.getDefaultSelectedTicketPriceList.bind(_this);
      return _this;
    }
    _inherits$1(WithMandatoryTicketPriceList, _PureComponent);
    return _createClass$3(WithMandatoryTicketPriceList, [{
      key: "getDefaultSelectedTicketPriceList",
      value: function getDefaultSelectedTicketPriceList() {
        var mandatoryTicketPriceList = this.props.mandatoryTicketPriceList;
        var defaultSelectedTicketPriceIdList = mandatoryTicketPriceList.slice(0);
        if (
        // eslint-disable-next-line react/destructuring-assignment
        typeof this.props.defaultSelectedTicketPriceIdList !== 'undefined' &&
        // eslint-disable-next-line react/destructuring-assignment
        Array.isArray(this.props.defaultSelectedTicketPriceIdList)) {
          // eslint-disable-next-line react/destructuring-assignment
          return this.props.defaultSelectedTicketPriceIdList.concat(defaultSelectedTicketPriceIdList);
        }
        return defaultSelectedTicketPriceIdList;
      }
    }, {
      key: "canChangeTicketPriceToCheckedState",
      value: function canChangeTicketPriceToCheckedState(ticketPrice, isChecked) {
        var _this$props = this.props,
          canChangeTicketPriceToCheckedState = _this$props.canChangeTicketPriceToCheckedState,
          mandatoryTicketPriceList = _this$props.mandatoryTicketPriceList;
        if (!canChangeTicketPriceToCheckedState(ticketPrice, isChecked)) {
          return false;
        }
        if (isChecked === false &&
        // @ts-expect-error issue with immutable 3
        mandatoryTicketPriceList.indexOf(ticketPrice.get('@id')) >= 0) {
          return false;
        }
        return true;
      }
    }, {
      key: "render",
      value: function render() {
        var mandatoryTicketPriceList = this.props.mandatoryTicketPriceList;
        if (!mandatoryTicketPriceList) {
          // ignore this HOC if there is no mandatory ticket prices
          return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2({}, this.props));
        }

        // ... and renders the wrapped component with the fresh data!
        // Notice that we pass through any additional props
        return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, this.props), {}, {
          canChangeTicketPriceToCheckedState: this.canChangeTicketPriceToCheckedState,
          defaultSelectedTicketPriceIdList: this.getDefaultSelectedTicketPriceList()
        }));
      }
    }]);
  }(PureComponent);
  _defineProperty$5(WithMandatoryTicketPriceList, "defaultProps", {
    mandatoryTicketPriceList: []
  });
  _defineProperty$5(WithMandatoryTicketPriceList, "displayName", "WithMandatoryTicketPriceList(".concat(getDisplayName(WrappedComponent), ")"));
  return WithMandatoryTicketPriceList;
};

function canSkipStep(ticketPriceList, max, defaultSelectedTicketPriceIdList) {
  return ticketPriceList.length === 1 && max === (defaultSelectedTicketPriceIdList === null || defaultSelectedTicketPriceIdList === void 0 ? void 0 : defaultSelectedTicketPriceIdList.length);
}
function isValid$1(selectedTicketPriceIdList, constraintList) {
  var _constraintList$NbTic;
  var max = (_constraintList$NbTic = constraintList.NbTicket) === null || _constraintList$NbTic === void 0 ? void 0 : _constraintList$NbTic.max;
  var nbTickets = selectedTicketPriceIdList.size;
  if (typeof max !== 'undefined' && max >= 0 && nbTickets > max) {
    return false;
  }
  return true;
}

/**
 * This HOC check that if we did not select more that max ticket price.
 * It also skip the step if there is only one ticket price in the offer and in the selected ticket price list
 */
var withMaxTicketPriceList = function withMaxTicketPriceList(WrappedComponent) {
  var WithMaxTicketPriceList = /*#__PURE__*/function (_PureComponent) {
    function WithMaxTicketPriceList(props) {
      var _this;
      _classCallCheck$3(this, WithMaxTicketPriceList);
      _this = _callSuper$1(this, WithMaxTicketPriceList, [props]);
      _this.isSelectedTicketPriceListValid = _this.isSelectedTicketPriceListValid.bind(_this);
      _this.getErrorMessageList = _this.getErrorMessageList.bind(_this);
      return _this;
    }
    _inherits$1(WithMaxTicketPriceList, _PureComponent);
    return _createClass$3(WithMaxTicketPriceList, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _constraintList$NbTic2;
        var _this$props = this.props,
          constraintList = _this$props.constraintList,
          defaultSelectedTicketPriceIdList = _this$props.defaultSelectedTicketPriceIdList,
          onConfirm = _this$props.onConfirm,
          ticketPriceList = _this$props.ticketPriceList,
          onSkipStep = _this$props.onSkipStep;
        var max = (_constraintList$NbTic2 = constraintList.NbTicket) === null || _constraintList$NbTic2 === void 0 ? void 0 : _constraintList$NbTic2.max;
        if (onConfirm && canSkipStep(ticketPriceList, max, defaultSelectedTicketPriceIdList)) {
          onSkipStep().then(function () {
            onConfirm(defaultSelectedTicketPriceIdList);
          });
        }
      }
    }, {
      key: "getErrorMessageList",
      value: function getErrorMessageList(selectedTicketPriceIdList) {
        var _this$props2 = this.props,
          constraintList = _this$props2.constraintList,
          getErrorMessageList = _this$props2.getErrorMessageList,
          t = _this$props2.t;
        var errorMessageList = getErrorMessageList(selectedTicketPriceIdList);
        if (!isValid$1(selectedTicketPriceIdList, constraintList)) {
          var _constraintList$NbTic3;
          var max = (_constraintList$NbTic3 = constraintList.NbTicket) === null || _constraintList$NbTic3 === void 0 ? void 0 : _constraintList$NbTic3.max;
          var nb = selectedTicketPriceIdList.size - (max !== null && max !== void 0 ? max : 0);
          errorMessageList.push(t('ticket_price_picker.error.nb_too_many_tickets', {
            count: nb
          }));
        }
        return errorMessageList;
      }
    }, {
      key: "isSelectedTicketPriceListValid",
      value: function isSelectedTicketPriceListValid(selectedTicketPriceIdList) {
        var _this$props3 = this.props,
          constraintList = _this$props3.constraintList,
          isSelectedTicketPriceListValid = _this$props3.isSelectedTicketPriceListValid;
        if (isSelectedTicketPriceListValid(selectedTicketPriceIdList) === false) {
          return false;
        }
        return isValid$1(selectedTicketPriceIdList, constraintList);
      }
    }, {
      key: "render",
      value: function render() {
        var _constraintList$NbTic4;
        var constraintList = this.props.constraintList;
        var max = (_constraintList$NbTic4 = constraintList.NbTicket) === null || _constraintList$NbTic4 === void 0 ? void 0 : _constraintList$NbTic4.max;
        if (max === null) {
          // ignore this HOC if there is no max
          return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2({}, this.props));
        }

        // ... and renders the wrapped component with the fresh data!
        // Notice that we pass through any additional props
        return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, this.props), {}, {
          constraintList: constraintList,
          getErrorMessageList: this.getErrorMessageList,
          isSelectedTicketPriceListValid: this.isSelectedTicketPriceListValid
        }));
      }
    }]);
  }(PureComponent); // eslint-disable-next-line react/no-multi-comp
  _defineProperty$5(WithMaxTicketPriceList, "displayName", "WithMaxTicketPriceList(".concat(getDisplayName(WrappedComponent), ")"));
  return function WithMaxTicketPriceListWithTranslation(props) {
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;

    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/jsx(WithMaxTicketPriceList, _objectSpread2(_objectSpread2({}, props), {}, {
      t: t
    }));
  };
};

function isValid(selectedTicketPriceIdList, constraintList) {
  var _constraintList$NbTic;
  var nbTickets = selectedTicketPriceIdList.size;
  var min = (_constraintList$NbTic = constraintList.NbTicket) === null || _constraintList$NbTic === void 0 ? void 0 : _constraintList$NbTic.min;
  if (typeof min !== 'undefined' && min >= 0 && nbTickets < min) {
    return false;
  }
  return true;
}
function getAutoAddedTicketPriceIdList$1(ticketPriceList, min, defaultSelectedTicketPriceIdList) {
  var autoAddedTicketPriceIdList = [];
  if ((defaultSelectedTicketPriceIdList === null || defaultSelectedTicketPriceIdList === void 0 ? void 0 : defaultSelectedTicketPriceIdList.length) <= 0 &&
  // if ticketing are already selected, then don't auto-select
  ticketPriceList.length === 1 // auto-select if there is no choice for the user
  ) {
    autoAddedTicketPriceIdList = Array(min).fill(ticketPriceList[0].get('@id'));
  }
  return autoAddedTicketPriceIdList;
}
/**
 * This HOC tries to automatically add all ticket prices if there is only one ticket price
 * in this step and if we want a minimum number of ticket prices.
 * This resolves cases like :
 *   - Group pack : at least 10 tickets names "Group"
 * In this case, it will auto-fill the first 10 tickets
 */
var withMinTicketPriceList = function withMinTicketPriceList(WrappedComponent) {
  var WithMinTicketPriceList = /*#__PURE__*/function (_PureComponent) {
    function WithMinTicketPriceList(props) {
      var _constraintList$NbTic2, _constraintList$NbTic3;
      var _this;
      _classCallCheck$3(this, WithMinTicketPriceList);
      _this = _callSuper$1(this, WithMinTicketPriceList, [props]);
      _this.isSelectedTicketPriceListValid = _this.isSelectedTicketPriceListValid.bind(_this);
      _this.getErrorMessageList = _this.getErrorMessageList.bind(_this);
      var constraintList = props.constraintList,
        ticketPriceList = props.ticketPriceList,
        defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList;
      var min = (_constraintList$NbTic2 = (_constraintList$NbTic3 = constraintList.NbTicket) === null || _constraintList$NbTic3 === void 0 ? void 0 : _constraintList$NbTic3.min) !== null && _constraintList$NbTic2 !== void 0 ? _constraintList$NbTic2 : 0;
      _this.state = {
        autoAddedTicketPriceIdList: getAutoAddedTicketPriceIdList$1(ticketPriceList, min, defaultSelectedTicketPriceIdList)
      };
      return _this;
    }
    _inherits$1(WithMinTicketPriceList, _PureComponent);
    return _createClass$3(WithMinTicketPriceList, [{
      key: "getErrorMessageList",
      value: function getErrorMessageList(selectedTicketPriceIdList) {
        var _this$props = this.props,
          constraintList = _this$props.constraintList,
          getErrorMessageList = _this$props.getErrorMessageList,
          t = _this$props.t;
        var errorMessageList = getErrorMessageList(selectedTicketPriceIdList);
        if (!isValid(selectedTicketPriceIdList, constraintList)) {
          var _constraintList$NbTic4;
          var min = (_constraintList$NbTic4 = constraintList.NbTicket) === null || _constraintList$NbTic4 === void 0 ? void 0 : _constraintList$NbTic4.min;
          var nb = (min !== null && min !== void 0 ? min : 0) - selectedTicketPriceIdList.size;
          errorMessageList.push(t('ticket_price_picker.error.missing_nb_tickets', {
            count: nb
          }));
        }
        return errorMessageList;
      }
    }, {
      key: "isSelectedTicketPriceListValid",
      value: function isSelectedTicketPriceListValid(selectedTicketPriceIdList) {
        var _this$props2 = this.props,
          constraintList = _this$props2.constraintList,
          isSelectedTicketPriceListValid = _this$props2.isSelectedTicketPriceListValid;
        if (isSelectedTicketPriceListValid(selectedTicketPriceIdList) === false) {
          return false;
        }
        return isValid(selectedTicketPriceIdList, constraintList);
      }
    }, {
      key: "render",
      value: function render() {
        var _constraintList$NbTic5;
        var _this$props3 = this.props,
          constraintList = _this$props3.constraintList,
          defaultSelectedTicketPriceIdList = _this$props3.defaultSelectedTicketPriceIdList;
        var autoAddedTicketPriceIdList = this.state.autoAddedTicketPriceIdList;
        var min = (_constraintList$NbTic5 = constraintList.NbTicket) === null || _constraintList$NbTic5 === void 0 ? void 0 : _constraintList$NbTic5.min;
        if (min === null) {
          // ignore this HOC if there is no min
          return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2({}, this.props));
        }

        // ... and renders the wrapped component with the fresh data!
        // Notice that we pass through any additional props
        return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, this.props), {}, {
          defaultSelectedTicketPriceIdList: (defaultSelectedTicketPriceIdList === null || defaultSelectedTicketPriceIdList === void 0 ? void 0 : defaultSelectedTicketPriceIdList.length) > 0 ? defaultSelectedTicketPriceIdList : autoAddedTicketPriceIdList,
          getErrorMessageList: this.getErrorMessageList,
          isSelectedTicketPriceListValid: this.isSelectedTicketPriceListValid
        }));
      }
    }]);
  }(PureComponent); // eslint-disable-next-line react/no-multi-comp
  _defineProperty$5(WithMinTicketPriceList, "displayName", "WithMinTicketPriceList(".concat(getDisplayName(WrappedComponent), ")"));
  return function WithMinTicketPriceListWithTranslation(props) {
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;

    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/jsx(WithMinTicketPriceList, _objectSpread2(_objectSpread2({}, props), {}, {
      t: t
    }));
  };
};

function filterNull(value) {
  return value !== null;
}
function getAutoAddedTicketPriceIdList(ticketPriceList, constraintList) {
  var _constraintList$NbTic, _constraintList$NbTic2, _constraintList$NPerV, _constraintList$NPerT, _constraintList$NPerE, _constraintList$NPerT2;
  var nbTicketsMin = (_constraintList$NbTic = constraintList.NbTicket) === null || _constraintList$NbTic === void 0 ? void 0 : _constraintList$NbTic.min;
  var nbTicketsMax = (_constraintList$NbTic2 = constraintList.NbTicket) === null || _constraintList$NbTic2 === void 0 ? void 0 : _constraintList$NbTic2.max;
  if (typeof nbTicketsMin !== 'number' || nbTicketsMin <= 0) {
    // we can not add anything automatically if the number of tickets required is zero
    return [];
  }
  if (nbTicketsMin !== nbTicketsMax) {
    // we can only automatically add ticket prices if we require an exact number of tickets
    return [];
  }
  if (ticketPriceList.length !== nbTicketsMin) {
    // if the number of ticket prices are not identical to the number of tickets,
    // then we can not decide whose ticket prices will be selected
    return [];
  }
  var maxPerVenue = (_constraintList$NPerV = constraintList.NPerVenue) === null || _constraintList$NPerV === void 0 ? void 0 : _constraintList$NPerV.max;
  var maxPerTicketing = (_constraintList$NPerT = constraintList.NPerTicketing) === null || _constraintList$NPerT === void 0 ? void 0 : _constraintList$NPerT.max;
  var maxPerEventDate = (_constraintList$NPerE = constraintList.NPerEventDate) === null || _constraintList$NPerE === void 0 ? void 0 : _constraintList$NPerE.max;
  var maxPerTicketPrice = (_constraintList$NPerT2 = constraintList.NPerTicketPrice) === null || _constraintList$NPerT2 === void 0 ? void 0 : _constraintList$NPerT2.max;
  var ticketPriceIdList = ticketPriceList.map(getEntityId).filter(filterNull);
  var nbDifferentTicketPricePerSelector;

  // select which "selector" is the best. Start with the more global selector :
  // venue -> ticketing -> eventDate -> ticketPrice
  if (maxPerVenue === 1) {
    nbDifferentTicketPricePerSelector = Set$1(ticketPriceList.map(function (ticketPrice) {
      return (
        // @ts-expect-error issue with immutable 3
        getEntityId(ticketPrice.eventDate.ticketing.venue)
      );
    })).size;
  } else if (maxPerTicketing === 1) {
    nbDifferentTicketPricePerSelector = Set$1(ticketPriceList.map(function (ticketPrice) {
      return (
        // @ts-expect-error issue with immutable 3
        getEntityId(ticketPrice.eventDate.ticketing)
      );
    })).size;
  } else if (maxPerEventDate === 1) {
    nbDifferentTicketPricePerSelector = Set$1(ticketPriceList.map(function (ticketPrice) {
      return getEntityId(ticketPrice.eventDate);
    })).size;
  } else if (maxPerTicketPrice === 1) {
    nbDifferentTicketPricePerSelector = ticketPriceIdList.length;
  } else {
    // if we allow more than one ticket per event date, then we can not automatically add items here
    // There is another hook that automatically adds items if all ticket prices ids are the same
    return [];
  }
  if (nbDifferentTicketPricePerSelector !== nbTicketsMin) {
    // if the number of event dates are not identical to the number of tickets,
    // then we can not automatically add the tickets as we can not decide whose event dates will be selected
    return [];
  }

  // finally, we are on the manage case where we can automatically add one ticket price of each
  return ticketPriceIdList;
}
/**
 * This HOC automatically add tickets if:
 *   - the number of required tickets is the same as the number of possible tickets
 *   - there is a constraint "NPerXXX" with max = 1 (ex. every event date is different)
 */
var withMinTicketPriceListAndDifferentSelector = function withMinTicketPriceListAndDifferentSelector(WrappedComponent) {
  var WithMinTicketPriceListAndDifferentSelector = /*#__PURE__*/function (_PureComponent) {
    function WithMinTicketPriceListAndDifferentSelector(props) {
      var _constraintList$NbTic3;
      var _this;
      _classCallCheck$3(this, WithMinTicketPriceListAndDifferentSelector);
      _this = _callSuper$1(this, WithMinTicketPriceListAndDifferentSelector, [props]);
      var constraintList = props.constraintList,
        ticketPriceList = props.ticketPriceList,
        onConfirm = props.onConfirm,
        onSkipStep = props.onSkipStep;
      var nbTicketsMin = (_constraintList$NbTic3 = constraintList.NbTicket) === null || _constraintList$NbTic3 === void 0 ? void 0 : _constraintList$NbTic3.min;
      var autoAddedTicketPriceIdList = getAutoAddedTicketPriceIdList(ticketPriceList, constraintList);
      if (typeof nbTicketsMin === 'number' && nbTicketsMin > 0 && autoAddedTicketPriceIdList.length === nbTicketsMin && onConfirm) {
        // we can skip this step if ticket prices are selected as there is no other choice to the user
        onSkipStep().then(function () {
          onConfirm(autoAddedTicketPriceIdList);
        });
      }
      _this.state = {
        autoAddedTicketPriceIdList: autoAddedTicketPriceIdList
      };
      return _this;
    }
    _inherits$1(WithMinTicketPriceListAndDifferentSelector, _PureComponent);
    return _createClass$3(WithMinTicketPriceListAndDifferentSelector, [{
      key: "render",
      value: function render() {
        var defaultSelectedTicketPriceIdList = this.props.defaultSelectedTicketPriceIdList;
        var autoAddedTicketPriceIdList = this.state.autoAddedTicketPriceIdList;
        return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, this.props), {}, {
          defaultSelectedTicketPriceIdList: defaultSelectedTicketPriceIdList && defaultSelectedTicketPriceIdList.length > 0 ? defaultSelectedTicketPriceIdList : autoAddedTicketPriceIdList
        }));
      }
    }]);
  }(PureComponent);
  _defineProperty$5(WithMinTicketPriceListAndDifferentSelector, "displayName", "WithMinTicketPriceListAndDifferentSelector(".concat(getDisplayName(WrappedComponent), ")"));
  return WithMinTicketPriceListAndDifferentSelector;
};

function countTicketPricesByEventDate(ticketPriceList, selectedTicketPriceIdList) {
  var out = {};
  selectedTicketPriceIdList.forEach(function (selectedTicketPriceId) {
    var ticketPrice = findTicketPriceById(ticketPriceList, selectedTicketPriceId);
    if (ticketPrice) {
      var _getEntityId;
      var eventDateId = (_getEntityId = getEntityId(ticketPrice.eventDate)) !== null && _getEntityId !== void 0 ? _getEntityId : '';
      out[eventDateId] = out[eventDateId] ? out[eventDateId] + 1 : 1;
    }
  });
  return out;
}
var getDisableTicketPriceIdList$8 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var ticketPriceNumberPerEventDate = countTicketPricesByEventDate(ticketPriceList, defaultSelectedTicketPriceIdList);
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var NPerEventDate = constraintList.NPerEventDate;
  if (NPerEventDate && NPerEventDate.max) {
    // override if there is a `NPerTicketPrice` for those event dates
    ticketPriceList.forEach(function (ticketPrice) {
      var _getEntityId2;
      assertRelationIsDefined(ticketPrice.eventDate, 'ticketPrice.eventDate');
      if (typeof NPerEventDate.max === 'undefined' || ticketPriceNumberPerEventDate[(_getEntityId2 = getEntityId(ticketPrice.eventDate)) !== null && _getEntityId2 !== void 0 ? _getEntityId2 : ''] >= NPerEventDate.max) {
        var _ticketPrice$get;
        decoratedDisabledTicketPriceIdList.add((_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : '');
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from event date that alrealy have more than max allowed per event date
 */
var withNPerEventDate = function withNPerEventDate(WrappedComponent) {
  function WithNPerEventDate(props) {
    var constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList,
      disabledTicketPriceIdList = props.disabledTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$8(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithNPerEventDate.displayName = "WithNPerEventDate(".concat(getDisplayName(WrappedComponent), ")");
  return WithNPerEventDate;
};
withNPerEventDate.getDisableTicketPriceIdList = getDisableTicketPriceIdList$8;

function countTicketPricesByHash(ticketPriceList, selectedTicketPriceIdList) {
  var out = {};
  var selectedHashList = getSelectedHashList(ticketPriceList, selectedTicketPriceIdList);
  selectedHashList.forEach(function (selectedTicketPriceHash) {
    out[selectedTicketPriceHash] = out[selectedTicketPriceHash] ? out[selectedTicketPriceHash] + 1 : 1;
  });
  return out;
}
var getDisableTicketPriceIdList$7 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var ticketPriceNumberPerHash = countTicketPricesByHash(ticketPriceList, defaultSelectedTicketPriceIdList);
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var NPerTicketPrice = constraintList.NPerTicketPrice;
  if (NPerTicketPrice && NPerTicketPrice.max) {
    // override if there is a `NPerTicketPrice` for those ticket prices
    ticketPriceList.forEach(function (ticketPrice) {
      var ticketPriceId = ticketPrice['@id'];
      var ticketPriceHash = ticketPrice.hash;
      assertRelationIsDefined(ticketPriceId, 'ticketPrice.@id');
      assertHashIsValid(ticketPriceHash);
      if (NPerTicketPrice.max && ticketPriceNumberPerHash[ticketPriceHash] >= NPerTicketPrice.max) {
        decoratedDisabledTicketPriceIdList.add(ticketPriceId);
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from ticket prices that already have more than max allowed per ticket price
 */
var withNPerTicketPrice = function withNPerTicketPrice(WrappedComponent) {
  function WithNPerTicketPrice(props) {
    var disabledTicketPriceIdList = props.disabledTicketPriceIdList,
      constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$7(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithNPerTicketPrice.displayName = "WithNPerTicketPrice(".concat(getDisplayName(WrappedComponent), ")");
  return WithNPerTicketPrice;
};
withNPerTicketPrice.getDisableTicketPriceIdList = getDisableTicketPriceIdList$7;

function countTicketPricesByTicketing(ticketPriceList, selectedTicketPriceIdList) {
  var out = {};
  selectedTicketPriceIdList.forEach(function (selectedTicketPriceId) {
    var _getEntityId;
    var ticketPrice = findTicketPriceById(ticketPriceList, selectedTicketPriceId);
    if (!ticketPrice) {
      return out;
    }
    assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
    var ticketingId = (_getEntityId = getEntityId(ticketPrice.eventDate.ticketing)) !== null && _getEntityId !== void 0 ? _getEntityId : '';
    out[ticketingId] = out[ticketingId] ? out[ticketingId] + 1 : 1;
  });
  return out;
}
var getDisableTicketPriceIdList$6 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var ticketPriceNumberPerTicketing = countTicketPricesByTicketing(ticketPriceList, defaultSelectedTicketPriceIdList);
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var NPerTicketing = constraintList.NPerTicketing,
    NbTicket = constraintList.NbTicket;
  if (NPerTicketing && NPerTicketing.max) {
    // override if there is a `NPerTicketPrice` for those event dates
    ticketPriceList.forEach(function (ticketPrice) {
      var _getEntityId2;
      assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
      assertRelationIsDefined(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
      if (NPerTicketing.max && ticketPriceNumberPerTicketing[(_getEntityId2 = getEntityId(ticketPrice.eventDate.ticketing)) !== null && _getEntityId2 !== void 0 ? _getEntityId2 : ''] >= NPerTicketing.max) {
        var _ticketPrice$get;
        decoratedDisabledTicketPriceIdList.add((_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : '');
      }
    });
  }
  var minPerTicketing = NPerTicketing === null || NPerTicketing === void 0 ? void 0 : NPerTicketing.min;
  var maxNbTickets = NbTicket === null || NbTicket === void 0 ? void 0 : NbTicket.max;
  if (minPerTicketing && maxNbTickets) {
    // there should be not more that the maximum number of ticket / the minimum number of person
    var maxNumberOfDifferentTicketing = Math.ceil(maxNbTickets / minPerTicketing);
    if (Object.keys(ticketPriceNumberPerTicketing).length >= maxNumberOfDifferentTicketing) {
      ticketPriceList.forEach(function (ticketPrice) {
        var _getEntityId3;
        assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
        assertRelationIsDefined(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
        if (!(((_getEntityId3 = getEntityId(ticketPrice.eventDate.ticketing)) !== null && _getEntityId3 !== void 0 ? _getEntityId3 : '') in ticketPriceNumberPerTicketing)) {
          var _ticketPrice$get2;
          decoratedDisabledTicketPriceIdList.add((_ticketPrice$get2 = ticketPrice.get('@id')) !== null && _ticketPrice$get2 !== void 0 ? _ticketPrice$get2 : '');
        }
      });
    }
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from ticketing that already have more than max allowed per ticketing
 */
var withNPerTicketing = function withNPerTicketing(WrappedComponent) {
  function WithNPerTicketing(props) {
    var constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList,
      disabledTicketPriceIdList = props.disabledTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$6(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithNPerTicketing.displayName = "WithNPerTicketing(".concat(getDisplayName(WrappedComponent), ")");
  return WithNPerTicketing;
};
withNPerTicketing.getDisableTicketPriceIdList = getDisableTicketPriceIdList$6;

function countTicketPricesByVenue(ticketPriceList, selectedTicketPriceIdList) {
  var out = {};
  selectedTicketPriceIdList.forEach(function (selectedTicketPriceId) {
    var ticketPrice = findTicketPriceById(ticketPriceList, selectedTicketPriceId);
    if (!ticketPrice) {
      return out;
    }
    assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
    assertRelationIsObject(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
    var venueId = getEntityId(ticketPrice.eventDate.ticketing.venue);
    if (venueId) {
      out[venueId] = out[venueId] ? out[venueId] + 1 : 1;
    }
  });
  return out;
}
var getDisableTicketPriceIdList$5 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var ticketPriceNumberPerVenue = countTicketPricesByVenue(ticketPriceList, defaultSelectedTicketPriceIdList);
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var NPerVenue = constraintList.NPerVenue;
  if (NPerVenue && NPerVenue.max) {
    // override if there is a `NPerTicketPrice` for those event dates
    ticketPriceList.forEach(function (ticketPrice) {
      assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
      assertRelationIsObject(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
      var venueId = getEntityId(ticketPrice.eventDate.ticketing.venue);
      if (venueId && NPerVenue.max && ticketPriceNumberPerVenue[venueId] >= NPerVenue.max) {
        var _ticketPrice$get;
        decoratedDisabledTicketPriceIdList.add((_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : '');
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from venues that already have more than max allowed per venue
 */
var withNPerVenue = function withNPerVenue(WrappedComponent) {
  function WithNPerVenue(props) {
    var constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList,
      disabledTicketPriceIdList = props.disabledTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$5(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithNPerVenue.displayName = "WithNPerVenue(".concat(getDisplayName(WrappedComponent), ")");
  return WithNPerVenue;
};
withNPerVenue.getDisableTicketPriceIdList = getDisableTicketPriceIdList$5;

function countTicketPricesByDay(ticketPriceList, selectedTicketPriceIdList) {
  return selectedTicketPriceIdList.reduce(function (carry, selectedTicketPriceId) {
    var _getDayOfTicketPrice;
    var ticketPrice = findTicketPriceById(ticketPriceList, selectedTicketPriceId);
    if (!ticketPrice) {
      return carry;
    }
    var newCarry = carry;
    var day = (_getDayOfTicketPrice = getDayOfTicketPrice(ticketPrice)) !== null && _getDayOfTicketPrice !== void 0 ? _getDayOfTicketPrice : '';
    newCarry[day] = newCarry[day] ? newCarry[day] + 1 : 1;
    return newCarry;
  }, {});
}

/**
 * get the ticket price list for the same day as the previously selected ticket price only.
 * You may be interested in the `withSameDay` HOC too.
 */
function filterTicketPriceListForSameDay(ticketPriceList, previousStepsSelectedTicketPriceList, constraintList) {
  // do filter only for SameDay constraint
  if (constraintList.SameDay !== true) {
    return ticketPriceList;
  }
  if (previousStepsSelectedTicketPriceList.length === 0) {
    // no previously selected ticket price, we don't filter
    return ticketPriceList;
  }
  var selectedTicketPriceDaysList = previousStepsSelectedTicketPriceList.map(getDayOfTicketPrice);
  if (selectedTicketPriceDaysList.every(function (day) {
    return day === undefined;
  })) {
    // no previously selected ticket price with start date, we don't filter
    return ticketPriceList;
  }
  var filteredTicketPriceList = ticketPriceList.filter(function (ticketPrice) {
    var dayOfTicketPrice = getDayOfTicketPrice(ticketPrice);
    return selectedTicketPriceDaysList.includes(dayOfTicketPrice);
  });

  // return the filtered list only if there is more than one ticket price.
  // else return the full list, that will be disabled in `WithSameDay.getDisableTicketPriceIdList`
  return filteredTicketPriceList.length > 0 ? filteredTicketPriceList : ticketPriceList;
}
function getSelectedDayList(ticketPriceList, selectedTicketPriceIdList) {
  return Object.keys(countTicketPricesByDay(ticketPriceList, selectedTicketPriceIdList));
}
var getDisableTicketPriceIdList$4 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var SameDay = constraintList.SameDay;
  if (SameDay === true && defaultSelectedTicketPriceIdList.length > 0) {
    var selectedTicketPriceDaysList = getSelectedDayList(ticketPriceList, defaultSelectedTicketPriceIdList);

    // override if there is a `SameDay` for those ticket prices
    ticketPriceList.forEach(function (ticketPrice) {
      var ticketPriceId = ticketPrice['@id'];
      assertRelationIsDefined(ticketPriceId, 'ticketPrice.@id');
      var dayOfTicketprice = getDayOfTicketPrice(ticketPrice);
      if (!selectedTicketPriceDaysList.includes(dayOfTicketprice !== null && dayOfTicketprice !== void 0 ? dayOfTicketprice : '')) {
        decoratedDisabledTicketPriceIdList.add(ticketPriceId);
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from other day if
 * there is a "SameDay" constraint and if one ticket price is selected
 */
var withSameDay = function withSameDay(WrappedComponent) {
  function WithSameDay(props) {
    var disabledTicketPriceIdList = props.disabledTicketPriceIdList,
      constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList,
      previousStepsSelectedTicketPriceList = props.previousStepsSelectedTicketPriceList,
      globalConstraints = props.globalConstraints;
    var filteredTicketPriceList = filterTicketPriceListForSameDay(ticketPriceList, previousStepsSelectedTicketPriceList, globalConstraints !== null && globalConstraints !== void 0 ? globalConstraints : {});
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      ticketPriceList: filteredTicketPriceList,
      disabledTicketPriceIdList: getDisableTicketPriceIdList$4(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithSameDay.displayName = "WithSameDay(".concat(getDisplayName(WrappedComponent), ")");
  return WithSameDay;
};
withSameDay.getDisableTicketPriceIdList = getDisableTicketPriceIdList$4;

function getSelectedEventDateIdList(ticketPriceList, selectedTicketPriceIdList) {
  return Object.keys(countTicketPricesByEventDate(ticketPriceList, selectedTicketPriceIdList));
}
var getDisableTicketPriceIdList$3 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var SameEventDate = constraintList.SameEventDate;
  if (SameEventDate === true && defaultSelectedTicketPriceIdList.length > 0) {
    var selectedEventDateIdList = getSelectedEventDateIdList(ticketPriceList, defaultSelectedTicketPriceIdList);

    // override if there is a `SameEventDate` for those ticket prices
    ticketPriceList.forEach(function (ticketPrice) {
      var _getEntityId;
      assertRelationIsDefined(ticketPrice.eventDate, 'ticketPrice.eventDate');
      if (!selectedEventDateIdList.includes((_getEntityId = getEntityId(ticketPrice.eventDate)) !== null && _getEntityId !== void 0 ? _getEntityId : '')) {
        var _ticketPrice$get;
        decoratedDisabledTicketPriceIdList.add((_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : '');
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from other event date if
 * there is a "SameEventDate" constraint and if one ticket price is selected
 */
var withSameEventDate = function withSameEventDate(WrappedComponent) {
  function WithSameEventDate(props) {
    var disabledTicketPriceIdList = props.disabledTicketPriceIdList,
      constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$3(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithSameEventDate.displayName = "WithSameEventDate(".concat(getDisplayName(WrappedComponent), ")");
  return WithSameEventDate;
};
withSameEventDate.getDisableTicketPriceIdList = getDisableTicketPriceIdList$3;

var getDisableTicketPriceIdList$2 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var SameTicketPrice = constraintList.SameTicketPrice;
  if (SameTicketPrice === true && defaultSelectedTicketPriceIdList.length > 0) {
    var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
    var selectedHashList = getSelectedHashList(ticketPriceList, defaultSelectedTicketPriceIdList);

    // override if there is a `SameTicketPrice` for those ticket prices
    ticketPriceList.forEach(function (ticketPrice) {
      var ticketPriceId = ticketPrice['@id'];
      var ticketPriceHash = ticketPrice.hash;
      assertRelationIsDefined(ticketPriceId, 'ticketPrice.@id');
      assertHashIsValid(ticketPriceHash);
      if (!selectedHashList.includes(ticketPriceHash)) {
        decoratedDisabledTicketPriceIdList.add(ticketPriceId);
      }
    });
    return decoratedDisabledTicketPriceIdList;
  }
  return disabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from other ticket price if
 * there is a "SameTicketPrice" constraint and if one ticket price is selected
 */
var withSameTicketPrice = function withSameTicketPrice(WrappedComponent) {
  function WithSameTicketPrice(props) {
    var disabledTicketPriceIdList = props.disabledTicketPriceIdList,
      constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$2(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithSameTicketPrice.displayName = "WithSameTicketPrice(".concat(getDisplayName(WrappedComponent), ")");
  return WithSameTicketPrice;
};
withSameTicketPrice.getDisableTicketPriceIdList = getDisableTicketPriceIdList$2;

function getSelectedTicketingIdList(ticketPriceList, selectedTicketPriceIdList) {
  return Object.keys(countTicketPricesByTicketing(ticketPriceList, selectedTicketPriceIdList));
}
var getDisableTicketPriceIdList$1 = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var SameTicketing = constraintList.SameTicketing;
  if (SameTicketing === true && defaultSelectedTicketPriceIdList.length > 0) {
    var selectedTicketingIdList = getSelectedTicketingIdList(ticketPriceList, defaultSelectedTicketPriceIdList);

    // override if there is a `SameTicketing` for those ticket prices
    ticketPriceList.forEach(function (ticketPrice) {
      var _getEntityId;
      assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
      if (!selectedTicketingIdList.includes((_getEntityId = getEntityId(ticketPrice.eventDate.ticketing)) !== null && _getEntityId !== void 0 ? _getEntityId : '')) {
        var _ticketPrice$get;
        decoratedDisabledTicketPriceIdList.add((_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : '');
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from other ticketing if
 * there is a "SameTicketing" constraint and if one ticket price is selected
 */
var withSameTicketing = function withSameTicketing(WrappedComponent) {
  function WithSameTicketing(props) {
    var disabledTicketPriceIdList = props.disabledTicketPriceIdList,
      constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList$1(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithSameTicketing.displayName = "WithSameTicketing(".concat(getDisplayName(WrappedComponent), ")");
  return WithSameTicketing;
};
withSameTicketing.getDisableTicketPriceIdList = getDisableTicketPriceIdList$1;

function getSelectedVenueIdList(ticketPriceList, selectedTicketPriceIdList) {
  return Object.keys(countTicketPricesByVenue(ticketPriceList, selectedTicketPriceIdList));
}
var getDisableTicketPriceIdList = function getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  var decoratedDisabledTicketPriceIdList = new Set(disabledTicketPriceIdList);
  var SameVenue = constraintList.SameVenue;
  if (SameVenue === true && defaultSelectedTicketPriceIdList.length > 0) {
    var selectedTicketingIdList = getSelectedVenueIdList(ticketPriceList, defaultSelectedTicketPriceIdList);

    // override if there is a `SameVenue` for those ticket prices
    ticketPriceList.forEach(function (ticketPrice) {
      assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
      assertRelationIsObject(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
      assertRelationIsDefined(ticketPrice.eventDate.ticketing.venue, 'ticketPrice.eventDate.ticketing.venue');
      var venueId = getEntityId(ticketPrice.eventDate.ticketing.venue);
      var ticketPriceId = ticketPrice['@id'];
      assertRelationIsDefined(venueId, 'ticketPrice.eventDate.ticketing.venue.@id');
      assertRelationIsDefined(ticketPriceId, 'ticketPrice.@id');
      if (!selectedTicketingIdList.includes(venueId)) {
        decoratedDisabledTicketPriceIdList.add(ticketPriceId);
      }
    });
  }
  return decoratedDisabledTicketPriceIdList;
};

/**
 * This HOC automatically disable all ticket prices from other venue if
 * there is a "SameVenue" constraint and if one ticket price is selected
 */
var withSameVenue = function withSameVenue(WrappedComponent) {
  function WithSameVenue(props) {
    var disabledTicketPriceIdList = props.disabledTicketPriceIdList,
      constraintList = props.constraintList,
      ticketPriceList = props.ticketPriceList,
      defaultSelectedTicketPriceIdList = props.defaultSelectedTicketPriceIdList;
    return /*#__PURE__*/jsx(WrappedComponent, _objectSpread2(_objectSpread2({}, props), {}, {
      disabledTicketPriceIdList: getDisableTicketPriceIdList(disabledTicketPriceIdList, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList)
    }));
  }
  WithSameVenue.displayName = "WithSameVenue(".concat(getDisplayName(WrappedComponent), ")");
  return WithSameVenue;
};
withSameVenue.getDisableTicketPriceIdList = getDisableTicketPriceIdList;

var SellingDeviceIdContext = /*#__PURE__*/createContext(undefined);
function SellingDeviceIdContextProvider(_ref) {
  var sellingDeviceId = _ref.sellingDeviceId,
    children = _ref.children;
  return /*#__PURE__*/jsx(SellingDeviceIdContext.Provider, {
    value: sellingDeviceId,
    children: children
  });
}
function useSellingDeviceIdContext() {
  var sellingDeviceId = useContext(SellingDeviceIdContext);
  return sellingDeviceId;
}

function isTicketPricePickerAction(action) {
  var isImmutable = Map$1.isMap(action);

  // @ts-expect-error TODO delete this case when TS is migrated and everything checked
  var type = isImmutable ? action.get('type') : action.type;
  var ticketPriceList = isImmutable ? action.get('ticketPriceList') :
  // @ts-expect-error TODO delete this case when TS is migrated and everything checked
  action.ticketPriceList;
  var hasTicketPriceList = List.isList(ticketPriceList) && ticketPriceList.size > 0 || Array.isArray(ticketPriceList) && ticketPriceList.length > 0;
  return type === 'ticket_price_picker' && hasTicketPriceList;
}
function hasTicketPricePickerForActionList(actionList) {
  return actionList.some(isTicketPricePickerAction);
}
function getTicketingSchedule(ticketing, sellingDeviceId, locale) {
  return ticketing.getIn(['sellingDeviceSchedule', sellingDeviceId, locale]) || ticketing.getIn(['sellingDeviceSchedule', sellingDeviceId, 'fr']) || '';
}

/**
 * Get the number of selected ticket price per ticket price id
 */
function countSelectedTicketPrices(allSelectedTicketPriceIdList) {
  return allSelectedTicketPriceIdList.reduce(function (acc, id) {
    if (id in acc) {
      acc[id] += 1;
    } else {
      acc[id] = 1;
    }
    return acc;
  }, {});
}

/**
 * Get the number of selected ticket price per event date
 *
 * @returns Map<EventDate, number> A Map with the event date as key and the number of selected ticket price as value
 */
function countSelectedEventDates(allSelectedTicketPriceIdList, indexedTicketPriceList) {
  return List(allSelectedTicketPriceIdList)
  // get a list of selected event date instance
  .map(function (ticketPriceId) {
    var ticketPrice = indexedTicketPriceList[ticketPriceId];
    assertRelationIsObject(ticketPrice.eventDate, 'eventDate');
    return ticketPrice.eventDate;
  })

  // group by event date instance
  .groupBy(function (eventDate) {
    return eventDate;
  })
  // and count the number of selected items
  .map(function (eventDateList) {
    return eventDateList.size;
  });
}
function getMaxSubscriptionQuantity(indexedTicketPriceList, allSelectedTicketPriceIdList) {
  var maxQuantity = null;

  // handle ticket price stock limit
  var selectedTicketPricePerId = countSelectedTicketPrices(allSelectedTicketPriceIdList);
  Object.entries(selectedTicketPricePerId).forEach(function (_ref) {
    var _ref2 = _slicedToArray$1(_ref, 2),
      ticketPriceId = _ref2[0],
      nbItemInSubscription = _ref2[1];
    var ticketPrice = indexedTicketPriceList[ticketPriceId];
    if (ticketPrice) {
      var ticketPriceBookableStock = ticketPrice.bookableStock;

      // handle stock limit on ticket price
      if (ticketPriceBookableStock !== null) {
        var newMaxQuantity = Math.floor(ticketPriceBookableStock / nbItemInSubscription);
        if (maxQuantity === null || newMaxQuantity < maxQuantity) {
          maxQuantity = newMaxQuantity;
        }
      }
    }
  });

  // handle event date stock limit
  var selectedEventDatePerId = countSelectedEventDates(allSelectedTicketPriceIdList, indexedTicketPriceList);
  selectedEventDatePerId.entrySeq().forEach(function (_ref3) {
    var _ref4 = _slicedToArray$1(_ref3, 2),
      eventDate = _ref4[0],
      nbItemInSubscription = _ref4[1];
    // handle stock limit on event date
    if (eventDate.notInStockContingentBookableStock !== null) {
      var newMaxQuantity = Math.floor(eventDate.notInStockContingentBookableStock / nbItemInSubscription);
      if (maxQuantity === null || newMaxQuantity < maxQuantity) {
        maxQuantity = newMaxQuantity;
      }
    }
  });
  return maxQuantity;
}

var IMG_SIZE = 70;
function TicketingBlock(_ref) {
  var _ticketing$title;
  var ticketing = _ref.ticketing,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nbTicketsSelecte = _ref.nbTicketsSelected,
    nbTicketsSelected = _ref$nbTicketsSelecte === void 0 ? null : _ref$nbTicketsSelecte,
    setOpenedTicketing = _ref.setOpenedTicketing,
    isOpen = _ref.isOpen;
  var sellingDeviceId = useSellingDeviceIdContext();
  var firstImage = ticketing.imageList ? ticketing.imageList.first() : null;
  var ticketingTile = (_ticketing$title = ticketing.title) !== null && _ticketing$title !== void 0 ? _ticketing$title : '';
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("div", {
      className: "ticketing-block-line-container",
      onClick: function onClick() {
        return setOpenedTicketing(isOpen ? null : ticketing.get('@id'));
      }
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      ,
      onKeyDown: function onKeyDown() {},
      role: "button",
      tabIndex: 0,
      children: [/*#__PURE__*/jsxs("div", {
        className: "flex-row",
        children: [/*#__PURE__*/jsxs("span", {
          className: cn('image-container', {
            'image-container--active': nbTicketsSelected
          }),
          children: [/*#__PURE__*/jsx("span", {
            children: nbTicketsSelected
          }), firstImage && /*#__PURE__*/jsx("img", {
            title: ticketingTile,
            alt: ticketingTile,
            width: IMG_SIZE,
            height: IMG_SIZE,
            src: buildUrl(firstImage, IMG_SIZE, IMG_SIZE),
            loading: "lazy"
          })]
        }), /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("span", {
            className: "h3-like",
            children: ticketingTile
          }), sellingDeviceId && /*#__PURE__*/jsx("div", {
            className: "txt-like small",
            children: getTicketingSchedule(ticketing, sellingDeviceId, getLocale())
          })]
        })]
      }), /*#__PURE__*/jsx(MpdIcon, {
        icon: isOpen ? 'arrow-down' : 'arrow-right',
        width: "20",
        height: "20",
        className: "mpd-color-blue"
      })]
    }), isOpen && children]
  });
}

function TicketingPriceSummaryLine(_ref) {
  var _ticketPrice$get;
  var ticketPrice = _ref.ticketPrice,
    onChange = _ref.onChange,
    count = _ref.count,
    disabledTicketPriceIdList = _ref.disabledTicketPriceIdList,
    getTicketPriceBookableStock = _ref.getTicketPriceBookableStock,
    children = _ref.children,
    ticketPriceChildren = _ref.ticketPriceChildren,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate;
  var eventDate = ticketPrice.eventDate,
    onSale = ticketPrice.onSale;
  assertRelationIsObject(eventDate, 'eventDate');
  var bookableStock = getTicketPriceBookableStock(ticketPrice);
  var isDisabled = !onSale && !canSellOnHoldOrScheduledEventDate;
  var canAddMore = !isDisabled && (bookableStock === null || bookableStock > 0);
  var countClasses = cn('ticket-price-count', {
    active: count > 0,
    disabled: isDisabled
  });
  return /*#__PURE__*/jsxs("div", {
    className: "ticketing-price-summary-line",
    children: [/*#__PURE__*/jsxs("div", {
      className: "ticketing-price-summary-line__ticket-price",
      children: [/*#__PURE__*/jsx("button", {
        type: "button",
        className: "mpd-btn mpd-btn--icon-only",
        onClick: function onClick() {
          return onChange(ticketPrice, false);
        },
        disabled: isDisabled,
        children: /*#__PURE__*/jsx(MpdIcon, {
          icon: "minus-stroke",
          width: "18",
          height: "18"
        })
      }), /*#__PURE__*/jsx("span", {
        className: countClasses,
        children: count
      }), /*#__PURE__*/jsx("button", {
        type: "button",
        className: "mpd-btn mpd-btn--icon-only",
        onClick: function onClick() {
          return onChange(ticketPrice, true);
        },
        disabled: !canAddMore || disabledTicketPriceIdList.has((_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : ''),
        children: /*#__PURE__*/jsx(MpdIcon, {
          icon: "plus-stroke",
          width: "18",
          height: "18"
        })
      }), ticketPriceChildren]
    }), children]
  });
}

function groupTicketPricesByEventDate(ticketPriceArray) {
  return List(ticketPriceArray).groupBy(function (ticketPrice) {
    return getEntityId(ticketPrice.eventDate);
  }).map(function (ticketPriceList) {
    var first = ticketPriceList.first();
    assertRelationIsObject(first.eventDate, 'ticketPrice.eventDate');
    return {
      eventDate: first.eventDate,
      ticketPriceArray: ticketPriceList.toArray()
    };
  }).valueSeq().toArray();
}

var BOOKABLE_STOCK_THRESHOLD = 10;
function DeskTicketPricePicker(_ref) {
  var ticketing = _ref.ticketing,
    ticketPriceList = _ref.ticketPriceList,
    onChange = _ref.onChange,
    _setOpenedTicketing = _ref.setOpenedTicketing,
    isOpen = _ref.isOpen,
    selectedTicketPriceIdListForTicketing = _ref.selectedTicketPriceIdListForTicketing,
    getTicketPriceBookableStock = _ref.getTicketPriceBookableStock,
    _ref$disabledTicketPr = _ref.disabledTicketPriceIdList,
    disabledTicketPriceIdList = _ref$disabledTicketPr === void 0 ? new Set() : _ref$disabledTicketPr,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var groups = groupTicketPricesByEventDate(ticketPriceList);
  return /*#__PURE__*/jsx(TicketingBlock, {
    ticketing: ticketing,
    nbTicketsSelected: (selectedTicketPriceIdListForTicketing === null || selectedTicketPriceIdListForTicketing === void 0 ? void 0 : selectedTicketPriceIdListForTicketing.size) || null,
    setOpenedTicketing: function setOpenedTicketing() {
      return _setOpenedTicketing(isOpen ? null : ticketing.get('@id'));
    },
    isOpen: isOpen,
    children: groups.map(function (group) {
      var _group$eventDate$get;
      var eventDateId = (_group$eventDate$get = group.eventDate.get('@id')) !== null && _group$eventDate$get !== void 0 ? _group$eventDate$get : '';
      return /*#__PURE__*/jsxs("div", {
        className: "ticketprice-picker-eventdate-group",
        children: [/*#__PURE__*/jsx("div", {
          className: "ticketprice-picker-eventdate-group-header",
          children: /*#__PURE__*/jsx("span", {
            children: group.eventDate.startDate && moment(group.eventDate.startDate).format('LLLL')
          })
        }), group.ticketPriceArray.map(function (ticketPrice) {
          var count = selectedTicketPriceIdListForTicketing.filter(function (id) {
            return ticketPrice.get('@id') === id;
          }).size;
          return /*#__PURE__*/jsx(Fragment$1, {
            children: isOpen && /*#__PURE__*/jsx(TicketingPriceSummaryLine, {
              ticketPrice: ticketPrice,
              onChange: onChange,
              count: count,
              disabledTicketPriceIdList: disabledTicketPriceIdList,
              getTicketPriceBookableStock: getTicketPriceBookableStock,
              canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate,
              ticketPriceChildren: /*#__PURE__*/jsxs("div", {
                className: "eventdate",
                children: [/*#__PURE__*/jsx("span", {
                  className: "ticketprice-picker-left-ticketprice-name",
                  children: ticketPrice.name
                }), !!ticketPrice.bookableStock && ticketPrice.bookableStock < BOOKABLE_STOCK_THRESHOLD && /*#__PURE__*/jsx("span", {
                  className: "bold",
                  children: t('offer.ticket_price.bookable_stock_left', {
                    count: ticketPrice.bookableStock
                  })
                })]
              })
            }, ticketPrice.get('@id'))
          }, ticketPrice.get('@id'));
        })]
      }, eventDateId);
    })
  });
}

/**
 * Make the first letter of a string uppercase and the rest lowercase
 *
 * Usage :
 *
 * ```js
 * import { capitalize } from '@mapado/js-component';
 *
 * capitalize('uNiTeD StAtE');
 * ```
 *
 * @return some capitalized string
 */
function capitalize(string) {
  var out = string.toLowerCase();
  return out.charAt(0).toUpperCase() + out.substring(1);
}
function upperFirst(string) {
  return string.charAt(0).toUpperCase() + string.substring(1);
}
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function FormattedDateForStartAndEndDate(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? FORMATTED_DATE_FORMAT.LONG : _ref$format,
    _ref$capitalizeDate = _ref.capitalizeDate,
    capitalizeDate = _ref$capitalizeDate === void 0 ? false : _ref$capitalizeDate;
  // do use translation hook to get the translation function
  // do not use Suspense and fallback to an empty string. The translation should work on server side and when client download the translations
  // This might display a warning in the console: "Did not expect server HTML to contain the text node "lundi 28 février 2022 à 18:51" in <div>."
  // but this will work fine and be SEO friendly
  var _useTranslation = useTranslation(undefined, {
      useSuspense: false
    }),
    t = _useTranslation.t,
    ready = _useTranslation.ready;
  if (!ready) {
    return null;
  }
  var out = getFormattedDateForStartAndEndDate(startDate, endDate, format, t);
  var outCapitalized = capitalize(out);

  // keep the fragment to avoid issue with `Node.removeChild`
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/jsx(Fragment, {
    children: capitalizeDate ? outCapitalized : out
  });
}

function EventDateBlock(_ref) {
  var eventDate = _ref.eventDate,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx("span", {
    className: "block ".concat(className),
    children: /*#__PURE__*/jsx("span", {
      children: /*#__PURE__*/jsx(FormattedDateForStartAndEndDate, {
        startDate: eventDate.startDate,
        endDate: eventDate.endDate
      })
    })
  });
}

function Fee(_ref) {
  var ticketPrice = _ref.ticketPrice;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (ticketPrice.hideFees !== false) {
    return null;
  }
  return /*#__PURE__*/jsx("span", {
    className: "smaller",
    children: t('ticketing.ticket.mapado_fee_no_amount')
  });
}

function FrontTicketPricePicker(_ref) {
  var ticketing = _ref.ticketing,
    ticketPriceList = _ref.ticketPriceList,
    onChange = _ref.onChange,
    setOpenedTicketing = _ref.setOpenedTicketing,
    isOpen = _ref.isOpen,
    selectedTicketPriceIdListForTicketing = _ref.selectedTicketPriceIdListForTicketing,
    getTicketPriceBookableStock = _ref.getTicketPriceBookableStock,
    _ref$disabledTicketPr = _ref.disabledTicketPriceIdList,
    disabledTicketPriceIdList = _ref$disabledTicketPr === void 0 ? new Set() : _ref$disabledTicketPr,
    _ref$displayEventDate = _ref.displayEventDateBlock,
    displayEventDateBlock = _ref$displayEventDate === void 0 ? true : _ref$displayEventDate,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var groups = groupTicketPricesByEventDate(ticketPriceList);
  return /*#__PURE__*/jsx(TicketingBlock, {
    ticketing: ticketing,
    nbTicketsSelected: (selectedTicketPriceIdListForTicketing === null || selectedTicketPriceIdListForTicketing === void 0 ? void 0 : selectedTicketPriceIdListForTicketing.size) || null,
    setOpenedTicketing: setOpenedTicketing,
    isOpen: isOpen,
    children: groups.map(function (group) {
      var _group$eventDate$get;
      var eventDateId = (_group$eventDate$get = group.eventDate.get('@id')) !== null && _group$eventDate$get !== void 0 ? _group$eventDate$get : '';
      return /*#__PURE__*/jsxs("div", {
        className: "ticketprice-picker-eventdate-group",
        children: [/*#__PURE__*/jsx("div", {
          className: "ticketprice-picker-eventdate-group-header",
          children: /*#__PURE__*/jsx(EventDateBlock, {
            eventDate: group.eventDate
          })
        }), group.ticketPriceArray.map(function (ticketPrice) {
          var eventDate = ticketPrice.eventDate,
            currency = ticketPrice.currency;
          assertRelationIsObject(eventDate, 'eventDate');
          var count = selectedTicketPriceIdListForTicketing.filter(function (id) {
            return ticketPrice.get('@id') === id;
          }).size;
          return /*#__PURE__*/jsx(TicketingPriceSummaryLine, {
            ticketPrice: ticketPrice,
            onChange: onChange,
            count: count,
            disabledTicketPriceIdList: disabledTicketPriceIdList,
            getTicketPriceBookableStock: getTicketPriceBookableStock,
            canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate,
            ticketPriceChildren: displayEventDateBlock && /*#__PURE__*/jsxs("div", {
              className: "eventdate",
              children: [/*#__PURE__*/jsx("span", {
                className: "ticketprice-picker-left-ticketprice-name",
                children: ticketPrice.name
              }), !ticketPrice.onSale && !canSellOnHoldOrScheduledEventDate && /*#__PURE__*/jsx("span", {
                className: "bold",
                children: t('ticketing.unavailable')
              }), (ticketPrice.onSale || canSellOnHoldOrScheduledEventDate) && !!ticketPrice.onlineMaxQuantityPerCart && /*#__PURE__*/jsx("span", {
                className: "bold",
                children: t('offer.ticket_price.limited_quantity', {
                  quantity: ticketPrice.onlineMaxQuantityPerCart
                })
              })]
            }),
            children: /*#__PURE__*/jsxs("div", {
              className: "ticketing-price-name",
              children: [!!ticketPrice.facialValue && ticketPrice.facialValue > 0 && /*#__PURE__*/jsx("span", {
                className: "bold",
                children: formatPrice(ticketPrice.facialValue, currency)
              }), ticketPrice.facialValue === 0 && ticketPrice.isPriceDisplayed !== false && /*#__PURE__*/jsx("span", {
                className: "bold",
                children: t('ticketing.free_price')
              }), /*#__PURE__*/jsx(Fee, {
                ticketPrice: ticketPrice
              })]
            })
          }, ticketPrice.get('@id'));
        })]
      }, eventDateId);
    })
  });
}

var SORT_BY_DATE = 'SORT_BY_DATE';
var SORT_BY_ALPHABETICAL = 'SORT_BY_ALPHABETICAL';
var TicketPricePicker = /*#__PURE__*/function (_PureComponent) {
  function TicketPricePicker(props) {
    var _localStorage;
    var _this;
    _classCallCheck$3(this, TicketPricePicker);
    _this = _callSuper$1(this, TicketPricePicker, [props]);
    _defineProperty$5(_this, "debouncedHandleSearch", void 0);
    _this.state = {
      selectedTicketPriceIdList: List(props.defaultSelectedTicketPriceIdList),
      openedTicketing: null,
      search: '',
      sortBy: ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('TicketPricePricer-sortBy')) || SORT_BY_ALPHABETICAL
    };
    _this.debouncedHandleSearch = debounce(_this.handleSearch.bind(_this), 100);
    _this.handleCancelButtonClick = _this.handleCancelButtonClick.bind(_this);
    _this.handleConfirmButtonClick = _this.handleConfirmButtonClick.bind(_this);
    _this.handleTicketPriceCheckedChanged = _this.handleTicketPriceCheckedChanged.bind(_this);
    _this.canConfirm = _this.canConfirm.bind(_this);
    _this.getEventDateList = _this.getEventDateList.bind(_this);
    _this.getTicketPriceList = _this.getTicketPriceList.bind(_this);
    _this.setOpenedTicketing = _this.setOpenedTicketing.bind(_this);
    _this.handleSortByDateChange = _this.handleSortByDateChange.bind(_this);
    _this.getTicketPriceBookableStock = _this.getTicketPriceBookableStock.bind(_this);
    return _this;
  }
  _inherits$1(TicketPricePicker, _PureComponent);
  return _createClass$3(TicketPricePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        defaultSelectedTicketPriceIdList = _this$props.defaultSelectedTicketPriceIdList;
      if (typeof onChange === 'function' && (defaultSelectedTicketPriceIdList === null || defaultSelectedTicketPriceIdList === void 0 ? void 0 : defaultSelectedTicketPriceIdList.length) > 0) {
        onChange(defaultSelectedTicketPriceIdList);
      }
      this.openTicketingIfSingle();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ticketPriceList = this.props.ticketPriceList;
      if (prevProps.ticketPriceList !== ticketPriceList) {
        this.openTicketingIfSingle();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.debouncedHandleSearch.clear();
    }
  }, {
    key: "getTicketingList",
    value: function getTicketingList() {
      var _this$props2 = this.props,
        ticketPriceList = _this$props2.ticketPriceList,
        canSellOnHoldOrScheduledEventDate = _this$props2.canSellOnHoldOrScheduledEventDate;
      return Object.values(ticketPriceList.reduce(function (carry, ticketPrice) {
        var _ticketing$get;
        assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
        var ticketing = ticketPrice.eventDate.ticketing;
        assertRelationIsObject(ticketing, 'ticketPrice.eventDate.ticketing');
        if (!ticketing.get('isOnSale') && !canSellOnHoldOrScheduledEventDate) {
          return carry;
        }
        var id = (_ticketing$get = ticketing.get('@id')) !== null && _ticketing$get !== void 0 ? _ticketing$get : '';
        if (!carry[id]) {
          // eslint-disable-next-line no-param-reassign
          carry[id] = ticketing;
        }
        return carry;
      }, {}));
    }

    /**
     * @return {EventDate[]} a list of event date for the current ticketing
     */
  }, {
    key: "getEventDateList",
    value: function getEventDateList(ticketing) {
      var _this$props3 = this.props,
        ticketPriceList = _this$props3.ticketPriceList,
        canSellOnHoldOrScheduledEventDate = _this$props3.canSellOnHoldOrScheduledEventDate;
      var ticketingId = ticketing.get('@id');
      var eventDateList = Object.values(ticketPriceList.reduce(function (carry, ticketPrice) {
        var _eventDate$get;
        var eventDate = ticketPrice.eventDate;
        assertRelationIsObject(eventDate, 'ticketPrice.eventDate');
        assertRelationIsObject(eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
        var id = (_eventDate$get = eventDate.get('@id')) !== null && _eventDate$get !== void 0 ? _eventDate$get : '';
        if (!carry[id] && eventDate.ticketing.get('@id') === ticketingId) {
          // eslint-disable-next-line no-param-reassign
          carry[id] = eventDate;
        }
        return carry;
      }, {}));
      return eventDateList.filter(function (eventDate) {
        return eventDate.onSale || canSellOnHoldOrScheduledEventDate;
      }).sort(compareEventDatesDate);
    }
  }, {
    key: "getTicketPriceList",
    value: function getTicketPriceList(eventDate) {
      var ticketPriceList = this.props.ticketPriceList;
      var eventDateId = eventDate.get('@id');
      return ticketPriceList.filter(function (ticketPrice) {
        return eventDateId === ticketPrice.getIn(['eventDate', '@id']);
      }).sort(compareTicketPrices);
    }

    /**
     * Get the live bookable stock for a ticket price.
     * If other ticket prices from the same event date are selected, the bookable stock is updated.
     */
  }, {
    key: "getTicketPriceBookableStock",
    value: function getTicketPriceBookableStock(ticketPrice) {
      var selectedTicketPriceIdList = this.state.selectedTicketPriceIdList;
      // count the number of selected ticket prices for the current ticket price
      var currentSelectedTicketPriceCount = selectedTicketPriceIdList.filter(function (tpId) {
        var _ticketPrice$Id;
        return ((_ticketPrice$Id = ticketPrice['@id']) !== null && _ticketPrice$Id !== void 0 ? _ticketPrice$Id : '') === tpId;
      }).size;
      var bookableStock = ticketPrice.bookableStock;
      var ticketPriceBookableStock = bookableStock;
      if (ticketPriceBookableStock === null) {
        // no limit on ticket price stock : just return null
        return null;
      }
      var ticketPriceRemainingBookableStock = ticketPriceBookableStock - currentSelectedTicketPriceCount;
      return ticketPriceRemainingBookableStock;
    }
  }, {
    key: "setOpenedTicketing",
    value: function setOpenedTicketing(ticketingId) {
      this.setState({
        openedTicketing: ticketingId
      });
    }
  }, {
    key: "getFilteredTicketingList",
    value: function getFilteredTicketingList() {
      var _this$state = this.state,
        search = _this$state.search,
        sortBy = _this$state.sortBy;
      var ticketingList = this.getTicketingList().map(function (ticketing) {
        return sortBy === SORT_BY_DATE ? sortTicketingEventDateList(ticketing) : ticketing;
      }).sort(sortBy === SORT_BY_DATE ? compareTicketingByFirstEventDateDate : compareTicketing);
      var filteredTicketingList = ticketingList;
      if (search) {
        var options = {
          shouldSort: true,
          keys: ['title']
        };
        var fuse = new Fuse(filteredTicketingList, options);
        return fuse.search(search);
      }
      return filteredTicketingList;
    }
  }, {
    key: "openTicketingIfSingle",
    value: function openTicketingIfSingle() {
      var ticketingIdList = this.getTicketingList();
      if (ticketingIdList.length === 1) {
        this.setState({
          openedTicketing: ticketingIdList[0].get('@id')
        });
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "handleTicketPriceCheckedChanged",
    value: function handleTicketPriceCheckedChanged(ticketPrice) {
      var _this2 = this;
      var isAddTicket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props4 = this.props,
        onChange = _this$props4.onChange,
        max = _this$props4.max;
      var selectedTicketPriceIdList = this.state.selectedTicketPriceIdList;
      if (!isAddTicket && selectedTicketPriceIdList.size === 0) {
        return;
      }
      this.setState(function (prevState) {
        var _ticketPrice$get;
        var ticketPriceIdList = max === 1 ? List() : prevState.selectedTicketPriceIdList;
        var ticketPriceId = (_ticketPrice$get = ticketPrice.get('@id')) !== null && _ticketPrice$get !== void 0 ? _ticketPrice$get : '';
        var newSelectedTicketPriceIdSet;
        if (isAddTicket) {
          newSelectedTicketPriceIdSet = ticketPriceIdList.push(ticketPriceId);
        } else {
          var index = ticketPriceIdList.findIndex(function (item) {
            return item === ticketPriceId;
          });
          newSelectedTicketPriceIdSet = index > -1 ? ticketPriceIdList.delete(index) : ticketPriceIdList;
        }
        return {
          selectedTicketPriceIdList: newSelectedTicketPriceIdSet
        };
      }, function () {
        // Call onChange once the state has been set
        if (onChange) {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(_this2.state.selectedTicketPriceIdList.toArray());
        }
      });
    }
  }, {
    key: "handleCancelButtonClick",
    value: function handleCancelButtonClick(event) {
      event.preventDefault();
      var onCancel = this.props.onCancel;
      if (onCancel) {
        onCancel();
      }
    }
  }, {
    key: "canConfirm",
    value: function canConfirm() {
      var isSelectedTicketPriceListValid = this.props.isSelectedTicketPriceListValid;
      var selectedTicketPriceIdList = this.state.selectedTicketPriceIdList;
      return isSelectedTicketPriceListValid(selectedTicketPriceIdList);
    }
  }, {
    key: "handleConfirmButtonClick",
    value: function handleConfirmButtonClick(event) {
      event.preventDefault();
      var onConfirm = this.props.onConfirm;
      var selectedTicketPriceIdList = this.state.selectedTicketPriceIdList;
      var ticketPriceIdList = selectedTicketPriceIdList.toArray();
      if (onConfirm && this.canConfirm()) {
        onConfirm(ticketPriceIdList);
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(value) {
      this.setState({
        search: value
      });
    }
  }, {
    key: "handleSortByDateChange",
    value: function handleSortByDateChange(option) {
      var value = option === null || option === void 0 ? void 0 : option.value;
      if (!value) {
        return;
      }
      this.setState({
        sortBy: value
      }, function () {
        // store value in local storage
        localStorage.setItem('TicketPricePricer-sortBy', value);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props5 = this.props,
        getErrorMessageList = _this$props5.getErrorMessageList,
        displayEventDateBlock = _this$props5.displayEventDateBlock,
        isFront = _this$props5.isFront,
        onCancel = _this$props5.onCancel,
        onConfirm = _this$props5.onConfirm,
        disabledTicketPriceIdList = _this$props5.disabledTicketPriceIdList,
        t = _this$props5.t,
        canSellOnHoldOrScheduledEventDate = _this$props5.canSellOnHoldOrScheduledEventDate,
        hideErrorMessages = _this$props5.hideErrorMessages,
        hideButtons = _this$props5.hideButtons;
      var _this$state2 = this.state,
        selectedTicketPriceIdList = _this$state2.selectedTicketPriceIdList,
        openedTicketing = _this$state2.openedTicketing,
        sortBy = _this$state2.sortBy;
      var errorMessageList = getErrorMessageList(selectedTicketPriceIdList);
      var ticketingList = this.getFilteredTicketingList();
      var sortByOptions = [{
        label: t('ticketing.session.price_list_to_use.filter.by.alpha'),
        value: SORT_BY_ALPHABETICAL
      }, {
        label: t('ticketing.session.price_list_to_use.filter.by.date'),
        value: SORT_BY_DATE
      }];
      var selectedSortOption = sortByOptions.find(function (opt) {
        return opt.value === sortBy;
      }) || null;
      return /*#__PURE__*/jsxs(Fragment, {
        children: [!hideErrorMessages && /*#__PURE__*/jsx(ErrorMessageList, {
          errorMessageList: errorMessageList,
          className: "txtcenter"
        }), /*#__PURE__*/jsx(MpdFilters, {
          className: "mb4",
          placeholder: t('ticketing.session.price_list_to_use.filter.title'),
          onChange: this.debouncedHandleSearch,
          sortElement: /*#__PURE__*/jsx(MpdSingleSelect, {
            isBorderless: true,
            value: selectedSortOption,
            onChange: this.handleSortByDateChange,
            options: sortByOptions,
            placeholder: t('ticketing.session.price_list_to_use.filter.by.title')
          })
        }), /*#__PURE__*/jsx("div", {
          className: cn(ticketingList.length > 3 && 'TicketPricePicker__ticketingBlockListScroll'),
          children: ticketingList.map(function (ticketing) {
            var ticketPriceList = _this3.getEventDateList(ticketing).flatMap(_this3.getTicketPriceList);
            var isOpen = openedTicketing === ticketing.get('@id');
            var selectedTicketPriceIdListForTicketing = selectedTicketPriceIdList.filter(function (tpId) {
              return ticketPriceList.find(function (tp) {
                return tp.get('@id') === tpId;
              });
            });
            if (isFront) {
              return /*#__PURE__*/jsx(FrontTicketPricePicker, {
                ticketing: ticketing,
                ticketPriceList: ticketPriceList,
                onChange: _this3.handleTicketPriceCheckedChanged,
                setOpenedTicketing: _this3.setOpenedTicketing,
                isOpen: isOpen,
                selectedTicketPriceIdListForTicketing: selectedTicketPriceIdListForTicketing,
                disabledTicketPriceIdList: disabledTicketPriceIdList,
                displayEventDateBlock: displayEventDateBlock,
                getTicketPriceBookableStock: _this3.getTicketPriceBookableStock,
                canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate
              }, ticketing.get('@id'));
            }
            return /*#__PURE__*/jsx(DeskTicketPricePicker, {
              ticketing: ticketing,
              ticketPriceList: ticketPriceList,
              onChange: _this3.handleTicketPriceCheckedChanged,
              setOpenedTicketing: _this3.setOpenedTicketing,
              isOpen: isOpen,
              selectedTicketPriceIdListForTicketing: selectedTicketPriceIdListForTicketing,
              disabledTicketPriceIdList: disabledTicketPriceIdList,
              getTicketPriceBookableStock: _this3.getTicketPriceBookableStock,
              canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate
            }, ticketing.get('@id'));
          })
        }), !hideErrorMessages && /*#__PURE__*/jsx(ErrorMessageList, {
          errorMessageList: errorMessageList,
          className: "txtcenter"
        }), !hideButtons && /*#__PURE__*/jsxs("div", {
          className: "txtright mt2",
          children: [onCancel && /*#__PURE__*/jsx("button", {
            type: "button",
            className: "mpd-btn mpd-btn--secondary",
            onClick: this.handleCancelButtonClick,
            children: t('cancel')
          }), onConfirm && /*#__PURE__*/jsx("button", {
            type: "button",
            className: "mpd-btn mpd-btn--primary",
            onClick: this.handleConfirmButtonClick,
            disabled: !this.canConfirm(),
            children: t('validate')
          })]
        })]
      });
    }
  }]);
}(PureComponent);
_defineProperty$5(TicketPricePicker, "defaultProps", {
  max: null,
  onCancel: null,
  onConfirm: null,
  onChange: null,
  isFront: false,
  displayEventDateBlock: true,
  hideErrorMessages: false,
  hideButtons: false
});
 //  withTranslation()(TicketPricePicker);

var TICKET_PRICE_PICKER_DECORATOR_LIST = [withMandatoryTicketPriceList, withMaxTicketPriceList, withMinTicketPriceList, withMinTicketPriceListAndDifferentSelector, withNPerTicketPrice, withNPerEventDate, withNPerVenue, withNPerTicketing, withSameTicketPrice, withSameDay, withSameEventDate, withSameTicketing, withSameVenue, withCompanionBuyable, withEventDateFilter];

// apply all decorators, same as `withA(withB(withC(TicketPricePicker)))`
var EnhancedTicketPriceList = TICKET_PRICE_PICKER_DECORATOR_LIST.reduce(function (carry, fn) {
  return fn.call(null, carry);
}, TicketPricePicker);
var TicketPricePickerWithConstraints = /*#__PURE__*/function (_PureComponent) {
  function TicketPricePickerWithConstraints() {
    _classCallCheck$3(this, TicketPricePickerWithConstraints);
    return _callSuper$1(this, TicketPricePickerWithConstraints, arguments);
  }
  _inherits$1(TicketPricePickerWithConstraints, _PureComponent);
  return _createClass$3(TicketPricePickerWithConstraints, [{
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        // @ts-expect-error issue with `onCancel`, `max`, `displayEventDateBlock` and `t` props. Do not know why. Possibly unused, but works at runtime.
        jsx(EnhancedTicketPriceList
        // eslint-disable-next-line react/jsx-props-no-spreading
        , _objectSpread2(_objectSpread2({}, this.props), {}, {
          canChangeTicketPriceToCheckedState: function canChangeTicketPriceToCheckedState() {
            return true;
          },
          getErrorMessageList: function getErrorMessageList() {
            return [];
          },
          isSelectedTicketPriceListValid: function isSelectedTicketPriceListValid() {
            return true;
          }
        }))
      );
    }
  }]);
}(PureComponent);

var CONNECTOR = /*#__PURE__*/function (CONNECTOR) {
  CONNECTOR["AND"] = "AND";
  CONNECTOR["OR"] = "OR";
  return CONNECTOR;
}({});
var CONNECTOR_AND = CONNECTOR.AND;
var CONNECTOR_OR = CONNECTOR.OR;

var OVERVIEW_TAB = 'overview';
function Navigation(_ref) {
  var actionList = _ref.actionList,
    connector = _ref.connector,
    _onChange = _ref.onChange,
    _ref$selectedIndex = _ref.selectedIndex,
    selectedIndex = _ref$selectedIndex === void 0 ? null : _ref$selectedIndex;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (selectedIndex === null) {
    if (connector === CONNECTOR_OR) {
      return /*#__PURE__*/jsx("div", {
        className: "txtcenter",
        children: actionList.map(function (action, index) {
          return /*#__PURE__*/jsx("button", {
            type: "button",
            className: "mpd-btn mpd-btn--secondary",
            onClick: function onClick() {
              return _onChange(index);
            },
            children: action.get('name') || t('ticket_price_picker.offer.navigation.option', {
              index: index + 1
            })
          });
        })
      });
    }
    throw new Error('Navigation with connector "AND" must have a non-null selectedIndex');
  }
  return /*#__PURE__*/jsx("section", {
    className: "mpd-tabs mpd-tabs--offer-ticket-price-picker",
    children: /*#__PURE__*/jsxs("div", {
      className: "mpd-tabs__tab-container",
      children: [actionList.map(function (action, index) {
        // disable the tab if the index is greater than the selected index in "AND" offers
        // disable all indexes if the selected index is "overview"
        var isDisabled = selectedIndex === OVERVIEW_TAB || connector === CONNECTOR_AND && index > selectedIndex;
        return /*#__PURE__*/jsxs("div", {
          className: cn('mpd-tabs__tab', index === selectedIndex && 'selected'),
          children: [/*#__PURE__*/jsx("input", {
            id: "".concat(index),
            "data-target": index,
            type: "radio",
            name: "offer-rule-step-selection",
            className: "mpd-tabs__tab-selector",
            onChange: function onChange(event) {
              if (event.target.dataset.target) {
                _onChange(parseInt(event.target.dataset.target, 10));
              }
            },
            checked: index === selectedIndex,
            disabled: isDisabled
          }), /*#__PURE__*/jsx("label", {
            htmlFor: "".concat(index),
            className: cn('mpd-tabs__tab-label', {
              'mpd-color-light-gray': isDisabled
            }),
            children: action.get('name') || (connector === CONNECTOR_AND ? t('ticket_price_picker.offer.navigation.step', {
              index: index + 1
            }) : t('ticket_price_picker.offer.navigation.option', {
              index: index + 1
            }))
          })]
        });
      }), /*#__PURE__*/jsxs("div", {
        className: cn('mpd-tabs__tab', {
          selected: selectedIndex === OVERVIEW_TAB
        }),
        children: [/*#__PURE__*/jsx("input", {
          id: "tab-overview",
          "data-target": "overview",
          type: "radio",
          name: "offer-rule-step-selection",
          className: "mpd-tabs__tab-selector",
          onChange: function onChange(event) {
            if (event.target.dataset.target) {
              _onChange(parseInt(event.target.dataset.target, 10));
            }
          },
          checked: selectedIndex === OVERVIEW_TAB,
          disabled: selectedIndex !== OVERVIEW_TAB
        }), /*#__PURE__*/jsx("label", {
          htmlFor: "tab-overview",
          className: cn('mpd-tabs__tab-label', {
            'mpd-color-light-gray': selectedIndex !== OVERVIEW_TAB
          }),
          children: t('summary')
        })]
      })]
    })
  });
}

function FormattedTicketPriceFacialValue(_ref) {
  var ticketPrice = _ref.ticketPrice,
    locale = _ref.locale;
  // do use translation hook to get the translation function
  // do not use Suspense and fallback to an empty string. The translation should work on server side and when client download the translations
  // This might display a warning in the console: "Did not expect server HTML to contain the text node "lundi 28 février 2022 à 18:51" in <div>."
  // but this will work fine and be SEO friendly
  var _useTranslation = useTranslation(undefined, {
      useSuspense: false
    }),
    t = _useTranslation.t,
    ready = _useTranslation.ready;
  if (!ready) {
    return null;
  }

  // keep the fragment to avoid issue with `Node.removeChild`
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/jsx(Fragment, {
    children: getFormattedTicketPriceFacialValue(ticketPrice, null, locale, t)
  });
}

var MAX_SIMULTANOUS_OFFERS = 6;
function OfferOverview(_ref) {
  var ticketPriceList = _ref.ticketPriceList,
    selectedTicketPriceList = _ref.selectedTicketPriceList,
    errorMessageList = _ref.errorMessageList,
    onQuantityChange = _ref.onQuantityChange,
    isEdition = _ref.isEdition;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(1),
    _useState2 = _slicedToArray$1(_useState, 2),
    offerQuantity = _useState2[0],
    setOfferQuantity = _useState2[1];
  var groupedTicketPriceIdList = List(selectedTicketPriceList).groupBy(function (v) {
    return v.get('@id');
  });
  var maxSubscriptionQuantity = getMaxSubscriptionQuantity(Object.fromEntries(ticketPriceList.map(function (ticketPrice) {
    return [ticketPrice.get('@id'), ticketPrice];
  })), selectedTicketPriceList.map(function (ticketPrice) {
    var _ticketPrice$Id;
    return (_ticketPrice$Id = ticketPrice['@id']) !== null && _ticketPrice$Id !== void 0 ? _ticketPrice$Id : '';
  }));
  var maxQuantity = maxSubscriptionQuantity === null ? MAX_SIMULTANOUS_OFFERS : Math.min(maxSubscriptionQuantity, MAX_SIMULTANOUS_OFFERS);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h3", {
      children: t('ticket_price_picker.offer.overview.ticket_list.title')
    }), groupedTicketPriceIdList.map(function (ticketPriceListForId, id) {
      var ticketPrice = ticketPriceListForId.first();
      if (!ticketPrice) {
        throw new Error('groupBy first value of collection should be set. This should not happen.');
      }
      assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
      assertRelationIsObject(ticketPrice.eventDate.ticketing, 'ticketPrice.eventDate.ticketing');
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        jsxs("p", {
          children: [ticketPriceListForId.size, "\xD7", ' ', /*#__PURE__*/jsx("strong", {
            children: ticketPrice.eventDate.ticketing.title
          }), ' - ', /*#__PURE__*/jsx(FormattedDateForStartAndEndDate, {
            startDate: ticketPrice.eventDate.startDate,
            endDate: ticketPrice.eventDate.endDate
          }), ' - ', /*#__PURE__*/jsxs("em", {
            children: [ticketPrice.name, ' ', /*#__PURE__*/jsx(FormattedTicketPriceFacialValue, {
              ticketPrice: ticketPrice
            })]
          })]
        }, id)
      );
    }).valueSeq(), errorMessageList && /*#__PURE__*/jsx(ErrorMessageList, {
      errorMessageList: errorMessageList
    }), !isEdition && /*#__PURE__*/jsxs("div", {
      className: "form-group",
      children: [/*#__PURE__*/jsx("input", {
        id: "OfferTicketPricePicker__Overview__quantity",
        type: "number",
        min: "1",
        max: maxQuantity,
        className: "form-control",
        style: {
          maxWidth: '250px'
        },
        value: offerQuantity,
        onChange: function onChange(e) {
          var newQuantity = Math.min(maxQuantity, Number(e.target.value));
          setOfferQuantity(newQuantity);
          onQuantityChange(newQuantity);
        }
      }), /*#__PURE__*/jsx("label", {
        htmlFor: "OfferTicketPricePicker__Overview__quantity",
        className: "h3-like",
        children: t('ticket_price_picker.offer.overview.quantity.label')
      }), /*#__PURE__*/jsx("div", {
        className: "help",
        children: t('ticket_price_picker.offer.overview.quantity.helper', {
          max: maxQuantity
        })
      })]
    })]
  });
}

function getGlobalErrorMessageList(selectedTicketPriceIdList, constraints, t) {
  if (!constraints) {
    return null;
  }
  if (!isValid(List(selectedTicketPriceIdList), constraints)) {
    var _constraints$NbTicket, _constraints$NbTicket2;
    var min = (_constraints$NbTicket = constraints === null || constraints === void 0 || (_constraints$NbTicket2 = constraints.NbTicket) === null || _constraints$NbTicket2 === void 0 ? void 0 : _constraints$NbTicket2.min) !== null && _constraints$NbTicket !== void 0 ? _constraints$NbTicket : 0;
    var nb = min - selectedTicketPriceIdList.length;
    return [t('ticket_price_picker.error.missing_nb_tickets', {
      count: nb
    })];
  }
  if (!isValid$1(List(selectedTicketPriceIdList), constraints)) {
    var _constraints$NbTicket3, _constraints$NbTicket4;
    var max = (_constraints$NbTicket3 = (_constraints$NbTicket4 = constraints.NbTicket) === null || _constraints$NbTicket4 === void 0 ? void 0 : _constraints$NbTicket4.max) !== null && _constraints$NbTicket3 !== void 0 ? _constraints$NbTicket3 : 0;
    var _nb = selectedTicketPriceIdList.length - max;
    return [t('ticket_price_picker.error.nb_too_many_tickets', {
      count: _nb
    })];
  }
  return null;
}
var getGlobalDisableTicketPriceIdListList = [withNPerTicketPrice.getDisableTicketPriceIdList, withNPerEventDate.getDisableTicketPriceIdList, withNPerVenue.getDisableTicketPriceIdList, withNPerTicketing.getDisableTicketPriceIdList, withSameDay.getDisableTicketPriceIdList, withSameTicketPrice.getDisableTicketPriceIdList, withSameEventDate.getDisableTicketPriceIdList, withSameTicketing.getDisableTicketPriceIdList, withSameVenue.getDisableTicketPriceIdList];
function getGlobalDisableTicketPriceIdList(ticketPriceList, defaultSelectedTicketPriceIdList, constraintList) {
  return getGlobalDisableTicketPriceIdListList.reduce(function (acc, getDisableTicketPriceIdList) {
    return getDisableTicketPriceIdList(acc, ticketPriceList, defaultSelectedTicketPriceIdList, constraintList);
  }, new Set());
}

function getActionTicketPriceList(action) {
  return action.get('ticketPriceList').toArray();
}
var OfferPickerWithTicketPrices = /*#__PURE__*/function (_PureComponent) {
  function OfferPickerWithTicketPrices(props) {
    var _this;
    _classCallCheck$3(this, OfferPickerWithTicketPrices);
    _this = _callSuper$1(this, OfferPickerWithTicketPrices, [props]);
    _defineProperty$5(_this, "contentRef", /*#__PURE__*/createRef());
    _this.state = {
      actionList: null,
      connector: CONNECTOR_AND,
      globalConstraints: undefined,
      currentIndex: null,
      displayOverview: false,
      selectedTicketPriceIdList: null,
      skippedStepList: new Set(),
      groupKey: generateGroupKey(),
      overviewQuantity: 1
    };
    _this.handleTabChange = _this.handleTabChange.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleActionConfirm = _this.handleActionConfirm.bind(_this);
    _this.handleConfirm = _this.handleConfirm.bind(_this);
    _this.shouldDisplayFinalOverview = _this.shouldDisplayFinalOverview.bind(_this);
    _this.splitOfferToState = _this.splitOfferToState.bind(_this);
    _this.getSubmitGroupKey = _this.getSubmitGroupKey.bind(_this);
    _this.getFirstSelectedTicketPriceCurrency = _this.getFirstSelectedTicketPriceCurrency.bind(_this);
    _this.getPreviousStepsSelectedTicketPriceList = _this.getPreviousStepsSelectedTicketPriceList.bind(_this);
    return _this;
  }
  _inherits$1(OfferPickerWithTicketPrices, _PureComponent);
  return _createClass$3(OfferPickerWithTicketPrices, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.splitOfferToState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var offerRule = this.props.offerRule;
      var _this$state = this.state,
        currentIndex = _this$state.currentIndex,
        displayOverview = _this$state.displayOverview;
      if (prevState.currentIndex !== currentIndex || prevState.displayOverview !== displayOverview) {
        var _this$contentRef$curr;
        (_this$contentRef$curr = this.contentRef.current) === null || _this$contentRef$curr === void 0 || (_this$contentRef$curr = _this$contentRef$curr.closest('.mpd-modal__content')) === null || _this$contentRef$curr === void 0 || _this$contentRef$curr.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      if (prevProps.offerRule !== offerRule) {
        this.splitOfferToState();
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          groupKey: generateGroupKey()
        });
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "splitOfferToState",
    value: function splitOfferToState() {
      var _offerRule$message$ge, _offerRule$message, _offerRule$message2, _offerRule$message3;
      var _this$props = this.props,
        offerRule = _this$props.offerRule,
        defaultSelectedTicketPriceIdList = _this$props.defaultSelectedTicketPriceIdList;
      var connector = (_offerRule$message$ge = (_offerRule$message = offerRule.message) === null || _offerRule$message === void 0 ? void 0 : _offerRule$message.get('connector')) !== null && _offerRule$message$ge !== void 0 ? _offerRule$message$ge : CONNECTOR_AND;
      var messageActionList = (_offerRule$message2 = offerRule.message) === null || _offerRule$message2 === void 0 ? void 0 : _offerRule$message2.get('actionList');
      var actionList = List.isList(messageActionList) ? messageActionList.filter(isTicketPricePickerAction) : List();
      var tmpTpIdList = _toConsumableArray(defaultSelectedTicketPriceIdList);
      var selectedTicketPriceIdList = actionList.reduce(function (carry, action, key) {
        var _action$constraints;
        var actionTicketPriceList = getActionTicketPriceList(action);
        var max = Map$1.isMap(action) ? action.getIn(['constraints', 'NbTicket', 'max']) : // @ts-expect-error TODO delete this case when TS is migrated and everything checked
        (_action$constraints = action.constraints) === null || _action$constraints === void 0 || (_action$constraints = _action$constraints.NbTicket) === null || _action$constraints === void 0 ? void 0 : _action$constraints.max;
        var ticketPriceIdList = [];
        actionTicketPriceList.forEach(function (actionTicketPriceId) {
          // take every possible ticket price for this action
          while (tmpTpIdList.includes(actionTicketPriceId) && (!max || max > ticketPriceIdList.length) // skip if we hit the max limit for this action
          ) {
            var index = tmpTpIdList.indexOf(actionTicketPriceId);
            tmpTpIdList.splice(index, 1);
            ticketPriceIdList.push(actionTicketPriceId);
          }
        });
        return _objectSpread2(_objectSpread2({}, carry), {}, _defineProperty$5({}, key, ticketPriceIdList));
      }, {});
      var globalConstraints = (_offerRule$message3 = offerRule.message) === null || _offerRule$message3 === void 0 || (_offerRule$message3 = _offerRule$message3.get('constraints')) === null || _offerRule$message3 === void 0 ? void 0 : _offerRule$message3.toJS();
      this.setState({
        connector: connector,
        currentIndex: connector === CONNECTOR_AND ? 0 : null,
        // with "OR" offer, we want to display the option selection first
        actionList: actionList,
        // @ts-expect-error type matches, toJS lost the type
        globalConstraints: globalConstraints,
        selectedTicketPriceIdList: selectedTicketPriceIdList,
        skippedStepList: new Set()
      });
    }

    /**
     * Get the currency for the first selected ticket price
     */
  }, {
    key: "getFirstSelectedTicketPriceCurrency",
    value: function getFirstSelectedTicketPriceCurrency() {
      var selectedTicketPriceIdList = this.state.selectedTicketPriceIdList;
      var ticketPriceList = this.props.ticketPriceList;
      var firstSelectedTicketPriceList = selectedTicketPriceIdList ? Object.values(selectedTicketPriceIdList).filter(function (arr) {
        return arr.length;
      }) : null;
      if (firstSelectedTicketPriceList && firstSelectedTicketPriceList.length && firstSelectedTicketPriceList[0].length) {
        var firstTicketPriceId = firstSelectedTicketPriceList[0][0];
        var foundTicketPrice = ticketPriceList.find(function (ticketPrice) {
          return getEntityId(ticketPrice) === firstTicketPriceId;
        });
        return (foundTicketPrice === null || foundTicketPrice === void 0 ? void 0 : foundTicketPrice.currency) || null;
      }
      return null;
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "handleTabChange",
    value: function handleTabChange(index) {
      this.setState({
        currentIndex: index
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(tpIdList, index) {
      var _this2 = this;
      var onChange = this.props.onChange;
      this.setState(function (prevState) {
        return {
          selectedTicketPriceIdList: _objectSpread2(_objectSpread2({}, prevState.selectedTicketPriceIdList), {}, _defineProperty$5({}, index, tpIdList))
        };
      }, function () {
        var selectedTicketPriceIdList = _this2.state.selectedTicketPriceIdList;
        if (onChange) {
          onChange(selectedTicketPriceIdList ? Object.values(selectedTicketPriceIdList).flat() : [], _this2.getSubmitGroupKey(), _this2.getFirstSelectedTicketPriceCurrency());
        }
      });
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "getSubmitGroupKey",
    value: function getSubmitGroupKey() {
      var generateNewGroupKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var offerRule = this.props.offerRule;
      var groupKey = this.state.groupKey;
      var groupKeySuffix = generateNewGroupKey ? generateGroupKey() : groupKey;
      return "".concat(getShortId(getEntityId(offerRule) || 'no-offer-id'), "|").concat(groupKeySuffix);
    }
  }, {
    key: "shouldDisplayFinalOverview",
    value: function shouldDisplayFinalOverview() {
      var _this$state2 = this.state,
        actionList = _this$state2.actionList,
        skippedStepList = _this$state2.skippedStepList;

      // if all steps are skipped, we don't want to display the final overview
      if (actionList === null || skippedStepList.size === actionList.size) {
        return false;
      }
      return true;
    }
  }, {
    key: "handleStepSkipped",
    value: function handleStepSkipped(index) {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.setState(function (prev) {
          return {
            skippedStepList: prev.skippedStepList.add(index)
          };
        }, function () {
          resolve();
        });
      });
    }
  }, {
    key: "handleActionConfirm",
    value: function handleActionConfirm(tpIdList, index) {
      var _this4 = this;
      var _this$state3 = this.state,
        actionList = _this$state3.actionList,
        connector = _this$state3.connector,
        displayOverview = _this$state3.displayOverview;
      var needOverview = this.shouldDisplayFinalOverview();
      var isLast = actionList !== null && actionList.size === index + 1;

      // do submit if there is no overview and we are on the last step
      // or if we are on the overview step and we submit
      var doSubmit = isLast && !needOverview || isLast && needOverview && displayOverview === true;
      this.setState(function (prevState) {
        var newSelectedTicketPriceIdList = _objectSpread2(_objectSpread2({}, prevState.selectedTicketPriceIdList), {}, _defineProperty$5({}, index, tpIdList));
        if (connector === CONNECTOR_OR) {
          // if the connector is a "OR" and we submit, keep track of selected ticket price id list and display the overview
          return {
            currentIndex: prevState.currentIndex,
            // weird but issue with TS and return type if we don't put it here
            selectedTicketPriceIdList: newSelectedTicketPriceIdList,
            displayOverview: true
          };
        }

        // else let's move to the next step
        var newIndex = Math.min(prevState.currentIndex !== null ? prevState.currentIndex + 1 : 1, prevState.actionList !== null ? prevState.actionList.size - 1 : 0);
        var newDisplayOverview = isLast && needOverview;
        return {
          selectedTicketPriceIdList: newSelectedTicketPriceIdList,
          currentIndex: newIndex,
          displayOverview: newDisplayOverview
        };
      }, function () {
        if (doSubmit) {
          _this4.handleConfirm();
        }
      });
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this5 = this;
      var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var onConfirm = this.props.onConfirm;
      var _this$state4 = this.state,
        selectedTicketPriceIdList = _this$state4.selectedTicketPriceIdList,
        skippedStepList = _this$state4.skippedStepList,
        actionList = _this$state4.actionList;

      // generate a list of group key. The first offer do keep the modal group key, the others will generate a new one
      var submitGroupKeys = Array(quantity).fill(null).map(function (_, i) {
        return _this5.getSubmitGroupKey(i !== 0);
      });
      if (onConfirm) {
        onConfirm(selectedTicketPriceIdList ? Object.values(selectedTicketPriceIdList).flat() : [], submitGroupKeys, this.getFirstSelectedTicketPriceCurrency(), skippedStepList.size === (actionList === null || actionList === void 0 ? void 0 : actionList.size));
      }
    }

    /**
     * Return the list of ticket prices selected in the previous steps if connector is "AND".
     * When isFallbackOnCartBuyableItemsAllowed is true and there are no previous steps (first step),
     * falls back to buyable ticket prices from the full list.
     */
  }, {
    key: "getPreviousStepsSelectedTicketPriceList",
    value: function getPreviousStepsSelectedTicketPriceList() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isFallbackOnCart = _ref.isFallbackOnCartBuyableItemsAllowed,
        isFallbackOnCartBuyableItemsAllowed = _ref$isFallbackOnCart === void 0 ? false : _ref$isFallbackOnCart;
      var _this$state5 = this.state,
        connector = _this$state5.connector,
        currentIndex = _this$state5.currentIndex,
        selectedTicketPriceIdList = _this$state5.selectedTicketPriceIdList;
      var _this$props2 = this.props,
        ticketPriceList = _this$props2.ticketPriceList,
        cartBuyableTicketPriceArray = _this$props2.cartBuyableTicketPriceArray;
      if (connector !== CONNECTOR_AND) {
        // if connector is not "AND", we don't care about previous steps
        return [];
      }
      if (!selectedTicketPriceIdList) {
        // i.e. for MakeCompanionBuyable applier
        if (isFallbackOnCartBuyableItemsAllowed) {
          return cartBuyableTicketPriceArray !== null && cartBuyableTicketPriceArray !== void 0 ? cartBuyableTicketPriceArray : [];
        }

        // i.e. for SameDay constraint
        return [];
      }
      var previousStepsSelectedTicketPriceIdList = new Set(Object.values(selectedTicketPriceIdList).slice(0, currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0).flat());
      if (previousStepsSelectedTicketPriceIdList.size === 0) {
        // i.e. for MakeCompanionBuyable applier
        if (isFallbackOnCartBuyableItemsAllowed) {
          return cartBuyableTicketPriceArray !== null && cartBuyableTicketPriceArray !== void 0 ? cartBuyableTicketPriceArray : [];
        }

        // i.e. for SameDay constraint
        return [];
      }
      return ticketPriceList.filter(function (tp) {
        assertRelationIsDefined(tp['@id'], 'ticketPrice.@id');
        return previousStepsSelectedTicketPriceIdList.has(tp['@id']);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _currentAction$get,
        _selectedTicketPriceI,
        _this6 = this,
        _offerRule$descriptio;
      var _this$props3 = this.props,
        isFront = _this$props3.isFront,
        currentEventDateId = _this$props3.currentEventDateId,
        ticketPriceList = _this$props3.ticketPriceList,
        _onCancel = _this$props3.onCancel,
        isLoading = _this$props3.isLoading,
        t = _this$props3.t,
        isEdition = _this$props3.isEdition,
        offerRule = _this$props3.offerRule,
        canSellOnHoldOrScheduledEventDate = _this$props3.canSellOnHoldOrScheduledEventDate;
      var _this$state6 = this.state,
        actionList = _this$state6.actionList,
        connector = _this$state6.connector,
        currentIndex = _this$state6.currentIndex,
        selectedTicketPriceIdList = _this$state6.selectedTicketPriceIdList,
        displayOverview = _this$state6.displayOverview,
        globalConstraints = _this$state6.globalConstraints,
        overviewQuantity = _this$state6.overviewQuantity;
      if (!actionList || actionList.size === 0) {
        return null;
      }
      var ticketPriceListById = Object.fromEntries(ticketPriceList.map(function (ticketPrice) {
        return [ticketPrice.get('@id'), ticketPrice];
      }));
      var allSelectedTicketPriceIdList = selectedTicketPriceIdList ? Object.values(selectedTicketPriceIdList).flat() : [];
      var previousStepsSelectedTicketPriceList = this.getPreviousStepsSelectedTicketPriceList({
        isFallbackOnCartBuyableItemsAllowed: false
      });
      var potentialSiblingsTicketPriceList = this.getPreviousStepsSelectedTicketPriceList({
        isFallbackOnCartBuyableItemsAllowed: true
      });
      var disabledTicketPriceIdList = getGlobalDisableTicketPriceIdList(ticketPriceList, allSelectedTicketPriceIdList, globalConstraints !== null && globalConstraints !== void 0 ? globalConstraints : {});
      var globalErrorMessageList = getGlobalErrorMessageList(allSelectedTicketPriceIdList, globalConstraints, t) || [];
      var currentAction = currentIndex !== null ? actionList.get(currentIndex) : null;
      // @ts-expect-error constrains are compatibles
      var currentActionConstraintList = currentAction ? ((_currentAction$get = currentAction.get('constraints')) === null || _currentAction$get === void 0 ? void 0 : _currentAction$get.toJS()) || {} : {};
      var actionErrorMessageList = currentIndex !== null && selectedTicketPriceIdList ? getGlobalErrorMessageList((_selectedTicketPriceI = selectedTicketPriceIdList[currentIndex]) !== null && _selectedTicketPriceI !== void 0 ? _selectedTicketPriceI : [], currentActionConstraintList, t) || [] : [];
      var allErrorMessageList = [].concat(_toConsumableArray(globalErrorMessageList), _toConsumableArray(actionErrorMessageList));
      var overviewErrorMessageList = getGlobalErrorMessageList(allSelectedTicketPriceIdList, globalConstraints, t) || [];
      var needOverview = this.shouldDisplayFinalOverview();
      var isLastStep = currentIndex !== null && actionList.size === currentIndex + 1;
      var isDirectSubmitStep = isLastStep && !needOverview;
      var getPrimaryButtonProps = function getPrimaryButtonProps() {
        if (displayOverview) {
          return {
            label: t('validate'),
            onClick: function onClick() {
              _this6.handleConfirm(overviewQuantity);
            },
            isDisabled: overviewErrorMessageList.length > 0
          };
        }
        if (currentIndex !== null) {
          return {
            label: isDirectSubmitStep ? t('validate') : t('ticket_price_picker.offer.next_step'),
            onClick: function onClick() {
              var _selectedTicketPriceI2;
              _this6.handleActionConfirm(selectedTicketPriceIdList ? (_selectedTicketPriceI2 = selectedTicketPriceIdList[currentIndex]) !== null && _selectedTicketPriceI2 !== void 0 ? _selectedTicketPriceI2 : [] : [], currentIndex);
            },
            isDisabled: allErrorMessageList.length > 0
          };
        }
        return undefined;
      };
      var primaryButtonProps = getPrimaryButtonProps();
      return /*#__PURE__*/jsx(MpdModal, {
        title: offerRule.title || t('ticketing.booking.ticket_price_picker_modal.title'),
        subtitle: (_offerRule$descriptio = offerRule.description) !== null && _offerRule$descriptio !== void 0 ? _offerRule$descriptio : '',
        onCancel: function onCancel() {
          return _onCancel(_this6.getSubmitGroupKey());
        },
        contentClassNames: "mpd-modal__content--scrollable",
        primaryButtonProps: primaryButtonProps,
        secondaryButtonProps: displayOverview ? {
          label: t('edit'),
          onClick: function onClick() {
            _this6.setState({
              currentIndex: connector === CONNECTOR_AND ? 0 : null,
              displayOverview: false
            });
          }
        } : undefined,
        children: isLoading ? /*#__PURE__*/jsx("div", {
          className: "txtcenter",
          children: /*#__PURE__*/jsx(MpdLoader, {})
        }) : /*#__PURE__*/jsxs("div", {
          children: [!displayOverview && allErrorMessageList.length > 0 && /*#__PURE__*/jsx(ModalAlertMessage, {
            children: /*#__PURE__*/jsx(ErrorMessageList, {
              errorMessageList: allErrorMessageList
            })
          }), /*#__PURE__*/jsx("div", {
            ref: this.contentRef
          }), /*#__PURE__*/jsx(Navigation, {
            actionList: actionList,
            connector: connector,
            onChange: this.handleTabChange,
            selectedIndex: displayOverview ? OVERVIEW_TAB : currentIndex
          }), displayOverview ? /*#__PURE__*/jsx(OfferOverview, {
            ticketPriceList: ticketPriceList,
            selectedTicketPriceList: allSelectedTicketPriceIdList ? allSelectedTicketPriceIdList.map(function (id) {
              return ticketPriceListById[id];
            }) : [],
            errorMessageList: overviewErrorMessageList,
            onQuantityChange: function onQuantityChange(quantity) {
              _this6.setState({
                overviewQuantity: quantity
              });
            },
            isEdition: isEdition
          }) : actionList.map(function (action, index) {
            var _action$get, _action$get2;
            if (currentIndex !== index) {
              // until we handle a "swipe", we only display current index
              return null;
            }

            // @ts-expect-error constrains are compatibles
            var actionConstraintList = ((_action$get = action.get('constraints')) === null || _action$get === void 0 ? void 0 : _action$get.toJS()) || {};
            var actionTicketPriceIdList = getActionTicketPriceList(action);
            var actionTicketPriceList = ticketPriceList.filter(function (tp) {
              var tpId = tp.get('@id');
              assertRelationIsDefined(tpId, 'ticketPrice.@id');
              return actionTicketPriceIdList.includes(tpId);
            });
            return /*#__PURE__*/jsx(TicketPricePickerWithConstraints, {
              constraintList: actionConstraintList,
              globalConstraints: globalConstraints !== null && globalConstraints !== void 0 ? globalConstraints : {},
              previousStepsSelectedTicketPriceList: previousStepsSelectedTicketPriceList,
              potentialSiblingsTicketPriceList: potentialSiblingsTicketPriceList,
              disabledTicketPriceIdList: disabledTicketPriceIdList,
              mandatoryTicketPriceList: (_action$get2 = action
              // @ts-expect-error `mandatoryTicketPriceList` is unused and thus not defined in `ticketing-js-sdk`
              .get('mandatoryTicketPriceList')) === null || _action$get2 === void 0 ? void 0 : _action$get2.toJS(),
              ticketPriceList: actionTicketPriceList,
              defaultSelectedTicketPriceIdList: selectedTicketPriceIdList ? selectedTicketPriceIdList[index] : [],
              onChange: function onChange(tpIdList) {
                _this6.handleChange(tpIdList, index);
              }
              // we should probably manage the selected prices and the button visibility here
              // (See `TicketPricePicker.canConfirm` method and `isSelectedTicketPriceListValid` prop)
              // and do not pass any `onConfirm` action to the TicketPricePicker
              ,
              onConfirm: function onConfirm(tpIdList) {
                _this6.handleActionConfirm(tpIdList, index);
              },
              isFront: isFront,
              currentEventDateId: currentEventDateId,
              onSkipStep: function onSkipStep() {
                return _this6.handleStepSkipped(index);
              },
              canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate,
              hideErrorMessages: true,
              hideButtons: true
            }, "action-".concat(action.hashCode()));
          })]
        })
      });
    }
  }]);
}(PureComponent); // eslint-disable-next-line react/no-multi-comp
_defineProperty$5(OfferPickerWithTicketPrices, "defaultProps", {
  onConfirm: null,
  onChange: null,
  defaultSelectedTicketPriceIdList: [],
  currentEventDateId: null,
  isLoading: false,
  isEdition: false,
  canSellOnHoldOrScheduledEventDate: false,
  cartBuyableTicketPriceArray: []
});
function OfferPickerWithTicketPricesWithTranslation(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/jsx(OfferPickerWithTicketPrices, _objectSpread2(_objectSpread2({}, props), {}, {
    t: t
  }));
}

var _excluded$7 = ["offerRule", "ticketPriceRepository", "sellingDeviceId"];
function OfferPicker(_ref) {
  var _offerRule$get, _offerRule$message;
  var offerRule = _ref.offerRule,
    ticketPriceRepository = _ref.ticketPriceRepository,
    sellingDeviceId = _ref.sellingDeviceId,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useTicketPricePicker = useTicketPricePickerOfferRuleFetch({
      offerRuleId: (_offerRule$get = offerRule.get('@id')) !== null && _offerRule$get !== void 0 ? _offerRule$get : '',
      offerRuleDisallowBatchFetching: !!((_offerRule$message = offerRule.message) !== null && _offerRule$message !== void 0 && _offerRule$message.get('disallowTicketPriceBatchFetch')),
      sellingDeviceId: sellingDeviceId,
      ticketPriceRepository: ticketPriceRepository
    }),
    ticketPriceList = _useTicketPricePicker.ticketPriceList,
    isLoading = _useTicketPricePicker.isLoading,
    isBatchFetch = _useTicketPricePicker.isBatchFetch,
    ticketPriceCount = _useTicketPricePicker.ticketPriceCount;
  var hasTimedout = useTimeout(1000);

  // if fetch is not batch, we do not want to display the modal
  // while fetching : it could be an add-to-cart where the modal
  // never shows up
  if ((ticketPriceCount === null || ticketPriceList.length === 0) && !isBatchFetch) {
    if (!hasTimedout) {
      return null;
    }
    return /*#__PURE__*/jsx(BaseModal, {
      title: t('ticketing.booking.ticket_price_picker_modal.title')
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      ,
      onCancel: function onCancel() {},
      children: /*#__PURE__*/jsx("div", {
        className: "txtcenter",
        children: /*#__PURE__*/jsx(MpdLoader, {})
      })
    });
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error weird typing issue due to defaultProps
    jsx(OfferPickerWithTicketPricesWithTranslation
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _objectSpread2(_objectSpread2({}, rest), {}, {
      offerRule: offerRule,
      ticketPriceList: ticketPriceList,
      isLoading: isLoading
    }))
  );
}

function makeCancelable(promise) {
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(
    // eslint-disable-next-line prefer-promise-reject-errors
    function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    },
    // eslint-disable-next-line prefer-promise-reject-errors
    function (error) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled = true;
    }
  };
}

function findTicketPricepickerForOfferRule(offerRule) {
  var _offerRule$message;
  var actionList = (_offerRule$message = offerRule.message) === null || _offerRule$message === void 0 ? void 0 : _offerRule$message.get('actionList');
  if (!actionList || !hasTicketPricePickerForActionList(actionList)) {
    return false;
  }
  return true;
}
function findOfferRuleForTicketPrice(ticketPrice) {
  assertRelationIsListOfObject(ticketPrice.offerRuleList, 'ticketPrice.offerRuleList');
  return ticketPrice.offerRuleList.find(findTicketPricepickerForOfferRule);
}
function useOfferRule(ticketPriceRepository, triggerOfferTicketPriceId) {
  var _useState = useState(null),
    _useState2 = _slicedToArray$1(_useState, 2),
    offerRule = _useState2[0],
    setOfferRule = _useState2[1];
  useEffect(function () {
    var findPromise = makeCancelable(ticketPriceRepository.find(getShortId(triggerOfferTicketPriceId), {
      fields: [{
        offerRuleList: ['title', 'message', 'description', 'exchangeData']
      }]
    }));
    findPromise.promise.then(function (ticketPrice) {
      var foundOfferRule = findOfferRuleForTicketPrice(ticketPrice);
      if (!foundOfferRule) {
        return;
      }
      setOfferRule(foundOfferRule);
    });
    return function () {
      findPromise.cancel();
    };
  }, [ticketPriceRepository, triggerOfferTicketPriceId]);
  return offerRule;
}
/**
 * ## Usage
 *
 * ```js
 * import { OfferTicketPricePicker } from '@mapado/js-component';
 *
 * <OfferTicketPricePicker
 *   triggerOfferTicketPrice="/v1/ticket_prices/1"
 *   ticketPriceRepository={ticketingSdk.ticketPrice}
 *   selectedTicketPriceIdList={['/v1/ticket_prices/23', '/v1/ticket_prices/25']}
 *   onCancel={() => {
 *     console.log('Cancelled');
 *   }}
 *   onChange={(selectedTicketPriceIdList) => {
 *     console.log(selectedTicketPriceIdList);
 *   }}
 *   onConfirm={(selectedTicketPriceIdList) => {
 *     console.log(selectedTicketPriceIdList);
 *   }}
 * />;
 * ```
 */
function OfferTicketPricePicker(_ref) {
  var ticketPriceRepository = _ref.ticketPriceRepository,
    triggerOfferTicketPrice = _ref.triggerOfferTicketPrice,
    onCancel = _ref.onCancel,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? null : _ref$onConfirm,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$isFront = _ref.isFront,
    isFront = _ref$isFront === void 0 ? false : _ref$isFront,
    sellingDeviceId = _ref.sellingDeviceId,
    _ref$currentEventDate = _ref.currentEventDateId,
    currentEventDateId = _ref$currentEventDate === void 0 ? null : _ref$currentEventDate,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate,
    cartBuyableTicketPriceArray = _ref.cartBuyableTicketPriceArray;
  var triggerOfferTicketPriceId = getEntityId(triggerOfferTicketPrice);
  assertRelationIsString(triggerOfferTicketPriceId, 'triggerOfferTicketPriceId');
  var offerRule = useOfferRule(ticketPriceRepository, triggerOfferTicketPriceId);
  if (!offerRule) {
    return null;
  }
  return /*#__PURE__*/jsx(SellingDeviceIdContextProvider, {
    sellingDeviceId: sellingDeviceId,
    children: /*#__PURE__*/jsx(OfferPicker, {
      onCancel: onCancel,
      offerRule: offerRule,
      ticketPriceRepository: ticketPriceRepository,
      sellingDeviceId: sellingDeviceId,
      isFront: isFront,
      onConfirm: onConfirm,
      onChange: onChange,
      currentEventDateId: currentEventDateId,
      canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate,
      cartBuyableTicketPriceArray: cartBuyableTicketPriceArray
    })
  });
}

function Condition(_ref) {
  var when = _ref.when,
    is = _ref.is,
    inArray = _ref.in,
    _children = _ref.children;
  var arrayToCheck = is ? [is] : inArray;
  return /*#__PURE__*/jsx(Field$1, {
    name: when,
    subscription: {
      value: true
    },
    children: function children(_ref2) {
      var value = _ref2.input.value;
      return arrayToCheck !== null && arrayToCheck !== void 0 && arrayToCheck.includes(value) ? _children : null;
    }
  });
}

var _excluded$6 = ["name", "value", "label", "parse", "format", "validate", "description", "disabled", "onFieldChange", "containerClassName", "active", "withoutPadding"],
  _excluded2 = ["onChange"];
function FieldRadio(_ref) {
  var name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    parse = _ref.parse,
    format = _ref.format,
    validate = _ref.validate,
    description = _ref.description,
    disabled = _ref.disabled,
    _ref$onFieldChange = _ref.onFieldChange,
    onFieldChange = _ref$onFieldChange === void 0 ? function () {} : _ref$onFieldChange,
    containerClassName = _ref.containerClassName,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    _ref$withoutPadding = _ref.withoutPadding,
    withoutPadding = _ref$withoutPadding === void 0 ? false : _ref$withoutPadding,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    type: "radio",
    value: value,
    parse: parse,
    format: format,
    validate: validate,
    disabled: disabled,
    children: function children(_ref2) {
      var _ref2$input = _ref2.input,
        _onChange = _ref2$input.onChange,
        inputRest = _objectWithoutProperties(_ref2$input, _excluded2),
        meta = _ref2.meta;
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(MpdRadio, _objectSpread2(_objectSpread2(_objectSpread2({
          active: active,
          className: containerClassName,
          onChange: function onChange(e) {
            _onChange(e);
            onFieldChange(e);
          },
          description: description && /*#__PURE__*/jsx("span", {
            className: "mpd-color-gray",
            children: description
          }),
          withoutPadding: withoutPadding,
          disabled: disabled
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, rest), inputRest), {}, {
          children: label
        })), meta.error && meta.touched && /*#__PURE__*/jsx("div", {
          className: "help error",
          children: meta.error
        })]
      });
    }
  });
}

var FIELD_VALUE = /*#__PURE__*/function (FIELD_VALUE) {
  FIELD_VALUE["YES"] = "yes";
  FIELD_VALUE["NO"] = "no";
  return FIELD_VALUE;
}(FIELD_VALUE || {});
function Field(_ref) {
  var name = _ref.name,
    value = _ref.value,
    label = _ref.label;
  return /*#__PURE__*/jsx(FieldRadio, {
    name: name
    // @ts-expect-error don't know why but it does work
    ,
    value: value,
    label: label,
    format: function format(innerValue) {
      if (innerValue === true) {
        return FIELD_VALUE.YES;
      } else if (innerValue === false) {
        return FIELD_VALUE.NO;
      }
    },
    parse: function parse(innerValue) {
      if (innerValue === FIELD_VALUE.YES) {
        return true;
      } else if (innerValue === FIELD_VALUE.NO) {
        return false;
      }
    }
  });
}
var LABEL_DEFAULTS = {
  true: undefined,
  false: undefined
};
// eslint-disable-next-line react/no-multi-comp
function FieldBoolean(_ref2) {
  var name = _ref2.name,
    _ref2$labels = _ref2.labels,
    labels = _ref2$labels === void 0 ? LABEL_DEFAULTS : _ref2$labels,
    className = _ref2.className;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: cn(className),
      children: /*#__PURE__*/jsx(Field, {
        name: name,
        value: FIELD_VALUE.YES,
        label: labels.true || t('yes')
      })
    }), /*#__PURE__*/jsx("div", {
      className: cn(className),
      children: /*#__PURE__*/jsx(Field, {
        name: name,
        value: FIELD_VALUE.NO,
        label: labels.false || t('no')
      })
    })]
  });
}

var _excluded$5 = ["name", "label", "className", "defaultChecked", "onChange", "value"];
function FieldCheckbox(_ref) {
  var name = _ref.name,
    label = _ref.label,
    className = _ref.className,
    defaultChecked = _ref.defaultChecked,
    _onChange = _ref.onChange,
    value = _ref.value,
    mpdCheckboxProps = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    type: "checkbox",
    value: value,
    children: function children(_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(MpdCheckbox, _objectSpread2(_objectSpread2(_objectSpread2({
          className: className
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, input), {}, {
          defaultChecked: defaultChecked,
          checked: defaultChecked ? undefined : input.checked,
          onChange: function onChange(e) {
            input.onChange(e);
            if (typeof _onChange === 'function') {
              _onChange(e.target.checked);
            }
          }
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, mpdCheckboxProps), {}, {
          children: label
        })), meta.error && meta.touched && /*#__PURE__*/jsx("span", {
          children: meta.error
        })]
      });
    }
  });
}

var _excluded$4 = ["name", "value", "label", "type", "validate", "required", "parse", "format", "disabled", "help", "inputClassName", "className", "icon", "errorMessage", "clearable"];
function FieldInput(_ref) {
  var name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    label = _ref.label,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? undefined : _ref$validate,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    parse = _ref.parse,
    format = _ref.format,
    disabled = _ref.disabled,
    help = _ref.help,
    inputClassName = _ref.inputClassName,
    className = _ref.className,
    icon = _ref.icon,
    errorMessage = _ref.errorMessage,
    clearable = _ref.clearable,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    type: type,
    value: value,
    validate: validate,
    parse: parse,
    format: format,
    children: function children(_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      var classnames = cn(inputClassName, 'form-control', {
        error: meta.error && meta.touched
      });
      return /*#__PURE__*/jsx(MpdInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread2(_objectSpread2(_objectSpread2({}, input), rest), {}, {
        type: type,
        label: label,
        errorMessage: meta.error && meta.touched && meta.error || errorMessage,
        help: help,
        required: required,
        disabled: disabled,
        inputClassName: classnames,
        className: className,
        icon: icon,
        onClear: clearable ? function () {
          return input.onChange(null);
        } : undefined
      }));
    }
  });
}

var _excluded$3 = ["name", "validate", "parse", "format", "onChange"];
function FieldMultiSelect(_ref) {
  var name = _ref.name,
    validate = _ref.validate,
    parse = _ref.parse,
    format = _ref.format,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    validate: validate,
    parse: parse,
    format: format,
    children: function children(_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      return /*#__PURE__*/jsx(MpdMultiSelect
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread2(_objectSpread2(_objectSpread2({}, input), rest), {}, {
        id: name,
        errorMessage: meta.error && meta.touched ? meta.error : null,
        onChange: function onChange(values) {
          input.onChange(values);
          if (typeof _onChange === 'function') {
            _onChange(values);
          }
        }
      }));
    }
  });
}

var _excluded$2 = ["name", "errorMessage", "validate"];
function FieldPhoneInput(_ref) {
  var name = _ref.name,
    errorMessage = _ref.errorMessage,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? undefined : _ref$validate,
    mpdPhoneInputProps = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    type: "tel",
    validate: validate,
    children: function children(_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      return /*#__PURE__*/jsx(MpdPhoneInput, _objectSpread2(_objectSpread2({
        errorMessage: meta.touched && meta.error || errorMessage
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, input), mpdPhoneInputProps));
    }
  });
}

var _excluded$1 = ["name", "validate", "parse", "format", "onChange"];
function FieldSingleSelect(_ref) {
  var name = _ref.name,
    validate = _ref.validate,
    parse = _ref.parse,
    format = _ref.format,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    validate: validate,
    parse: parse,
    format: format,
    children: function children(_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      return /*#__PURE__*/jsx(MpdSingleSelect
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread2(_objectSpread2(_objectSpread2({}, input), rest), {}, {
        id: name,
        errorMessage: meta.error && meta.touched ? meta.error : null,
        onChange: function onChange(option) {
          input.onChange(option);
          if (typeof _onChange === 'function') {
            _onChange(option);
          }
        }
      }));
    }
  });
}

var _excluded = ["name", "value", "label", "validate", "parse", "format"];
function FieldTextarea(_ref) {
  var name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    label = _ref.label,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? undefined : _ref$validate,
    parse = _ref.parse,
    format = _ref.format,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Field$1, {
    name: name,
    value: value,
    validate: validate,
    parse: parse,
    format: format,
    children: function children(_ref2) {
      var input = _ref2.input,
        meta = _ref2.meta;
      return /*#__PURE__*/jsx(MpdTextarea
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread2(_objectSpread2(_objectSpread2({}, input), rest), {}, {
        label: label,
        errorMessage: meta.error && meta.touched && meta.error
      }));
    }
  });
}

var DEFAULT_ERROR_DESCRIPTION = i18n.t('api.default_error_description');
function getErrorDescription(_x) {
  return _getErrorDescription.apply(this, arguments);
}
function _getErrorDescription() {
  _getErrorDescription = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(error) {
    var json;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(error instanceof HttpError && !error.baseResponse.bodyUsed)) {
            _context.n = 5;
            break;
          }
          _context.p = 1;
          _context.n = 2;
          return error.responseJson();
        case 2:
          json = _context.v;
          if (!(_typeof$7(json) === 'object' && typeof json['hydra:description'] === 'string')) {
            _context.n = 3;
            break;
          }
          return _context.a(2, json['hydra:description']);
        case 3:
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _context.v;
          return _context.a(2, error.toString());
        case 5:
          if (!(error instanceof Error)) {
            _context.n = 6;
            break;
          }
          return _context.a(2, error.message);
        case 6:
          if (!(typeof error === 'string')) {
            _context.n = 7;
            break;
          }
          return _context.a(2, error);
        case 7:
          return _context.a(2, DEFAULT_ERROR_DESCRIPTION);
      }
    }, _callee, null, [[1, 4]]);
  }));
  return _getErrorDescription.apply(this, arguments);
}

function useModal(ModalComponent) {
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isModalOpened = _useState2[0],
    setIsModalOpened = _useState2[1];
  var OpenedModalComponent = isModalOpened ? createModalPortal(ModalComponent) : null;
  return [OpenedModalComponent, setIsModalOpened];
}

/**
 * Create a simple modal with a final-form inside.
 * If the `onSubmit` function throws an error, it will be displayed in the modal directly.
 *
 * Usage:
 * return useFormModal<FormValueType>({
 *   title: 'Modal name',
 *   initialValues: {
 *     name: 'initial name',
 *   },
 *   onLoad?: () => { do stuff to load data. Watch out : you will probably need to use `useCallback` to avoid infinite loop },
 *   onSubmit: (values: FormValueType) => { do stuff with data },
 *   children: (
 *     <FieldInput
 *       name="name"
 *       label={t('settings.booking_track.form_name_label')}
 *     />
 *   ),
 * });
 */
function useFormModal(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    initialValues = _ref.initialValues,
    disableNativeFormValidation = _ref.disableNativeFormValidation,
    onSubmit = _ref.onSubmit,
    _children = _ref.children,
    onLoad = _ref.onLoad,
    isSmall = _ref.isSmall,
    _onCancel = _ref.onCancel,
    validate = _ref.validate,
    noValidate = _ref.noValidate,
    primaryButtonLabel = _ref.primaryButtonLabel,
    _ref$allowPristineOnS = _ref.allowPristineOnSubmit,
    allowPristineOnSubmit = _ref$allowPristineOnS === void 0 ? false : _ref$allowPristineOnS,
    _ref$isFormSubmitDisa = _ref.isFormSubmitDisabled,
    isFormSubmitDisabled = _ref$isFormSubmitDisa === void 0 ? false : _ref$isFormSubmitDisa,
    tertiaryAction = _ref.tertiaryAction;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray$1(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$1(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];

  // decorate useModal `setIsVisible` to reset state when modal is closed
  var setIsVisibleAndResetState = function setIsVisibleAndResetState(isVisible) {
    if (!isVisible) {
      setErrorMessage(null);
      setIsLoading(false);
    }
    setIsVisible(isVisible);
  };
  var _useModal = useModal(/*#__PURE__*/jsx(Form, {
      onSubmit: (/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
          var error, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _context.p = 0;
                _context.n = 1;
                return onSubmit(data);
              case 1:
                _context.n = 4;
                break;
              case 2:
                _context.p = 2;
                _t = _context.v;
                _context.n = 3;
                return getErrorDescription(_t);
              case 3:
                error = _context.v;
                setErrorMessage(error);
              case 4:
                return _context.a(2);
            }
          }, _callee, null, [[0, 2]]);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()),
      onChange: true,
      initialValues: initialValues,
      validate: validate,
      noValidate: noValidate,
      keepDirtyOnReinitialize: true,
      children: function children(_ref3) {
        var handleSubmit = _ref3.handleSubmit,
          submitting = _ref3.submitting,
          pristine = _ref3.pristine;
        return /*#__PURE__*/jsxs(MpdModal, {
          title: title,
          subtitle: subtitle,
          onCancel: function onCancel() {
            setIsVisibleAndResetState(false);
            if (_onCancel) {
              _onCancel();
            }
          },
          onSubmit: handleSubmit,
          isForm: true,
          disableNativeFormValidation: disableNativeFormValidation,
          isSmall: isSmall,
          primaryButtonProps: {
            label: primaryButtonLabel,
            isDisabled: pristine && !allowPristineOnSubmit || isFormSubmitDisabled,
            isLoading: submitting
          },
          secondaryButtonProps: {
            onClick: function onClick() {
              setIsVisibleAndResetState(false);
              if (_onCancel) {
                _onCancel();
              }
            },
            isDisabled: submitting
          },
          tertiaryAction: tertiaryAction,
          children: [isLoading ? /*#__PURE__*/jsx(MpdLoader, {
            align: "center"
          }) : /*#__PURE__*/jsxs(Fragment, {
            children: [errorMessage && /*#__PURE__*/jsx(ModalAlertMessage, {
              type: ALERT_TYPE.ERROR,
              children: errorMessage
            }), _children]
          }), /*#__PURE__*/jsx(FormSpy, {
            subscription: {
              modifiedSinceLastSubmit: true
            },
            onChange: function onChange() {
              // If one data change, do reset error message
              setErrorMessage(null);
            }
          })]
        });
      }
    })),
    _useModal2 = _slicedToArray$1(_useModal, 2),
    FormModal = _useModal2[0],
    setIsVisible = _useModal2[1];
  var isModalVisible = !!FormModal;

  // Load data when modal is opened if there is a `onLoad` function
  useEffect(function () {
    var handleOnLoad = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var error, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(typeof onLoad !== 'function')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              setIsLoading(true);
              _context2.p = 2;
              _context2.n = 3;
              return onLoad();
            case 3:
              setIsLoading(false);
              _context2.n = 6;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              _context2.n = 5;
              return getErrorDescription(_t2);
            case 5:
              error = _context2.v;
              setErrorMessage(error);
              setIsLoading(false);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 4]]);
      }));
      return function handleOnLoad() {
        return _ref4.apply(this, arguments);
      };
    }();
    if (isModalVisible) {
      handleOnLoad();
    }
  }, [onLoad, isModalVisible]);
  return [FormModal, setIsVisibleAndResetState];
}

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

function createAnchor(href) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'download';
  var id = "dowload-link-".concat(Date.now(), "-").concat(Math.round(Math.random() * 1000000));
  var anchor = document.createElement('a');
  anchor.setAttribute('class', 'hidden');
  anchor.setAttribute('download', name);
  anchor.setAttribute('id', id);
  anchor.href = href;
  return anchor;
}
function convertBlobPromiseToDataUrl(blobPromise) {
  return blobPromise.then(function (blob) {
    return URL.createObjectURL(blob);
  });
}
function downloadFile(url, name) {
  var anchor = createAnchor(url, name);
  document.body.append(anchor);
  var link = document.getElementById(anchor.id);
  if (!link) {
    throw new Error('Unable to create anchor link for download');
  }
  link.click();
  link.remove();
}
function downloadResponse(response, name) {
  return convertBlobPromiseToDataUrl(response.blob()).then(function (url) {
    createAnchor(url, name).click();
  });
}

var DURATION_UNIT = /*#__PURE__*/function (DURATION_UNIT) {
  DURATION_UNIT["MINUTE"] = "M";
  DURATION_UNIT["HOUR"] = "H";
  DURATION_UNIT["DAY"] = "D";
  DURATION_UNIT["WEEK"] = "W";
  return DURATION_UNIT;
}({});

// TODO: migrate to Temporal.Duration when available natively in browsers
function parseDuration(durationString) {
  if (!durationString) {
    return null;
  }
  var singleUnitDuration = /^P(?:([0-9]+)([WD])|T([0-9]+)([HM]))$/;
  var match = durationString.match(singleUnitDuration);
  if (!match) {
    return null;
  }
  var _match = _slicedToArray$1(match, 5),
    dateCount = _match[1],
    dateUnit = _match[2],
    timeCount = _match[3],
    timeUnit = _match[4];
  var count = Number(dateCount !== null && dateCount !== void 0 ? dateCount : timeCount);
  var unit = dateUnit !== null && dateUnit !== void 0 ? dateUnit : timeUnit;
  return {
    count: count,
    unit: unit
  };
}
function buildDuration(count, unit) {
  if (!count || !unit) {
    return undefined;
  }
  var period = unit === DURATION_UNIT.MINUTE || unit === DURATION_UNIT.HOUR ? 'PT' : 'P';
  return "".concat(period).concat(count).concat(unit);
}
function durationToMinutes(duration) {
  return moment$1.duration(duration).asMinutes();
}

/**
 * Validates that the value is not empty.
 * @param translateFunctionOrTranslatedError The translation function or the translated error message.
 */
function required(translateFunctionOrTranslatedError) {
  return function (value) {
    if (value) {
      // no error if value is not empty
      return undefined;
    }
    if (typeof value === 'number' && value === 0) {
      // if value is number, 0 is valid value
      return undefined;
    }
    if (typeof translateFunctionOrTranslatedError === 'string') {
      return translateFunctionOrTranslatedError;
    }
    return translateFunctionOrTranslatedError('field.required');
  };
}

/**
 * Validates that the input value length is not greater than max set.
 * @param max Nb of character max
 * @param t The translation function
 */
function maxLength(max, t) {
  return function (value) {
    if (typeof value === 'string' && value.length > max) {
      return t('field.error_max_length', {
        maxLength: max
      });
    }
    return undefined; // no error if value is not greater than max
  };
}
var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function (value, allValues, meta) {
    return validators.reduce(function (error, validator) {
      return error || validator(value, allValues, meta);
    }, undefined);
  };
};

function convertOptionListToGroupedOptions(optionList) {
  var _optionList$groupBy$m;
  return (_optionList$groupBy$m = optionList === null || optionList === void 0 ? void 0 : optionList.groupBy(function (option) {
    return option.groupName;
  }).map(function (list, key) {
    return {
      label: key,
      options: list.toArray()
    };
  }).valueSeq().toArray()) !== null && _optionList$groupBy$m !== void 0 ? _optionList$groupBy$m : [];
}
function getCurrentSingleOptionFromGroupedOptions(options, currentValue) {
  var _options$reduce$find;
  return (_options$reduce$find = options === null || options === void 0 ? void 0 : options.reduce(function (acc, groupedOption) {
    return acc.concat(groupedOption.options);
  }, []).find(function (option) {
    return option.value === currentValue;
  })) !== null && _options$reduce$find !== void 0 ? _options$reduce$find : null;
}

/** @deprecated to move in desk */
var StockRoundRepresentation = StockRoundRepresentation$1;

export { ALERT_TYPE, BaseModal, ColoredItemAdminModal, Condition, ContingentRow, ContingentSelector, CouponApplied, CouponOfferColorBorder, CouponOfferStatusRow, DOMAIN_CONTEXT, DURATION_UNIT, DomainContext, EditableStockContingentRow, FORMATTED_DATE_FORMAT, FieldBoolean, FieldCheckbox, FieldInput, FieldMultiSelect, FieldPhoneInput, FieldRadio, FieldSingleSelect, FieldTextarea, FormBuilderInstance, FormattedDateForStartAndEndDate, FormattedTicketPriceFacialValue, ModalAlertMessage, MomentInstance, MpdTooltip, OfferPicker, OfferTicketPricePicker, PriceListWithTranslation as PriceList, StockNotInContingent, StockRoundRepresentation, TicketingBlock, TicketingSdkContext, buildDuration, capitalize, compareMomentDates, composeValidators, convertOptionListToGroupedOptions, downloadFile, downloadResponse, durationToMinutes, formatDate, formatPrice, formatPriceCts, formatTicketPrice, formatTime, fromCents, getAddressFromCrmCustomer, getCurrentSingleOptionFromGroupedOptions, getCustomerFullname, getEntityId, getErrorDescription, getFormattedDateForStartAndEndDate, getFormattedNumber, getFormattedPhoneNumberObject, getFormattedTicketPriceFacialValue, getFullname, getLocale, getRequiredEntityId, getShortId, i18n, isPossiblePhoneNumber, maxLength, parseDuration, required, toCents, toTitleCase, upperFirst, useDomainContext, useFormModal, useModal, usePrevious, useTicketingSdkContext, withTicketingSdk };
//# sourceMappingURL=index.js.map
